/* tslint:disable */
/* eslint-disable */
/**
 * Aevo REST API
 * Aevo
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ken@ribbon.finance
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Account type. Eg. `STANDARD`
 * @export
 * @enum {string}
 */

export const AccountTypeResponse = {
    Standard: 'STANDARD',
    MarketMaker: 'MARKET_MAKER',
    ManagedAccount: 'MANAGED_ACCOUNT'
} as const;

export type AccountTypeResponse = typeof AccountTypeResponse[keyof typeof AccountTypeResponse];


/**
 * ADL rank of an account Eg. `low`
 * @export
 * @enum {string}
 */

export const AdlRankResponse = {
    Na: 'na',
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;

export type AdlRankResponse = typeof AdlRankResponse[keyof typeof AdlRankResponse];


/**
 * Status of the RFQ block Eg. `<nil>`
 * @export
 * @enum {string}
 */

export const BlockStatusResponse = {
    Open: 'open',
    Closed: 'closed'
} as const;

export type BlockStatusResponse = typeof BlockStatusResponse[keyof typeof BlockStatusResponse];


/**
 * Name of the collateral asset.
 * @export
 * @enum {string}
 */

export const CollateralAsset = {
    Usdc: 'USDC',
    Usdt: 'USDT',
    Weth: 'WETH',
    Wbtc: 'WBTC',
    AeUsd: 'aeUSD',
    Sdai: 'SDAI',
    WeEth: 'weETH'
} as const;

export type CollateralAsset = typeof CollateralAsset[keyof typeof CollateralAsset];


/**
 * Name of the collateral asset. Eg. `USDT`
 * @export
 * @enum {string}
 */

export const CollateralAssetResponse = {
    Usdc: 'USDC',
    Usdt: 'USDT',
    Weth: 'WETH',
    Wbtc: 'WBTC',
    AeUsd: 'aeUSD',
    Sdai: 'SDAI',
    WeEth: 'weETH'
} as const;

export type CollateralAssetResponse = typeof CollateralAssetResponse[keyof typeof CollateralAssetResponse];


/**
 * 
 * @export
 * @interface DeleteApiKey200Response
 */
export interface DeleteApiKey200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof DeleteApiKey200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface DeleteApiKeyPayload
 */
export interface DeleteApiKeyPayload {
    /**
     * Account\'s API Key.
     * @type {string}
     * @memberof DeleteApiKeyPayload
     */
    'api_key': string;
}
/**
 * 
 * @export
 * @interface DeleteOrdersAll200Response
 */
export interface DeleteOrdersAll200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof DeleteOrdersAll200Response
     */
    'success': boolean;
    /**
     * Order ID is the hash of the order payload
     * @type {Array<string>}
     * @memberof DeleteOrdersAll200Response
     */
    'order_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteOrdersAllPayload
 */
export interface DeleteOrdersAllPayload {
    /**
     * Name of underlying asset.
     * @type {string}
     * @memberof DeleteOrdersAllPayload
     */
    'asset'?: string;
    /**
     * 
     * @type {InstrumentType}
     * @memberof DeleteOrdersAllPayload
     */
    'instrument_type'?: InstrumentType;
}
/**
 * 
 * @export
 * @interface DeleteOrdersOrderId200Response
 */
export interface DeleteOrdersOrderId200Response {
    /**
     * Order ID is the hash of the order payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof DeleteOrdersOrderId200Response
     */
    'order_id': string;
}
/**
 * 
 * @export
 * @interface DeleteQuotes200Response
 */
export interface DeleteQuotes200Response {
    /**
     * Quote ID is the hash of the quote payload
     * @type {Array<string>}
     * @memberof DeleteQuotes200Response
     */
    'cancelled'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteQuotesQuoteId200Response
 */
export interface DeleteQuotesQuoteId200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof DeleteQuotesQuoteId200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface DeleteRfqs200Response
 */
export interface DeleteRfqs200Response {
    /**
     * Block ID is the unique identifier of the block
     * @type {Array<string>}
     * @memberof DeleteRfqs200Response
     */
    'cancelled'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteRfqsBlockId200Response
 */
export interface DeleteRfqsBlockId200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof DeleteRfqsBlockId200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface DeleteSigningKey200Response
 */
export interface DeleteSigningKey200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof DeleteSigningKey200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface DeleteSigningKeyPayload
 */
export interface DeleteSigningKeyPayload {
    /**
     * Ethereum address of the signing key.
     * @type {string}
     * @memberof DeleteSigningKeyPayload
     */
    'signing_key': string;
}
/**
 * Exchange status. Eg. ``
 * @export
 * @enum {string}
 */

export const ExchangeStatusResponse = {
    Live: 'Live',
    Maintenance: 'Maintenance'
} as const;

export type ExchangeStatusResponse = typeof ExchangeStatusResponse[keyof typeof ExchangeStatusResponse];


/**
 * 
 * @export
 * @interface GenericErrorResponse
 */
export interface GenericErrorResponse {
    /**
     * Error message. Eg. `RATE_LIMIT_EXCEEDED`
     * @type {string}
     * @memberof GenericErrorResponse
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface GenericErrorResponse1
 */
export interface GenericErrorResponse1 {
    /**
     * Error message. Eg. `INTERNAL_ERROR`
     * @type {string}
     * @memberof GenericErrorResponse1
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface GenericErrorResponse2
 */
export interface GenericErrorResponse2 {
    /**
     * Error message. Eg. `ERR_MALFORMED_REQUEST`
     * @type {string}
     * @memberof GenericErrorResponse2
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface GenericErrorResponse3
 */
export interface GenericErrorResponse3 {
    /**
     * Error message. Eg. `UNAUTHORIZED`
     * @type {string}
     * @memberof GenericErrorResponse3
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface GetAccount200Response
 */
export interface GetAccount200Response {
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetAccount200Response
     */
    'account': string;
    /**
     * Account\'s auto-generated username based on their Ethereum address. Eg. `officially-evolved-terrier`
     * @type {string}
     * @memberof GetAccount200Response
     */
    'username': string;
    /**
     * Account\'s equity. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200Response
     */
    'equity': string;
    /**
     * Available balance. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200Response
     */
    'available_balance': string;
    /**
     * Available margin. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200Response
     */
    'available_margin': string;
    /**
     * Balance. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200Response
     */
    'balance': string;
    /**
     * 
     * @type {Array<PostRegister200ResponseSigningKeysInner>}
     * @memberof GetAccount200Response
     */
    'signing_keys'?: Array<PostRegister200ResponseSigningKeysInner>;
    /**
     * 
     * @type {Array<GetAccount200ResponseCollateralsInner>}
     * @memberof GetAccount200Response
     */
    'collaterals'?: Array<GetAccount200ResponseCollateralsInner>;
    /**
     * 
     * @type {Array<GetAccount200ResponseApiKeysInner>}
     * @memberof GetAccount200Response
     */
    'api_keys'?: Array<GetAccount200ResponseApiKeysInner>;
    /**
     * 
     * @type {Array<GetAccount200ResponsePositionsInner>}
     * @memberof GetAccount200Response
     */
    'positions'?: Array<GetAccount200ResponsePositionsInner>;
    /**
     * 
     * @type {AccountTypeResponse}
     * @memberof GetAccount200Response
     */
    'account_type': AccountTypeResponse;
    /**
     * 
     * @type {Array<GetAccount200ResponseFeeStructuresInner>}
     * @memberof GetAccount200Response
     */
    'fee_structures'?: Array<GetAccount200ResponseFeeStructuresInner>;
    /**
     * Array of campaigns that account has signed up for. Eg. `[campaign_1 campaign_2]`
     * @type {Array<string>}
     * @memberof GetAccount200Response
     */
    'campaign_sign_ups': Array<string>;
    /**
     * Portfolio margin. Eg. `false`
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'portfolio': boolean;
    /**
     * True if an account is in liquidation mode. Eg. `false`
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'in_liquidation': boolean;
    /**
     * Margin required to keep an open order. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200Response
     */
    'initial_margin': string;
    /**
     * Maintenance margin. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200Response
     */
    'maintenance_margin': string;
    /**
     * Email address of an account. Eg. `timothy@ribbon.finance`
     * @type {string}
     * @memberof GetAccount200Response
     */
    'email_address': string;
    /**
     * Intercom hash used to verify user identity for intercom messages Eg. `nwiaenainhiw`
     * @type {string}
     * @memberof GetAccount200Response
     */
    'intercom_hash': string;
    /**
     * Credits in USDC Eg. `100.00`
     * @type {string}
     * @memberof GetAccount200Response
     */
    'credit': string;
    /**
     * Whether account has been credited using the automatic credit system Eg. `true`
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'credited': boolean;
    /**
     * Whether account has been referred by another account Eg. `true`
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'has_been_referred': boolean;
    /**
     * Referrer of a referee Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetAccount200Response
     */
    'referrer': string;
    /**
     * 
     * @type {Array<GetAccount200ResponseLeveragesInner>}
     * @memberof GetAccount200Response
     */
    'leverages'?: Array<GetAccount200ResponseLeveragesInner>;
    /**
     * 
     * @type {Array<GetAccount200ResponseInAdlInner>}
     * @memberof GetAccount200Response
     */
    'in_adl'?: Array<GetAccount200ResponseInAdlInner>;
    /**
     * Manual withdrawal flag Eg. `false`
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'manual_mode': boolean;
    /**
     * 
     * @type {Array<GetAccount200ResponseManualWithdrawalsInner>}
     * @memberof GetAccount200Response
     */
    'manual_withdrawals'?: Array<GetAccount200ResponseManualWithdrawalsInner>;
    /**
     * 
     * @type {Array<GetAccount200ResponseNetworkAddressesInner>}
     * @memberof GetAccount200Response
     */
    'network_addresses'?: Array<GetAccount200ResponseNetworkAddressesInner>;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponseApiKeysInner
 */
export interface GetAccount200ResponseApiKeysInner {
    /**
     * name Eg. `5732cc1f14e842f393e8cdecb49f02fa`
     * @type {string}
     * @memberof GetAccount200ResponseApiKeysInner
     */
    'name'?: string;
    /**
     * Account\'s API Key. Eg. `URPtt6eNCXgL8ERuchphUretdaga2smF`
     * @type {string}
     * @memberof GetAccount200ResponseApiKeysInner
     */
    'api_key': string;
    /**
     * Whitelisted client\'s IP address for API access. Eg. `[1.1.1.1 2.2.2.2]`
     * @type {Array<string>}
     * @memberof GetAccount200ResponseApiKeysInner
     */
    'ip_addresses'?: Array<string>;
    /**
     * API can only access read-only endpoints if true. Eg. `true`
     * @type {boolean}
     * @memberof GetAccount200ResponseApiKeysInner
     */
    'read_only': boolean;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetAccount200ResponseApiKeysInner
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponseCollateralsInner
 */
export interface GetAccount200ResponseCollateralsInner {
    /**
     * 
     * @type {CollateralAssetResponse}
     * @memberof GetAccount200ResponseCollateralsInner
     */
    'collateral_asset': CollateralAssetResponse;
    /**
     * Value of the collateral in USD Eg. `10423`
     * @type {string}
     * @memberof GetAccount200ResponseCollateralsInner
     */
    'collateral_value': string;
    /**
     * Balance. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200ResponseCollateralsInner
     */
    'balance': string;
    /**
     * Available balance. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200ResponseCollateralsInner
     */
    'available_balance': string;
    /**
     * If collateral asset is yield bearing Eg. `false`
     * @type {boolean}
     * @memberof GetAccount200ResponseCollateralsInner
     */
    'collateral_yield_bearing': boolean;
    /**
     * Pending withdrawals for a yield vault or strategy Eg. `12`
     * @type {string}
     * @memberof GetAccount200ResponseCollateralsInner
     */
    'pending_withdrawals': string;
    /**
     * Unrealized PNL. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200ResponseCollateralsInner
     */
    'unrealized_pnl': string;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponseFeeStructuresInner
 */
export interface GetAccount200ResponseFeeStructuresInner {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetAccount200ResponseFeeStructuresInner
     */
    'asset': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetAccount200ResponseFeeStructuresInner
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * Account\'s taker fee structure Eg. `0.0005`
     * @type {string}
     * @memberof GetAccount200ResponseFeeStructuresInner
     */
    'taker_fee': string;
    /**
     * Account\'s maker fee structure Eg. `0.0003`
     * @type {string}
     * @memberof GetAccount200ResponseFeeStructuresInner
     */
    'maker_fee': string;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponseInAdlInner
 */
export interface GetAccount200ResponseInAdlInner {
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetAccount200ResponseInAdlInner
     */
    'instrument_name': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetAccount200ResponseInAdlInner
     */
    'instrument_id': string;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponseLeveragesInner
 */
export interface GetAccount200ResponseLeveragesInner {
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetAccount200ResponseLeveragesInner
     */
    'instrument_id': string;
    /**
     * The leverage of the position, will be shown if the position is isolated. Eg. `3.5`
     * @type {string}
     * @memberof GetAccount200ResponseLeveragesInner
     */
    'leverage': string;
    /**
     * 
     * @type {MarginTypeResponse}
     * @memberof GetAccount200ResponseLeveragesInner
     */
    'margin_type': MarginTypeResponse;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponseManualWithdrawalsInner
 */
export interface GetAccount200ResponseManualWithdrawalsInner {
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetAccount200ResponseManualWithdrawalsInner
     */
    'account': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetAccount200ResponseManualWithdrawalsInner
     */
    'amount': string;
    /**
     * The specified chain ID. Eg. `10`
     * @type {string}
     * @memberof GetAccount200ResponseManualWithdrawalsInner
     */
    'chain_id': string;
    /**
     * Ethereum address of the collateral asset. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetAccount200ResponseManualWithdrawalsInner
     */
    'collateral': string;
    /**
     * Unique ID of the withdrawal Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetAccount200ResponseManualWithdrawalsInner
     */
    'withdrawal_id': string;
    /**
     * Ethereum address to send withdrawals to. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetAccount200ResponseManualWithdrawalsInner
     */
    'to': string;
    /**
     * Transfer label. Eg. `Rewards`
     * @type {string}
     * @memberof GetAccount200ResponseManualWithdrawalsInner
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponseNetworkAddressesInner
 */
export interface GetAccount200ResponseNetworkAddressesInner {
    /**
     * 
     * @type {NetworkResponse}
     * @memberof GetAccount200ResponseNetworkAddressesInner
     */
    'network': NetworkResponse;
    /**
     * Account\'s non-eth network address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetAccount200ResponseNetworkAddressesInner
     */
    'network_address': string;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponsePositionsInner
 */
export interface GetAccount200ResponsePositionsInner {
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {GetAccount200ResponsePositionsInnerOption}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'option'?: GetAccount200ResponsePositionsInnerOption;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'iv'?: string;
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'asset': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'amount': string;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'side': SideResponse;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'mark_price': string;
    /**
     * Average entry price. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'avg_entry_price': string;
    /**
     * Unrealized PNL. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'unrealized_pnl': string;
    /**
     * Maintenance margin. Eg. `12.23`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'maintenance_margin': string;
    /**
     * 
     * @type {MarginTypeResponse}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'margin_type'?: MarginTypeResponse;
    /**
     * Liquidation price of the order/position. Eg. `1288.23`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'liquidation_price'?: string;
    /**
     * The change in isolated margin assigned to a position. In 6 decimals fixed number. Negative allowed. Eg. `10000000`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'isolated_margin'?: string;
    /**
     * The leverage of the position, will be shown if the position is isolated. Eg. `3.5`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'leverage'?: string;
    /**
     * 
     * @type {AdlRankResponse}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'adl_rank': AdlRankResponse;
    /**
     * 
     * @type {GetAccount200ResponsePositionsInnerClosePositionTriggers}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'closePositionTriggers'?: GetAccount200ResponsePositionsInnerClosePositionTriggers;
    /**
     * 
     * @type {GetAccount200ResponsePositionsInnerPartialPositionTriggers}
     * @memberof GetAccount200ResponsePositionsInner
     */
    'partialPositionTriggers'?: GetAccount200ResponsePositionsInnerPartialPositionTriggers;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponsePositionsInnerClosePositionTriggers
 */
export interface GetAccount200ResponsePositionsInnerClosePositionTriggers {
    /**
     * 
     * @type {GetAccount200ResponsePositionsInnerClosePositionTriggersTakeProfit}
     * @memberof GetAccount200ResponsePositionsInnerClosePositionTriggers
     */
    'take_profit'?: GetAccount200ResponsePositionsInnerClosePositionTriggersTakeProfit;
    /**
     * 
     * @type {GetAccount200ResponsePositionsInnerClosePositionTriggersTakeProfit}
     * @memberof GetAccount200ResponsePositionsInnerClosePositionTriggers
     */
    'stop_loss'?: GetAccount200ResponsePositionsInnerClosePositionTriggersTakeProfit;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponsePositionsInnerClosePositionTriggersTakeProfit
 */
export interface GetAccount200ResponsePositionsInnerClosePositionTriggersTakeProfit {
    /**
     * Order ID is the hash of the order payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerClosePositionTriggersTakeProfit
     */
    'order_id': string;
    /**
     * The price to trigger the stop order at. `stop` is required when `trigger` is specified. Eg. `1836.74`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerClosePositionTriggersTakeProfit
     */
    'trigger': string;
    /**
     * 
     * @type {OrderTypeResponse}
     * @memberof GetAccount200ResponsePositionsInnerClosePositionTriggersTakeProfit
     */
    'order_type': OrderTypeResponse;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponsePositionsInnerOption
 */
export interface GetAccount200ResponsePositionsInnerOption {
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerOption
     */
    'strike': string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetAccount200ResponsePositionsInnerOption
     */
    'option_type': OptionTypeResponse;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerOption
     */
    'expiry': string;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerOption
     */
    'iv': string;
    /**
     * Option\'s Delta. Eg. `0.23`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerOption
     */
    'delta': string;
    /**
     * Option\'s Theta. Eg. `0.23`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerOption
     */
    'theta': string;
    /**
     * Option\'s Vega. Eg. `0.23`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerOption
     */
    'vega': string;
    /**
     * Option\'s Rho. Eg. `0.23`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerOption
     */
    'rho': string;
    /**
     * Option\'s Gamma. Eg. `0.23`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerOption
     */
    'gamma': string;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponsePositionsInnerPartialPositionTriggers
 */
export interface GetAccount200ResponsePositionsInnerPartialPositionTriggers {
    /**
     * 
     * @type {Array<GetAccount200ResponsePositionsInnerPartialPositionTriggersTakeProfitInner>}
     * @memberof GetAccount200ResponsePositionsInnerPartialPositionTriggers
     */
    'take_profit'?: Array<GetAccount200ResponsePositionsInnerPartialPositionTriggersTakeProfitInner>;
    /**
     * 
     * @type {Array<GetAccount200ResponsePositionsInnerPartialPositionTriggersTakeProfitInner>}
     * @memberof GetAccount200ResponsePositionsInnerPartialPositionTriggers
     */
    'stop_loss'?: Array<GetAccount200ResponsePositionsInnerPartialPositionTriggersTakeProfitInner>;
}
/**
 * 
 * @export
 * @interface GetAccount200ResponsePositionsInnerPartialPositionTriggersTakeProfitInner
 */
export interface GetAccount200ResponsePositionsInnerPartialPositionTriggersTakeProfitInner {
    /**
     * Order ID is the hash of the order payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerPartialPositionTriggersTakeProfitInner
     */
    'order_id': string;
    /**
     * The price to trigger the stop order at. `stop` is required when `trigger` is specified. Eg. `1836.74`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerPartialPositionTriggersTakeProfitInner
     */
    'trigger': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerPartialPositionTriggersTakeProfitInner
     */
    'amount': string;
    /**
     * Order limit price. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetAccount200ResponsePositionsInnerPartialPositionTriggersTakeProfitInner
     */
    'limit_price': string;
    /**
     * 
     * @type {OrderTypeResponse}
     * @memberof GetAccount200ResponsePositionsInnerPartialPositionTriggersTakeProfitInner
     */
    'order_type': OrderTypeResponse;
    /**
     * 
     * @type {StopResponse}
     * @memberof GetAccount200ResponsePositionsInnerPartialPositionTriggersTakeProfitInner
     */
    'stop': StopResponse;
}
/**
 * 
 * @export
 * @interface GetAccountAccumulatedFundings200Response
 */
export interface GetAccountAccumulatedFundings200Response {
    /**
     * 
     * @type {Array<GetAccountAccumulatedFundings200ResponseAccumulatedFundingsInner>}
     * @memberof GetAccountAccumulatedFundings200Response
     */
    'accumulated_fundings'?: Array<GetAccountAccumulatedFundings200ResponseAccumulatedFundingsInner>;
}
/**
 * 
 * @export
 * @interface GetAccountAccumulatedFundings200ResponseAccumulatedFundingsInner
 */
export interface GetAccountAccumulatedFundings200ResponseAccumulatedFundingsInner {
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetAccountAccumulatedFundings200ResponseAccumulatedFundingsInner
     */
    'instrument_id': string;
    /**
     * Accumulated funding for an account\'s perp position. Eg. `0.00005`
     * @type {string}
     * @memberof GetAccountAccumulatedFundings200ResponseAccumulatedFundingsInner
     */
    'accumulated_funding'?: string;
}
/**
 * 
 * @export
 * @interface GetAccountCancelOnDisconnect200Response
 */
export interface GetAccountCancelOnDisconnect200Response {
    /**
     * Enabled if true. Eg. `true`
     * @type {boolean}
     * @memberof GetAccountCancelOnDisconnect200Response
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface GetAccountEmailAddress200Response
 */
export interface GetAccountEmailAddress200Response {
    /**
     * Email address of an account. Eg. `timothy@ribbon.finance`
     * @type {string}
     * @memberof GetAccountEmailAddress200Response
     */
    'email_address': string;
    /**
     * Whether send a verification email after user sets email address. Eg. `false`
     * @type {boolean}
     * @memberof GetAccountEmailAddress200Response
     */
    'send_email_verification'?: boolean;
}
/**
 * 
 * @export
 * @interface GetAccountEmailPreferences200Response
 */
export interface GetAccountEmailPreferences200Response {
    /**
     * A user\'s email preferences Eg. ``
     * @type {string}
     * @memberof GetAccountEmailPreferences200Response
     */
    'email_preferences': string;
}
/**
 * 
 * @export
 * @interface GetAccountEmailVerified200Response
 */
export interface GetAccountEmailVerified200Response {
    /**
     * Whether account email is verified. Eg. `false`
     * @type {boolean}
     * @memberof GetAccountEmailVerified200Response
     */
    'email_verified': boolean;
}
/**
 * 
 * @export
 * @interface GetAccountStats200Response
 */
export interface GetAccountStats200Response {
    /**
     * 
     * @type {GetLeaderboard200ResponseLeaderboard}
     * @memberof GetAccountStats200Response
     */
    'account_statistics'?: GetLeaderboard200ResponseLeaderboard;
}
/**
 * 
 * @export
 * @interface GetAirdropIncentivizedAssets200Response
 */
export interface GetAirdropIncentivizedAssets200Response {
    /**
     * 
     * @type {Array<GetAirdropIncentivizedAssets200ResponseAirdropIncentivizedAssetsInner>}
     * @memberof GetAirdropIncentivizedAssets200Response
     */
    'airdrop_incentivized_assets'?: Array<GetAirdropIncentivizedAssets200ResponseAirdropIncentivizedAssetsInner>;
}
/**
 * 
 * @export
 * @interface GetAirdropIncentivizedAssets200ResponseAirdropIncentivizedAssetsInner
 */
export interface GetAirdropIncentivizedAssets200ResponseAirdropIncentivizedAssetsInner {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetAirdropIncentivizedAssets200ResponseAirdropIncentivizedAssetsInner
     */
    'asset': string;
    /**
     * If prelaunch asset is incentivized Eg. `false`
     * @type {boolean}
     * @memberof GetAirdropIncentivizedAssets200ResponseAirdropIncentivizedAssetsInner
     */
    'is_incentivized': boolean;
}
/**
 * 
 * @export
 * @interface GetApiKey200Response
 */
export interface GetApiKey200Response {
    /**
     * name Eg. `5732cc1f14e842f393e8cdecb49f02fa`
     * @type {string}
     * @memberof GetApiKey200Response
     */
    'name'?: string;
    /**
     * Account\'s API Key. Eg. `URPtt6eNCXgL8ERuchphUretdaga2smF`
     * @type {string}
     * @memberof GetApiKey200Response
     */
    'api_key': string;
    /**
     * Client\'s API Secret Eg. `0140af7046a63530fc4bd319823d6eee98086ef0d446584b42f68b640b60c457`
     * @type {string}
     * @memberof GetApiKey200Response
     */
    'api_secret': string;
    /**
     * Whitelisted client\'s IP address for API access. Eg. `[1.1.1.1 2.2.2.2]`
     * @type {Array<string>}
     * @memberof GetApiKey200Response
     */
    'ip_addresses'?: Array<string>;
    /**
     * API can only access read-only endpoints if true. Eg. `true`
     * @type {boolean}
     * @memberof GetApiKey200Response
     */
    'read_only': boolean;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetApiKey200Response
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetAuth200Response
 */
export interface GetAuth200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof GetAuth200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface GetBalanceHistory200Response
 */
export interface GetBalanceHistory200Response {
    /**
     * List of [timestamp, price]. Timestamp is in UNIX nanoseconds.
     * @type {Array<Array<string>>}
     * @memberof GetBalanceHistory200Response
     */
    'history'?: Array<Array<string>>;
}
/**
 * 
 * @export
 * @interface GetBlockHistory200Response
 */
export interface GetBlockHistory200Response {
    /**
     * total number of rows in a query Eg. `5`
     * @type {string}
     * @memberof GetBlockHistory200Response
     */
    'count': string;
    /**
     * 
     * @type {Array<GetBlockHistory200ResponseBlockHistoryInner>}
     * @memberof GetBlockHistory200Response
     */
    'block_history'?: Array<GetBlockHistory200ResponseBlockHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetBlockHistory200ResponseBlockHistoryInner
 */
export interface GetBlockHistory200ResponseBlockHistoryInner {
    /**
     * Block ID is the unique identifier of the block Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetBlockHistory200ResponseBlockHistoryInner
     */
    'block_id': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetBlockHistory200ResponseBlockHistoryInner
     */
    'account': string;
    /**
     * Duration of the RFQ block in seconds Eg. `30`
     * @type {string}
     * @memberof GetBlockHistory200ResponseBlockHistoryInner
     */
    'duration': string;
    /**
     * Deadline of the RFQ block in UNIX timestamp in nanoseconds Eg. `<nil>`
     * @type {string}
     * @memberof GetBlockHistory200ResponseBlockHistoryInner
     */
    'deadline': string;
    /**
     * 
     * @type {BlockStatusResponse}
     * @memberof GetBlockHistory200ResponseBlockHistoryInner
     */
    'block_status': BlockStatusResponse;
    /**
     * Updated timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetBlockHistory200ResponseBlockHistoryInner
     */
    'updated_timestamp': string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetBlockHistory200ResponseBlockHistoryInner
     */
    'created_timestamp': string;
    /**
     * 
     * @type {Array<GetBlockHistory200ResponseBlockHistoryInnerLegsInner>}
     * @memberof GetBlockHistory200ResponseBlockHistoryInner
     */
    'legs'?: Array<GetBlockHistory200ResponseBlockHistoryInnerLegsInner>;
}
/**
 * 
 * @export
 * @interface GetBlockHistory200ResponseBlockHistoryInnerLegsInner
 */
export interface GetBlockHistory200ResponseBlockHistoryInnerLegsInner {
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetBlockHistory200ResponseBlockHistoryInnerLegsInner
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetBlockHistory200ResponseBlockHistoryInnerLegsInner
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetBlockHistory200ResponseBlockHistoryInnerLegsInner
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetBlockHistory200ResponseBlockHistoryInnerLegsInner
     */
    'side': SideResponse;
    /**
     * Ratio of the instrument leg in decimals. Eg. `1`
     * @type {string}
     * @memberof GetBlockHistory200ResponseBlockHistoryInnerLegsInner
     */
    'ratio': string;
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetBlockHistory200ResponseBlockHistoryInnerLegsInner
     */
    'asset': string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetBlockHistory200ResponseBlockHistoryInnerLegsInner
     */
    'expiry'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetBlockHistory200ResponseBlockHistoryInnerLegsInner
     */
    'strike'?: string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetBlockHistory200ResponseBlockHistoryInnerLegsInner
     */
    'option_type'?: OptionTypeResponse;
}
/**
 * 
 * @export
 * @interface GetBlockTradeHistory200Response
 */
export interface GetBlockTradeHistory200Response {
    /**
     * total number of rows in a query Eg. `5`
     * @type {string}
     * @memberof GetBlockTradeHistory200Response
     */
    'count': string;
    /**
     * 
     * @type {Array<GetBlockTradeHistory200ResponseBlockHistoryInner>}
     * @memberof GetBlockTradeHistory200Response
     */
    'block_history'?: Array<GetBlockTradeHistory200ResponseBlockHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetBlockTradeHistory200ResponseBlockHistoryInner
 */
export interface GetBlockTradeHistory200ResponseBlockHistoryInner {
    /**
     * Unique ID of the block trade. Eg. `DwmDn5XnEyiqx5AB5CM4W8bgD137ASX4Lz1XWBYqvpX2`
     * @type {string}
     * @memberof GetBlockTradeHistory200ResponseBlockHistoryInner
     */
    'block_trade_id': string;
    /**
     * Block ID is the unique identifier of the block Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetBlockTradeHistory200ResponseBlockHistoryInner
     */
    'block_id': string;
    /**
     * Quote ID of the aggressor Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetBlockTradeHistory200ResponseBlockHistoryInner
     */
    'aggressing_quote_id': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetBlockTradeHistory200ResponseBlockHistoryInner
     */
    'account': string;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetBlockTradeHistory200ResponseBlockHistoryInner
     */
    'side': SideResponse;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetBlockTradeHistory200ResponseBlockHistoryInner
     */
    'amount': string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetBlockTradeHistory200ResponseBlockHistoryInner
     */
    'price': string;
    /**
     * Fees paid for the trade. Eg. `12.23`
     * @type {string}
     * @memberof GetBlockTradeHistory200ResponseBlockHistoryInner
     */
    'fees': string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetBlockTradeHistory200ResponseBlockHistoryInner
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetCheckReferral200Response
 */
export interface GetCheckReferral200Response {
    /**
     * Whether or not the user can be referred by a specific referral-code Eg. `true`
     * @type {boolean}
     * @memberof GetCheckReferral200Response
     */
    'is_referrable': boolean;
    /**
     * Total percentage discount for being referred by this referrer Eg. `0.1`
     * @type {string}
     * @memberof GetCheckReferral200Response
     */
    'referee_discount': string;
    /**
     * Error code string of why user cannot be referred by a specific referral-code Eg. `User has already been referred`
     * @type {string}
     * @memberof GetCheckReferral200Response
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface GetCheckRestricted200Response
 */
export interface GetCheckRestricted200Response {
    /**
     * Whether or not the ip has restricted access Eg. `true`
     * @type {boolean}
     * @memberof GetCheckRestricted200Response
     */
    'restricted': boolean;
    /**
     * Name of the country Eg. `United States of America`
     * @type {string}
     * @memberof GetCheckRestricted200Response
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface GetCoingeckoStatistics200Response
 */
export interface GetCoingeckoStatistics200Response {
    /**
     * Identifier of a ticker with delimiter to separate base/target, eg. BTC-PERP Eg. `ETH-PERP`
     * @type {string}
     * @memberof GetCoingeckoStatistics200Response
     */
    'ticker_id': string;
    /**
     * Symbol/currency code of base pair Eg. `BTC`
     * @type {string}
     * @memberof GetCoingeckoStatistics200Response
     */
    'base_currency'?: string;
    /**
     * Symbol/currency code of target pair Eg. `ETH`
     * @type {string}
     * @memberof GetCoingeckoStatistics200Response
     */
    'target_currency'?: string;
    /**
     * 24 hour trading volume in target pair volume Eg. `0`
     * @type {string}
     * @memberof GetCoingeckoStatistics200Response
     */
    'target_volume'?: string;
    /**
     * Type of product: Futures, Perpetual, Options Eg. `Perpetual`
     * @type {string}
     * @memberof GetCoingeckoStatistics200Response
     */
    'product_volume'?: string;
    /**
     * Open interest in USDC terms for a given expiry. Eg. `1234.56`
     * @type {string}
     * @memberof GetCoingeckoStatistics200Response
     */
    'open_interest'?: string;
    /**
     * Current index price of the asset. Eg. `12.23`
     * @type {string}
     * @memberof GetCoingeckoStatistics200Response
     */
    'index_price'?: string;
    /**
     * Underlying currency for index Eg. `USD`
     * @type {string}
     * @memberof GetCoingeckoStatistics200Response
     */
    'index_currency'?: string;
    /**
     * Timestamp of the next funding rate change Eg. `USD`
     * @type {string}
     * @memberof GetCoingeckoStatistics200Response
     */
    'next_funding_rate_timestamp'?: string;
    /**
     * Funding rate in decimals. Eg. `0.00122`
     * @type {string}
     * @memberof GetCoingeckoStatistics200Response
     */
    'funding_rate'?: string;
    /**
     * Type of contract - Vanilla, Inverse or Quanto Eg. `Vanilla`
     * @type {string}
     * @memberof GetCoingeckoStatistics200Response
     */
    'contract_type'?: string;
    /**
     * Describes the currency which the contract is priced in. Eg. `USD`
     * @type {string}
     * @memberof GetCoingeckoStatistics200Response
     */
    'contract_price_currency'?: string;
}
/**
 * 
 * @export
 * @interface GetEmissions200Response
 */
export interface GetEmissions200Response {
    /**
     * Farming emission of $AEVO in an epoch, in $AEVO terms Eg. `569.2`
     * @type {string}
     * @memberof GetEmissions200Response
     */
    'farming_emission': string;
    /**
     * Staking emission of $AEVO in an epoch, in $AEVO terms Eg. `593.4`
     * @type {string}
     * @memberof GetEmissions200Response
     */
    'staking_emission': string;
    /**
     * Total boosted trading notional volume in an epoch, in USD terms. Eg. `123`
     * @type {string}
     * @memberof GetEmissions200Response
     */
    'total_boosted_volume': string;
}
/**
 * 
 * @export
 * @interface GetFarmBoost200Response
 */
export interface GetFarmBoost200Response {
    /**
     * Farming boost Eg. `12.23`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'farm_boost': string;
    /**
     * Farming boost average Eg. `12.23`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'farm_boost_avg': string;
    /**
     * Timestamp of last rare farm boost Eg. `12.23`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'last_rare_farm_boost': string;
    /**
     * Trading notional volume in USD terms for current epoch. Eg. `1234.56`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'epoch_volume': string;
    /**
     * Boosted trading notional volume in USD terms for current epoch. Eg. `1234.56`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'epoch_boosted_volume': string;
    /**
     * Boosted trading notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'boosted_volume': string;
    /**
     * Trailing volume in past x days in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'trailing_volume': string;
    /**
     * Aevo earned from previous epochs Eg. `1234.56`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'prev_epoch_aevo_earned': string;
    /**
     * Aevo earned from current epoch (may change) Eg. `1234.56`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'curr_epoch_aevo_earned': string;
    /**
     * If user has sAEVO Eg. `true`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'staked': string;
    /**
     * airdropped farm boost level (from 1 to 5) Eg. `4`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'airdropped_farm_boost_level': string;
    /**
     * Eligible for a random farm boost (only if airdropped farm boost or referee) Eg. `true`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'random_farm_boost_eligible': string;
    /**
     * User\'s staked sAEVO amount Eg. `1`
     * @type {string}
     * @memberof GetFarmBoost200Response
     */
    'staked_amount': string;
    /**
     * 
     * @type {Array<GetFarmBoost200ResponseAevoEarnedPerEpochInner>}
     * @memberof GetFarmBoost200Response
     */
    'aevo_earned_per_epoch'?: Array<GetFarmBoost200ResponseAevoEarnedPerEpochInner>;
    /**
     * 
     * @type {Array<GetFarmBoost200ResponseAccountPrelaunchVolumesInner>}
     * @memberof GetFarmBoost200Response
     */
    'account_prelaunch_volumes'?: Array<GetFarmBoost200ResponseAccountPrelaunchVolumesInner>;
    /**
     * 
     * @type {Array<GetFarmBoost200ResponseAccountPrelaunchVolumesInner>}
     * @memberof GetFarmBoost200Response
     */
    'prelaunch_volumes'?: Array<GetFarmBoost200ResponseAccountPrelaunchVolumesInner>;
}
/**
 * 
 * @export
 * @interface GetFarmBoost200ResponseAccountPrelaunchVolumesInner
 */
export interface GetFarmBoost200ResponseAccountPrelaunchVolumesInner {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetFarmBoost200ResponseAccountPrelaunchVolumesInner
     */
    'asset': string;
    /**
     * Volume in USDC terms. Eg. `12.23`
     * @type {string}
     * @memberof GetFarmBoost200ResponseAccountPrelaunchVolumesInner
     */
    'volume': string;
}
/**
 * 
 * @export
 * @interface GetFarmBoost200ResponseAevoEarnedPerEpochInner
 */
export interface GetFarmBoost200ResponseAevoEarnedPerEpochInner {
    /**
     * Epoch Eg. `1`
     * @type {string}
     * @memberof GetFarmBoost200ResponseAevoEarnedPerEpochInner
     */
    'epoch': string;
    /**
     * Aevo Earned at an epoch Eg. `10`
     * @type {string}
     * @memberof GetFarmBoost200ResponseAevoEarnedPerEpochInner
     */
    'aevo_earned': string;
}
/**
 * 
 * @export
 * @interface GetFunding200Response
 */
export interface GetFunding200Response {
    /**
     * Funding rate in decimals. Eg. `0.00122`
     * @type {string}
     * @memberof GetFunding200Response
     */
    'funding_rate': string;
    /**
     * Next epoch in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetFunding200Response
     */
    'next_epoch': string;
}
/**
 * 
 * @export
 * @interface GetFundingHistory200Response
 */
export interface GetFundingHistory200Response {
    /**
     * List of [instrument name, timestamp, funding rate, mark price]. Timestamp is in UNIX nanoseconds. Funding rate is in decimals.
     * @type {Array<Array<string>>}
     * @memberof GetFundingHistory200Response
     */
    'funding_history'?: Array<Array<string>>;
}
/**
 * 
 * @export
 * @interface GetIndex200Response
 */
export interface GetIndex200Response {
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetIndex200Response
     */
    'price': string;
    /**
     * Timestamp in UNIX in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetIndex200Response
     */
    'timestamp': string;
}
/**
 * 
 * @export
 * @interface GetIndexHistories200Response
 */
export interface GetIndexHistories200Response {
    /**
     * 
     * @type {Array<GetIndexHistories200ResponseAssetsHistoryInner>}
     * @memberof GetIndexHistories200Response
     */
    'assets_history'?: Array<GetIndexHistories200ResponseAssetsHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetIndexHistories200ResponseAssetsHistoryInner
 */
export interface GetIndexHistories200ResponseAssetsHistoryInner {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetIndexHistories200ResponseAssetsHistoryInner
     */
    'asset': string;
    /**
     * List of [timestamp, price]. Timestamp is in UNIX nanoseconds.
     * @type {Array<Array<string>>}
     * @memberof GetIndexHistories200ResponseAssetsHistoryInner
     */
    'history'?: Array<Array<string>>;
}
/**
 * 
 * @export
 * @interface GetIndexHistory200Response
 */
export interface GetIndexHistory200Response {
    /**
     * List of [timestamp, price]. Timestamp is in UNIX nanoseconds.
     * @type {Array<Array<string>>}
     * @memberof GetIndexHistory200Response
     */
    'history'?: Array<Array<string>>;
}
/**
 * 
 * @export
 * @interface GetInstrumentInstrumentName200Response
 */
export interface GetInstrumentInstrumentName200Response {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200Response
     */
    'asset': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200Response
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200Response
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetInstrumentInstrumentName200Response
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200Response
     */
    'mark_price': string;
    /**
     * Current index price of the asset. Eg. `12.23`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200Response
     */
    'index_price': string;
    /**
     * Current forward price of the asset. Eg. `12.23`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200Response
     */
    'forward_price': string;
    /**
     * 
     * @type {GetInstrumentInstrumentName200ResponseBestBid}
     * @memberof GetInstrumentInstrumentName200Response
     */
    'best_bid'?: GetInstrumentInstrumentName200ResponseBestBid;
    /**
     * 
     * @type {GetInstrumentInstrumentName200ResponseBestBid}
     * @memberof GetInstrumentInstrumentName200Response
     */
    'best_ask'?: GetInstrumentInstrumentName200ResponseBestBid;
    /**
     * 
     * @type {GetInstrumentInstrumentName200ResponseMarkets}
     * @memberof GetInstrumentInstrumentName200Response
     */
    'markets'?: GetInstrumentInstrumentName200ResponseMarkets;
    /**
     * 
     * @type {GetMarkets200ResponseGreeks}
     * @memberof GetInstrumentInstrumentName200Response
     */
    'greeks'?: GetMarkets200ResponseGreeks;
}
/**
 * 
 * @export
 * @interface GetInstrumentInstrumentName200ResponseBestBid
 */
export interface GetInstrumentInstrumentName200ResponseBestBid {
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200ResponseBestBid
     */
    'price': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200ResponseBestBid
     */
    'amount': string;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200ResponseBestBid
     */
    'iv': string;
}
/**
 * 
 * @export
 * @interface GetInstrumentInstrumentName200ResponseMarkets
 */
export interface GetInstrumentInstrumentName200ResponseMarkets {
    /**
     * 24-hour traded notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200ResponseMarkets
     */
    'daily_volume': string;
    /**
     * 24-hour traded volume in contract terms. Eg. `1234.5`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200ResponseMarkets
     */
    'daily_volume_contracts': string;
    /**
     * Total traded notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200ResponseMarkets
     */
    'total_volume': string;
    /**
     * Total traded volume in contract terms. Eg. `1234.5`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200ResponseMarkets
     */
    'total_volume_contracts': string;
    /**
     * Total open interest in number of contracts. Eg. `1234.56`
     * @type {string}
     * @memberof GetInstrumentInstrumentName200ResponseMarkets
     */
    'total_oi': string;
}
/**
 * 
 * @export
 * @interface GetInstrumentInstrumentNameTradeHistory200Response
 */
export interface GetInstrumentInstrumentNameTradeHistory200Response {
    /**
     * total number of rows in a query Eg. `5`
     * @type {string}
     * @memberof GetInstrumentInstrumentNameTradeHistory200Response
     */
    'count': string;
    /**
     * 
     * @type {Array<GetInstrumentInstrumentNameTradeHistory200ResponseTradeHistoryInner>}
     * @memberof GetInstrumentInstrumentNameTradeHistory200Response
     */
    'trade_history'?: Array<GetInstrumentInstrumentNameTradeHistory200ResponseTradeHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetInstrumentInstrumentNameTradeHistory200ResponseTradeHistoryInner
 */
export interface GetInstrumentInstrumentNameTradeHistory200ResponseTradeHistoryInner {
    /**
     * Unique ID of the trade. Eg. `DwmDn5XnEyiqx5AB5CM4W8bgD137ASX4Lz1XWBYqvpX2`
     * @type {string}
     * @memberof GetInstrumentInstrumentNameTradeHistory200ResponseTradeHistoryInner
     */
    'trade_id': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetInstrumentInstrumentNameTradeHistory200ResponseTradeHistoryInner
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetInstrumentInstrumentNameTradeHistory200ResponseTradeHistoryInner
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetInstrumentInstrumentNameTradeHistory200ResponseTradeHistoryInner
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetInstrumentInstrumentNameTradeHistory200ResponseTradeHistoryInner
     */
    'side': SideResponse;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetInstrumentInstrumentNameTradeHistory200ResponseTradeHistoryInner
     */
    'price': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetInstrumentInstrumentNameTradeHistory200ResponseTradeHistoryInner
     */
    'amount': string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetInstrumentInstrumentNameTradeHistory200ResponseTradeHistoryInner
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetL1Capacity200Response
 */
export interface GetL1Capacity200Response {
    /**
     * 
     * @type {CollateralAssetResponse}
     * @memberof GetL1Capacity200Response
     */
    'collateral_asset': CollateralAssetResponse;
    /**
     * Token address Eg. `0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2`
     * @type {string}
     * @memberof GetL1Capacity200Response
     */
    'token': string;
    /**
     * The withdrawal capacity for a destination chain. Eg. `1000000`
     * @type {string}
     * @memberof GetL1Capacity200Response
     */
    'capacity': string;
}
/**
 * 
 * @export
 * @interface GetLeaderboard200Response
 */
export interface GetLeaderboard200Response {
    /**
     * 
     * @type {GetLeaderboard200ResponseLeaderboard}
     * @memberof GetLeaderboard200Response
     */
    'leaderboard'?: GetLeaderboard200ResponseLeaderboard;
}
/**
 * 
 * @export
 * @interface GetLeaderboard200ResponseLeaderboard
 */
export interface GetLeaderboard200ResponseLeaderboard {
    /**
     * 
     * @type {GetLeaderboard200ResponseLeaderboardDaily}
     * @memberof GetLeaderboard200ResponseLeaderboard
     */
    'daily'?: GetLeaderboard200ResponseLeaderboardDaily;
    /**
     * 
     * @type {GetLeaderboard200ResponseLeaderboardDaily}
     * @memberof GetLeaderboard200ResponseLeaderboard
     */
    'weekly'?: GetLeaderboard200ResponseLeaderboardDaily;
    /**
     * 
     * @type {GetLeaderboard200ResponseLeaderboardDaily}
     * @memberof GetLeaderboard200ResponseLeaderboard
     */
    'monthly'?: GetLeaderboard200ResponseLeaderboardDaily;
    /**
     * 
     * @type {GetLeaderboard200ResponseLeaderboardDaily}
     * @memberof GetLeaderboard200ResponseLeaderboard
     */
    'all_time'?: GetLeaderboard200ResponseLeaderboardDaily;
}
/**
 * 
 * @export
 * @interface GetLeaderboard200ResponseLeaderboardDaily
 */
export interface GetLeaderboard200ResponseLeaderboardDaily {
    /**
     * Ranking. Eg. ``
     * @type {string}
     * @memberof GetLeaderboard200ResponseLeaderboardDaily
     */
    'ranking': string;
    /**
     * Options Volume in USDC terms. Eg. `12.23`
     * @type {string}
     * @memberof GetLeaderboard200ResponseLeaderboardDaily
     */
    'options_volume': string;
    /**
     * Perpetuals Volume in USDC terms. Eg. `12.23`
     * @type {string}
     * @memberof GetLeaderboard200ResponseLeaderboardDaily
     */
    'perp_volume': string;
    /**
     * Profit and loss. Signed float string. Eg. `12.23`
     * @type {string}
     * @memberof GetLeaderboard200ResponseLeaderboardDaily
     */
    'pnl': string;
    /**
     * Account\'s auto-generated username based on their Ethereum address. Eg. `officially-evolved-terrier`
     * @type {string}
     * @memberof GetLeaderboard200ResponseLeaderboardDaily
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface GetLeaderboardCampaign200Response
 */
export interface GetLeaderboardCampaign200Response {
    /**
     * 
     * @type {GetLeaderboard200ResponseLeaderboard}
     * @memberof GetLeaderboardCampaign200Response
     */
    'leaderboard'?: GetLeaderboard200ResponseLeaderboard;
}
/**
 * 
 * @export
 * @interface GetMargin200Response
 */
export interface GetMargin200Response {
    /**
     * Margin required to keep an open order. Eg. `12.23`
     * @type {string}
     * @memberof GetMargin200Response
     */
    'initial_margin': string;
    /**
     * Liquidation price of the order/position. Eg. `1288.23`
     * @type {string}
     * @memberof GetMargin200Response
     */
    'liquidation_price'?: string;
}
/**
 * 
 * @export
 * @interface GetMarkHistory200Response
 */
export interface GetMarkHistory200Response {
    /**
     * List of [timestamp, price]. Timestamp is in UNIX nanoseconds.
     * @type {Array<Array<string>>}
     * @memberof GetMarkHistory200Response
     */
    'history'?: Array<Array<string>>;
}
/**
 * 
 * @export
 * @interface GetMarkets200Response
 */
export interface GetMarkets200Response {
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetMarkets200Response
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * Underlying asset symbol. Eg. `ETH`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'underlying_asset': string;
    /**
     * Quote asset symbol. Eg. `USDC`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'quote_asset': string;
    /**
     * Allowed increments in price. Eg. `0.05`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'price_step': string;
    /**
     * Allowed increments in contract amount. Eg. `0.1`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'amount_step': string;
    /**
     * Minimum allowed order value Eg. `0.1`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'min_order_value': string;
    /**
     * Maximum allowed order value Eg. `0.1`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'max_order_value': string;
    /**
     * Maximum allowed notional value Eg. `0.1`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'max_notional_value': string;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'mark_price': string;
    /**
     * Current forward price of the asset. Eg. `12.23`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'forward_price'?: string;
    /**
     * Current index price of the asset. Eg. `12.23`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'index_price': string;
    /**
     * True if instrument is active and tradable. Eg. `true`
     * @type {boolean}
     * @memberof GetMarkets200Response
     */
    'is_active': boolean;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetMarkets200Response
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'expiry'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'strike'?: string;
    /**
     * 
     * @type {GetMarkets200ResponseGreeks}
     * @memberof GetMarkets200Response
     */
    'greeks'?: GetMarkets200ResponseGreeks;
    /**
     * The maximum leverage multiplier for an instrument. Eg. `12`
     * @type {string}
     * @memberof GetMarkets200Response
     */
    'max_leverage'?: string;
    /**
     * Flag whether the perpetual is pre-launched. Eg. `true`
     * @type {boolean}
     * @memberof GetMarkets200Response
     */
    'pre_launch'?: boolean;
}
/**
 * 
 * @export
 * @interface GetMarkets200ResponseGreeks
 */
export interface GetMarkets200ResponseGreeks {
    /**
     * Option\'s Delta. Eg. `0.23`
     * @type {string}
     * @memberof GetMarkets200ResponseGreeks
     */
    'delta': string;
    /**
     * Option\'s Gamma. Eg. `0.23`
     * @type {string}
     * @memberof GetMarkets200ResponseGreeks
     */
    'gamma': string;
    /**
     * Option\'s Rho. Eg. `0.23`
     * @type {string}
     * @memberof GetMarkets200ResponseGreeks
     */
    'rho': string;
    /**
     * Option\'s Theta. Eg. `0.23`
     * @type {string}
     * @memberof GetMarkets200ResponseGreeks
     */
    'theta': string;
    /**
     * Option\'s Vega. Eg. `0.23`
     * @type {string}
     * @memberof GetMarkets200ResponseGreeks
     */
    'vega': string;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetMarkets200ResponseGreeks
     */
    'iv': string;
}
/**
 * 
 * @export
 * @interface GetMarketsSummary200Response
 */
export interface GetMarketsSummary200Response {
    /**
     * 
     * @type {Array<GetMarketsSummary200ResponseSummariesInner>}
     * @memberof GetMarketsSummary200Response
     */
    'summaries'?: Array<GetMarketsSummary200ResponseSummariesInner>;
}
/**
 * 
 * @export
 * @interface GetMarketsSummary200ResponseSummariesInner
 */
export interface GetMarketsSummary200ResponseSummariesInner {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInner
     */
    'asset': string;
    /**
     * Current index price of the asset. Eg. `12.23`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInner
     */
    'index_price': string;
    /**
     * 24-hour change in index price of the underlying asset. Eg. `12.52`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInner
     */
    'index_daily_change': string;
    /**
     * 
     * @type {GetMarketsSummary200ResponseSummariesInnerOptionInfo}
     * @memberof GetMarketsSummary200ResponseSummariesInner
     */
    'option_info'?: GetMarketsSummary200ResponseSummariesInnerOptionInfo;
    /**
     * 
     * @type {GetMarketsSummary200ResponseSummariesInnerPerpetualInfo}
     * @memberof GetMarketsSummary200ResponseSummariesInner
     */
    'perpetual_info'?: GetMarketsSummary200ResponseSummariesInnerPerpetualInfo;
}
/**
 * 
 * @export
 * @interface GetMarketsSummary200ResponseSummariesInnerOptionInfo
 */
export interface GetMarketsSummary200ResponseSummariesInnerOptionInfo {
    /**
     * 
     * @type {GetStatistics200ResponseOpenInterest}
     * @memberof GetMarketsSummary200ResponseSummariesInnerOptionInfo
     */
    'open_interest'?: GetStatistics200ResponseOpenInterest;
    /**
     * 24-hour traded notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerOptionInfo
     */
    'daily_volume'?: string;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerOptionInfo
     */
    'mark_price': string;
    /**
     * 24-hour change in mark price of the instrument. Eg. `12.52`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerOptionInfo
     */
    'mark_daily_change': string;
    /**
     * Allowed increments in price. Eg. `0.05`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerOptionInfo
     */
    'price_step': string;
    /**
     * Allowed increments in contract amount. Eg. `0.1`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerOptionInfo
     */
    'amount_step': string;
}
/**
 * 
 * @export
 * @interface GetMarketsSummary200ResponseSummariesInnerPerpetualInfo
 */
export interface GetMarketsSummary200ResponseSummariesInnerPerpetualInfo {
    /**
     * 
     * @type {GetMarketsSummary200ResponseSummariesInnerPerpetualInfoOpenInterest}
     * @memberof GetMarketsSummary200ResponseSummariesInnerPerpetualInfo
     */
    'open_interest'?: GetMarketsSummary200ResponseSummariesInnerPerpetualInfoOpenInterest;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerPerpetualInfo
     */
    'mark_price': string;
    /**
     * 24-hour change in mark price of the instrument. Eg. `12.52`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerPerpetualInfo
     */
    'mark_daily_change': string;
    /**
     * Mark price of the instrument from 24-hour ago. Eg. `12.52`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerPerpetualInfo
     */
    'mark_price_24h_ago': string;
    /**
     * Flag whether the perpetual is pre-launched. Eg. `true`
     * @type {boolean}
     * @memberof GetMarketsSummary200ResponseSummariesInnerPerpetualInfo
     */
    'pre_launch'?: boolean;
    /**
     * 24-hour traded notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerPerpetualInfo
     */
    'daily_volume'?: string;
    /**
     * Allowed increments in price. Eg. `0.05`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerPerpetualInfo
     */
    'price_step': string;
    /**
     * Allowed increments in contract amount. Eg. `0.1`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerPerpetualInfo
     */
    'amount_step': string;
    /**
     * Funding rate in decimals. Eg. `0.00122`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerPerpetualInfo
     */
    'funding_rate': string;
}
/**
 * 
 * @export
 * @interface GetMarketsSummary200ResponseSummariesInnerPerpetualInfoOpenInterest
 */
export interface GetMarketsSummary200ResponseSummariesInnerPerpetualInfoOpenInterest {
    /**
     * Total open interest in number of contracts. Eg. `1234.56`
     * @type {string}
     * @memberof GetMarketsSummary200ResponseSummariesInnerPerpetualInfoOpenInterest
     */
    'total': string;
}
/**
 * 
 * @export
 * @interface GetMmp200Response
 */
export interface GetMmp200Response {
    /**
     * Enabled if true. Eg. `true`
     * @type {boolean}
     * @memberof GetMmp200Response
     */
    'enabled': boolean;
    /**
     * Account under MMP if true Eg. `true`
     * @type {boolean}
     * @memberof GetMmp200Response
     */
    'triggered': boolean;
    /**
     * Interval in seconds. A setting for market maker protection (MMP). If set to 0, MMP is disabled. Eg. `30`
     * @type {string}
     * @memberof GetMmp200Response
     */
    'interval'?: string;
    /**
     * Duration in seconds during which the account will be frozen. If set to 0, manual reset is required. Eg. `30`
     * @type {string}
     * @memberof GetMmp200Response
     */
    'frozen'?: string;
    /**
     * End time in nanoseconds where the account will be unfrozen. Eg. `1683697928273737203`
     * @type {string}
     * @memberof GetMmp200Response
     */
    'frozen_end_time'?: string;
    /**
     * Amount limit setting for market maker protection (MMP). In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetMmp200Response
     */
    'amount_limit'?: string;
    /**
     * Delta limit setting for market maker protection (MMP). In unsigned float. Eg. `0.1`
     * @type {string}
     * @memberof GetMmp200Response
     */
    'delta_limit'?: string;
    /**
     * Change in filled contract amounts within the interval. Eg. `0.1`
     * @type {string}
     * @memberof GetMmp200Response
     */
    'amount_change'?: string;
    /**
     * Change in delta within the interval. Eg. `0.1`
     * @type {string}
     * @memberof GetMmp200Response
     */
    'delta_change'?: string;
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetMmp200Response
     */
    'asset': string;
}
/**
 * 
 * @export
 * @interface GetNotifications200Response
 */
export interface GetNotifications200Response {
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetNotifications200Response
     */
    'account': string;
    /**
     * Notification read flag. Eg. `true`
     * @type {boolean}
     * @memberof GetNotifications200Response
     */
    'is_read': boolean;
    /**
     * 
     * @type {NotificationTypeResponse}
     * @memberof GetNotifications200Response
     */
    'notification_type': NotificationTypeResponse;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetNotifications200Response
     */
    'created_timestamp': string;
    /**
     * 
     * @type {GetNotifications200ResponseMetadata}
     * @memberof GetNotifications200Response
     */
    'metadata'?: GetNotifications200ResponseMetadata;
}
/**
 * 
 * @export
 * @interface GetNotifications200ResponseMetadata
 */
export interface GetNotifications200ResponseMetadata {
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'amount'?: string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'price'?: string;
    /**
     * 
     * @type {OrderTypeResponse}
     * @memberof GetNotifications200ResponseMetadata
     */
    'order_type'?: OrderTypeResponse;
    /**
     * L1 token address Eg. `0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'l1Token'?: string;
    /**
     * L2 token address Eg. `0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'l2Token'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'strike'?: string;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetNotifications200ResponseMetadata
     */
    'side'?: SideResponse;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetNotifications200ResponseMetadata
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'expiry'?: string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'account'?: string;
    /**
     * Ethereum address of the collateral asset. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'collateral'?: string;
    /**
     * Transaction hash. Eg. `0x4c55895aa6f2dfc2da8189a71a054348ce63abbc1ae27267977e0d9cc6848e91`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'tx_hash'?: string;
    /**
     * Ethereum address to send withdrawals to. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'to'?: string;
    /**
     * Balance. Eg. `12.23`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'balance'?: string;
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'asset'?: string;
    /**
     * Number of positions liquidated. Eg. `12`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'position_count'?: string;
    /**
     * Fees paid for the trade. Eg. `12.23`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'fees'?: string;
    /**
     * Whether or not mmp is enabled Eg. `true`
     * @type {boolean}
     * @memberof GetNotifications200ResponseMetadata
     */
    'mmp_enabled'?: boolean;
    /**
     * The price to trigger the stop order at. `stop` is required when `trigger` is specified. Eg. `1836.74`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'trigger'?: string;
    /**
     * Transfer label. Eg. `Rewards`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'label'?: string;
    /**
     * Referee address of a Referrer Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'referee'?: string;
    /**
     * Referrer of a referee Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'referrer'?: string;
    /**
     * Commission for a referral Eg. `0.1`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'commission'?: string;
    /**
     * Duration of referral/referee discount Eg. `6 months`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'period'?: string;
    /**
     * Account\'s auto-generated username based on their Ethereum address. Eg. `officially-evolved-terrier`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'username'?: string;
    /**
     * Settlement payout. Signed float string. Eg. `12.23`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'payout'?: string;
    /**
     * Settlement entry price. Signed float string. Eg. `12.23`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'entry_price'?: string;
    /**
     * 
     * @type {GetTransactionHistory200ResponseTransactionHistoryInnerTransferDetails}
     * @memberof GetNotifications200ResponseMetadata
     */
    'transfer_details'?: GetTransactionHistory200ResponseTransactionHistoryInnerTransferDetails;
    /**
     * Farming boost Eg. `12.23`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'farm_boost'?: string;
    /**
     * Boosted trading notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetNotifications200ResponseMetadata
     */
    'boosted_volume'?: string;
}
/**
 * 
 * @export
 * @interface GetOptionsChain200Response
 */
export interface GetOptionsChain200Response {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetOptionsChain200Response
     */
    'asset': string;
    /**
     * 
     * @type {GetOptionsChain200ResponseOptions}
     * @memberof GetOptionsChain200Response
     */
    'options'?: GetOptionsChain200ResponseOptions;
}
/**
 * 
 * @export
 * @interface GetOptionsChain200ResponseOptions
 */
export interface GetOptionsChain200ResponseOptions {
    /**
     * 
     * @type {Array<GetOptionsChain200ResponseOptionsCallsInner>}
     * @memberof GetOptionsChain200ResponseOptions
     */
    'calls'?: Array<GetOptionsChain200ResponseOptionsCallsInner>;
    /**
     * 
     * @type {Array<GetOptionsChain200ResponseOptionsCallsInner>}
     * @memberof GetOptionsChain200ResponseOptions
     */
    'puts'?: Array<GetOptionsChain200ResponseOptionsCallsInner>;
}
/**
 * 
 * @export
 * @interface GetOptionsChain200ResponseOptionsCallsInner
 */
export interface GetOptionsChain200ResponseOptionsCallsInner {
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetOptionsChain200ResponseOptionsCallsInner
     */
    'instrument_name': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetOptionsChain200ResponseOptionsCallsInner
     */
    'instrument_id': string;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof GetOptionsChain200ResponseOptionsCallsInner
     */
    'mark_price': string;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetOptionsChain200ResponseOptionsCallsInner
     */
    'iv': string;
    /**
     * Option\'s Delta. Eg. `0.23`
     * @type {string}
     * @memberof GetOptionsChain200ResponseOptionsCallsInner
     */
    'delta': string;
    /**
     * Open interest in USDC terms for a given expiry. Eg. `1234.56`
     * @type {string}
     * @memberof GetOptionsChain200ResponseOptionsCallsInner
     */
    'open_interest': string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetOptionsChain200ResponseOptionsCallsInner
     */
    'strike': string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOptionsChain200ResponseOptionsCallsInner
     */
    'expiry': string;
    /**
     * 
     * @type {GetOptionsChain200ResponseOptionsCallsInnerTicker}
     * @memberof GetOptionsChain200ResponseOptionsCallsInner
     */
    'ticker'?: GetOptionsChain200ResponseOptionsCallsInnerTicker;
}
/**
 * 
 * @export
 * @interface GetOptionsChain200ResponseOptionsCallsInnerTicker
 */
export interface GetOptionsChain200ResponseOptionsCallsInnerTicker {
    /**
     * 
     * @type {GetOptionsChain200ResponseOptionsCallsInnerTickerBid}
     * @memberof GetOptionsChain200ResponseOptionsCallsInnerTicker
     */
    'bid'?: GetOptionsChain200ResponseOptionsCallsInnerTickerBid;
    /**
     * 
     * @type {GetOptionsChain200ResponseOptionsCallsInnerTickerBid}
     * @memberof GetOptionsChain200ResponseOptionsCallsInnerTicker
     */
    'ask'?: GetOptionsChain200ResponseOptionsCallsInnerTickerBid;
}
/**
 * 
 * @export
 * @interface GetOptionsChain200ResponseOptionsCallsInnerTickerBid
 */
export interface GetOptionsChain200ResponseOptionsCallsInnerTickerBid {
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetOptionsChain200ResponseOptionsCallsInnerTickerBid
     */
    'price': string;
    /**
     * Volume in USDC terms. Eg. `12.23`
     * @type {string}
     * @memberof GetOptionsChain200ResponseOptionsCallsInnerTickerBid
     */
    'volume': string;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetOptionsChain200ResponseOptionsCallsInnerTickerBid
     */
    'iv': string;
}
/**
 * 
 * @export
 * @interface GetOptionsHistory200Response
 */
export interface GetOptionsHistory200Response {
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetOptionsHistory200Response
     */
    'instrument_name': string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetOptionsHistory200Response
     */
    'option_type': OptionTypeResponse;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOptionsHistory200Response
     */
    'expiry': string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetOptionsHistory200Response
     */
    'strike': string;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetOptionsHistory200Response
     */
    'iv': string;
    /**
     * 
     * @type {OrderTypeResponse}
     * @memberof GetOptionsHistory200Response
     */
    'order_type': OrderTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetOptionsHistory200Response
     */
    'side': SideResponse;
    /**
     * Average entry price of the position. Eg. `12.23`
     * @type {string}
     * @memberof GetOptionsHistory200Response
     */
    'avg_price': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetOptionsHistory200Response
     */
    'amount': string;
    /**
     * 
     * @type {TradeStatusResponse}
     * @memberof GetOptionsHistory200Response
     */
    'trade_status': TradeStatusResponse;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOptionsHistory200Response
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetOrderHistory200Response
 */
export interface GetOrderHistory200Response {
    /**
     * total number of rows in a query Eg. `5`
     * @type {string}
     * @memberof GetOrderHistory200Response
     */
    'count': string;
    /**
     * 
     * @type {Array<GetOrderHistory200ResponseOrderHistoryInner>}
     * @memberof GetOrderHistory200Response
     */
    'order_history'?: Array<GetOrderHistory200ResponseOrderHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetOrderHistory200ResponseOrderHistoryInner
 */
export interface GetOrderHistory200ResponseOrderHistoryInner {
    /**
     * Order ID is the hash of the order payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'order_id': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'account': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {OrderTypeResponse}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'order_type': OrderTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'side': SideResponse;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'amount': string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'price': string;
    /**
     * Amount filled. Eg. `12.23`
     * @type {string}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'filled': string;
    /**
     * The error code for a failed trade Eg. `IOC_ORDER_REJECTED`
     * @type {string}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'error'?: string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'expiry'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'strike'?: string;
    /**
     * 
     * @type {StopResponse}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'stop'?: StopResponse;
    /**
     * 
     * @type {StopTypeResponse}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'stop_type'?: StopTypeResponse;
    /**
     * The price to trigger the stop order at. `stop` is required when `trigger` is specified. Eg. `1836.74`
     * @type {string}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'trigger'?: string;
    /**
     * 
     * @type {OrderStatusResponse}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'order_status': OrderStatusResponse;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOrderHistory200ResponseOrderHistoryInner
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetOrderHistoryStops200Response
 */
export interface GetOrderHistoryStops200Response {
    /**
     * total number of rows in a query Eg. `5`
     * @type {string}
     * @memberof GetOrderHistoryStops200Response
     */
    'count': string;
    /**
     * 
     * @type {Array<GetOrderHistoryStops200ResponseOrderHistoryInner>}
     * @memberof GetOrderHistoryStops200Response
     */
    'order_history'?: Array<GetOrderHistoryStops200ResponseOrderHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetOrderHistoryStops200ResponseOrderHistoryInner
 */
export interface GetOrderHistoryStops200ResponseOrderHistoryInner {
    /**
     * Order ID is the hash of the order payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'order_id': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'account': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {OrderTypeResponse}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'order_type': OrderTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'side': SideResponse;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'amount': string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'price': string;
    /**
     * Amount filled. Eg. `12.23`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'filled': string;
    /**
     * The error code for a failed trade Eg. `IOC_ORDER_REJECTED`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'error'?: string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'expiry'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'strike'?: string;
    /**
     * 
     * @type {StopResponse}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'stop'?: StopResponse;
    /**
     * 
     * @type {StopTypeResponse}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'stop_type'?: StopTypeResponse;
    /**
     * The price to trigger the stop order at. `stop` is required when `trigger` is specified. Eg. `1836.74`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'trigger'?: string;
    /**
     * 
     * @type {OrderStatusResponse}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'order_status': OrderStatusResponse;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'created_timestamp': string;
    /**
     * Number of contracts. Unsigned float string. Eg. `12.23`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'total_matched_amount'?: string;
    /**
     * Unique ID of the trade. Eg. `DwmDn5XnEyiqx5AB5CM4W8bgD137ASX4Lz1XWBYqvpX2`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'trade_id'?: string;
    /**
     * Average entry price of the position. Eg. `12.23`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'avg_price'?: string;
    /**
     * Settlement entry price. Signed float string. Eg. `12.23`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'entry_price'?: string;
    /**
     * Spot price. Eg. `1802.30`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'spot_price'?: string;
    /**
     * Fees paid for the trade. Eg. `12.23`
     * @type {string}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'fees'?: string;
    /**
     * True if a closing trade. Eg. `false`
     * @type {boolean}
     * @memberof GetOrderHistoryStops200ResponseOrderHistoryInner
     */
    'is_closing'?: boolean;
}
/**
 * 
 * @export
 * @interface GetOrderbook200Response
 */
export interface GetOrderbook200Response {
    /**
     * For REST API, the value is always set to `snapshot`. Eg. `snapshot`
     * @type {string}
     * @memberof GetOrderbook200Response
     */
    'type': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetOrderbook200Response
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetOrderbook200Response
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetOrderbook200Response
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * Array of 3 elements, price in USD, contract amount, and IV respectively.
     * @type {Array<Array<string>>}
     * @memberof GetOrderbook200Response
     */
    'bids'?: Array<Array<string>>;
    /**
     * Array of 3 elements, price in USD, contract amount, and IV respectively.
     * @type {Array<Array<string>>}
     * @memberof GetOrderbook200Response
     */
    'asks'?: Array<Array<string>>;
    /**
     * Last updated timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOrderbook200Response
     */
    'last_updated': string;
    /**
     * Payload checksum. Eg. `8479283742`
     * @type {string}
     * @memberof GetOrderbook200Response
     */
    'checksum': string;
}
/**
 * 
 * @export
 * @interface GetOrders200Response
 */
export interface GetOrders200Response {
    /**
     * Order ID is the hash of the order payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'order_id': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'account': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetOrders200Response
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {OrderTypeResponse}
     * @memberof GetOrders200Response
     */
    'order_type': OrderTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetOrders200Response
     */
    'side': SideResponse;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'amount': string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'price': string;
    /**
     * Average entry price of the position. Eg. `12.23`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'avg_price': string;
    /**
     * Amount filled. Eg. `12.23`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'filled': string;
    /**
     * 
     * @type {OrderStatusResponse}
     * @memberof GetOrders200Response
     */
    'order_status': OrderStatusResponse;
    /**
     * True for post-only maker orders, false for standard orders. Eg. `false`
     * @type {boolean}
     * @memberof GetOrders200Response
     */
    'post_only'?: boolean;
    /**
     * True for reduce-only orders, false for standard orders. Eg. `false`
     * @type {boolean}
     * @memberof GetOrders200Response
     */
    'reduce_only'?: boolean;
    /**
     * Margin required to keep an open order. Eg. `12.23`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'initial_margin'?: string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetOrders200Response
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'iv'?: string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'expiry'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'strike'?: string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'created_timestamp'?: string;
    /**
     * Timestamp in UNIX in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'timestamp': string;
    /**
     * 
     * @type {SystemTypeResponse}
     * @memberof GetOrders200Response
     */
    'system_type': SystemTypeResponse;
    /**
     * 
     * @type {TimeInForceResponse}
     * @memberof GetOrders200Response
     */
    'time_in_force'?: TimeInForceResponse;
    /**
     * 
     * @type {StopResponse}
     * @memberof GetOrders200Response
     */
    'stop'?: StopResponse;
    /**
     * The price to trigger the stop order at. `stop` is required when `trigger` is specified. Eg. `1836.74`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'trigger'?: string;
    /**
     * Is order a close position TPSL order. Eg. `true`
     * @type {boolean}
     * @memberof GetOrders200Response
     */
    'close_position'?: boolean;
    /**
     * Is order a partial position TPSL order. Eg. `false`
     * @type {boolean}
     * @memberof GetOrders200Response
     */
    'partial_position'?: boolean;
    /**
     * The change in isolated margin assigned to a position. In 6 decimals fixed number. Negative allowed. Eg. `10000000`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'isolated_margin'?: string;
    /**
     * Order ID of the order which when cancelled, cancels this order as well Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetOrders200Response
     */
    'parent_order_id'?: string;
    /**
     * 
     * @type {SelfTradePreventionResponse}
     * @memberof GetOrders200Response
     */
    'self_trade_prevention'?: SelfTradePreventionResponse;
}
/**
 * 
 * @export
 * @interface GetOrdersOrderId200Response
 */
export interface GetOrdersOrderId200Response {
    /**
     * Order ID is the hash of the order payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'order_id': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'account': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetOrdersOrderId200Response
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {OrderTypeResponse}
     * @memberof GetOrdersOrderId200Response
     */
    'order_type': OrderTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetOrdersOrderId200Response
     */
    'side': SideResponse;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'amount': string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'price': string;
    /**
     * Average entry price of the position. Eg. `12.23`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'avg_price': string;
    /**
     * Amount filled. Eg. `12.23`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'filled': string;
    /**
     * 
     * @type {OrderStatusResponse}
     * @memberof GetOrdersOrderId200Response
     */
    'order_status': OrderStatusResponse;
    /**
     * True for post-only maker orders, false for standard orders. Eg. `false`
     * @type {boolean}
     * @memberof GetOrdersOrderId200Response
     */
    'post_only'?: boolean;
    /**
     * True for reduce-only orders, false for standard orders. Eg. `false`
     * @type {boolean}
     * @memberof GetOrdersOrderId200Response
     */
    'reduce_only'?: boolean;
    /**
     * Margin required to keep an open order. Eg. `12.23`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'initial_margin'?: string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetOrdersOrderId200Response
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'iv'?: string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'expiry'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'strike'?: string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'created_timestamp'?: string;
    /**
     * Timestamp in UNIX in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'timestamp': string;
    /**
     * 
     * @type {SystemTypeResponse}
     * @memberof GetOrdersOrderId200Response
     */
    'system_type': SystemTypeResponse;
    /**
     * 
     * @type {TimeInForceResponse}
     * @memberof GetOrdersOrderId200Response
     */
    'time_in_force'?: TimeInForceResponse;
    /**
     * 
     * @type {StopResponse}
     * @memberof GetOrdersOrderId200Response
     */
    'stop'?: StopResponse;
    /**
     * The price to trigger the stop order at. `stop` is required when `trigger` is specified. Eg. `1836.74`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'trigger'?: string;
    /**
     * Is order a close position TPSL order. Eg. `true`
     * @type {boolean}
     * @memberof GetOrdersOrderId200Response
     */
    'close_position'?: boolean;
    /**
     * Is order a partial position TPSL order. Eg. `false`
     * @type {boolean}
     * @memberof GetOrdersOrderId200Response
     */
    'partial_position'?: boolean;
    /**
     * The change in isolated margin assigned to a position. In 6 decimals fixed number. Negative allowed. Eg. `10000000`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'isolated_margin'?: string;
    /**
     * Order ID of the order which when cancelled, cancels this order as well Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetOrdersOrderId200Response
     */
    'parent_order_id'?: string;
    /**
     * 
     * @type {SelfTradePreventionResponse}
     * @memberof GetOrdersOrderId200Response
     */
    'self_trade_prevention'?: SelfTradePreventionResponse;
}
/**
 * 
 * @export
 * @interface GetOtcAccount200Response
 */
export interface GetOtcAccount200Response {
    /**
     * Internal account for OTC trades Eg. `0x0`
     * @type {string}
     * @memberof GetOtcAccount200Response
     */
    'internal_account': string;
    /**
     * 
     * @type {Array<GetOtcAccount200ResponseOtcRequestsInner>}
     * @memberof GetOtcAccount200Response
     */
    'otc_requests'?: Array<GetOtcAccount200ResponseOtcRequestsInner>;
    /**
     * 
     * @type {Array<GetOtcAccount200ResponseOtcPositionsInner>}
     * @memberof GetOtcAccount200Response
     */
    'otc_positions'?: Array<GetOtcAccount200ResponseOtcPositionsInner>;
}
/**
 * 
 * @export
 * @interface GetOtcAccount200ResponseOtcPositionsInner
 */
export interface GetOtcAccount200ResponseOtcPositionsInner {
    /**
     * Unique ID of the otc request Eg. `1`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcPositionsInner
     */
    'otc_id': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcPositionsInner
     */
    'account': string;
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcPositionsInner
     */
    'asset': string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcPositionsInner
     */
    'strike': string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcPositionsInner
     */
    'expiry': string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetOtcAccount200ResponseOtcPositionsInner
     */
    'option_type': OptionTypeResponse;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcPositionsInner
     */
    'amount': string;
    /**
     * Entry spot price of the otc request Eg. `1000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcPositionsInner
     */
    'entry_spot_price': string;
    /**
     * Premiums required for the otc request Eg. `2000000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcPositionsInner
     */
    'premium': string;
    /**
     * Otc quote price Eg. `2000000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcPositionsInner
     */
    'quote_price': string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcPositionsInner
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetOtcAccount200ResponseOtcRequestsInner
 */
export interface GetOtcAccount200ResponseOtcRequestsInner {
    /**
     * Unique ID of the otc request Eg. `1`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'otc_id': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'account': string;
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'asset': string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'strike': string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'expiry': string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'option_type': OptionTypeResponse;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'amount': string;
    /**
     * Timestamp of the otc request Eg. `1692861351000000000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'request_timestamp': string;
    /**
     * Indicative price of the otc request Eg. `1000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'indicative_price': string;
    /**
     * Otc quote price Eg. `2000000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'quote_price': string;
    /**
     * Status of the otc request Eg. `requested`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'status': string;
    /**
     * Premiums required for the otc request Eg. `2000000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'premium': string;
    /**
     * Timestamp of the otc quote Eg. `1692861351000000000`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'quote_timestamp': string;
    /**
     * Otc id of position to unwind. Eg. `12`
     * @type {string}
     * @memberof GetOtcAccount200ResponseOtcRequestsInner
     */
    'unwind_id': string;
}
/**
 * 
 * @export
 * @interface GetPortfolio200Response
 */
export interface GetPortfolio200Response {
    /**
     * Balance. Eg. `12.23`
     * @type {string}
     * @memberof GetPortfolio200Response
     */
    'balance': string;
    /**
     * Profit and loss. Signed float string. Eg. `12.23`
     * @type {string}
     * @memberof GetPortfolio200Response
     */
    'pnl': string;
    /**
     * Realized profit and loss. Signed float string. Eg. `12.23`
     * @type {string}
     * @memberof GetPortfolio200Response
     */
    'realized_pnl': string;
    /**
     * Profit Factor. Eg. `1.4`
     * @type {string}
     * @memberof GetPortfolio200Response
     */
    'profit_factor': string;
    /**
     * Win rate. Eg. `12.23`
     * @type {string}
     * @memberof GetPortfolio200Response
     */
    'win_rate': string;
    /**
     * Sharpe ratio. Eg. `12.23`
     * @type {string}
     * @memberof GetPortfolio200Response
     */
    'sharpe_ratio': string;
    /**
     * 
     * @type {Array<GetPortfolio200ResponseGreeksInner>}
     * @memberof GetPortfolio200Response
     */
    'greeks'?: Array<GetPortfolio200ResponseGreeksInner>;
    /**
     * 
     * @type {GetPortfolio200ResponseUserMargin}
     * @memberof GetPortfolio200Response
     */
    'user_margin'?: GetPortfolio200ResponseUserMargin;
}
/**
 * 
 * @export
 * @interface GetPortfolio200ResponseGreeksInner
 */
export interface GetPortfolio200ResponseGreeksInner {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetPortfolio200ResponseGreeksInner
     */
    'asset'?: string;
    /**
     * Option\'s Delta. Eg. `0.23`
     * @type {string}
     * @memberof GetPortfolio200ResponseGreeksInner
     */
    'delta': string;
    /**
     * Option\'s Gamma. Eg. `0.23`
     * @type {string}
     * @memberof GetPortfolio200ResponseGreeksInner
     */
    'gamma': string;
    /**
     * Option\'s Rho. Eg. `0.23`
     * @type {string}
     * @memberof GetPortfolio200ResponseGreeksInner
     */
    'rho': string;
    /**
     * Option\'s Theta. Eg. `0.23`
     * @type {string}
     * @memberof GetPortfolio200ResponseGreeksInner
     */
    'theta': string;
    /**
     * Option\'s Vega. Eg. `0.23`
     * @type {string}
     * @memberof GetPortfolio200ResponseGreeksInner
     */
    'vega': string;
}
/**
 * 
 * @export
 * @interface GetPortfolio200ResponseUserMargin
 */
export interface GetPortfolio200ResponseUserMargin {
    /**
     * Margin used. Eg. `12.23`
     * @type {string}
     * @memberof GetPortfolio200ResponseUserMargin
     */
    'used': string;
    /**
     * Balance. Eg. `12.23`
     * @type {string}
     * @memberof GetPortfolio200ResponseUserMargin
     */
    'balance': string;
}
/**
 * 
 * @export
 * @interface GetPositions200Response
 */
export interface GetPositions200Response {
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetPositions200Response
     */
    'account': string;
    /**
     * 
     * @type {Array<GetAccount200ResponsePositionsInner>}
     * @memberof GetPositions200Response
     */
    'positions'?: Array<GetAccount200ResponsePositionsInner>;
}
/**
 * 
 * @export
 * @interface GetProofData200Response
 */
export interface GetProofData200Response {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetProofData200Response
     */
    'asset'?: string;
    /**
     * Merkle Root Eg. `0x0`
     * @type {string}
     * @memberof GetProofData200Response
     */
    'merkle_root': string;
    /**
     * Total Tokens Eg. `0x0`
     * @type {string}
     * @memberof GetProofData200Response
     */
    'token_total': string;
    /**
     * 
     * @type {GetProofData200ResponseClaim}
     * @memberof GetProofData200Response
     */
    'claim'?: GetProofData200ResponseClaim;
}
/**
 * 
 * @export
 * @interface GetProofData200ResponseClaim
 */
export interface GetProofData200ResponseClaim {
    /**
     * Index of proof. Eg. `0`
     * @type {string}
     * @memberof GetProofData200ResponseClaim
     */
    'index': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetProofData200ResponseClaim
     */
    'amount': string;
    /**
     * Proof.
     * @type {Array<string>}
     * @memberof GetProofData200ResponseClaim
     */
    'proof'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetProofsData200Response
 */
export interface GetProofsData200Response {
    /**
     * 
     * @type {Array<GetProofsData200ResponseMerkleDatasInner>}
     * @memberof GetProofsData200Response
     */
    'merkle_datas'?: Array<GetProofsData200ResponseMerkleDatasInner>;
}
/**
 * 
 * @export
 * @interface GetProofsData200ResponseMerkleDatasInner
 */
export interface GetProofsData200ResponseMerkleDatasInner {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetProofsData200ResponseMerkleDatasInner
     */
    'asset'?: string;
    /**
     * Merkle Root Eg. `0x0`
     * @type {string}
     * @memberof GetProofsData200ResponseMerkleDatasInner
     */
    'merkle_root': string;
    /**
     * Total Tokens Eg. `0x0`
     * @type {string}
     * @memberof GetProofsData200ResponseMerkleDatasInner
     */
    'token_total': string;
    /**
     * 
     * @type {GetProofData200ResponseClaim}
     * @memberof GetProofsData200ResponseMerkleDatasInner
     */
    'claim'?: GetProofData200ResponseClaim;
}
/**
 * 
 * @export
 * @interface GetQuoteHistory200Response
 */
export interface GetQuoteHistory200Response {
    /**
     * total number of rows in a query Eg. `5`
     * @type {string}
     * @memberof GetQuoteHistory200Response
     */
    'count': string;
    /**
     * 
     * @type {Array<GetQuoteHistory200ResponseQuoteHistoryInner>}
     * @memberof GetQuoteHistory200Response
     */
    'quote_history'?: Array<GetQuoteHistory200ResponseQuoteHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetQuoteHistory200ResponseQuoteHistoryInner
 */
export interface GetQuoteHistory200ResponseQuoteHistoryInner {
    /**
     * Quote ID is the hash of the quote payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInner
     */
    'quote_id': string;
    /**
     * Block ID is the unique identifier of the block Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInner
     */
    'block_id': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInner
     */
    'account': string;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInner
     */
    'side': SideResponse;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInner
     */
    'amount': string;
    /**
     * Order limit price. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInner
     */
    'limit_price': string;
    /**
     * Amount filled. Eg. `12.23`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInner
     */
    'filled': string;
    /**
     * 
     * @type {QuoteStatusResponse}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInner
     */
    'quote_status': QuoteStatusResponse;
    /**
     * 
     * @type {Array<GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner>}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInner
     */
    'legs'?: Array<GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner>;
    /**
     * Updated timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInner
     */
    'updated_timestamp': string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInner
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner
 */
export interface GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner {
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner
     */
    'side': SideResponse;
    /**
     * Ratio of the instrument leg in decimals. Eg. `1`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner
     */
    'ratio': string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner
     */
    'price'?: string;
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner
     */
    'asset': string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner
     */
    'expiry'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner
     */
    'strike'?: string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetQuoteHistory200ResponseQuoteHistoryInnerLegsInner
     */
    'option_type'?: OptionTypeResponse;
}
/**
 * 
 * @export
 * @interface GetQuotes200Response
 */
export interface GetQuotes200Response {
    /**
     * 
     * @type {Array<GetQuotes200ResponseQuotesInner>}
     * @memberof GetQuotes200Response
     */
    'quotes'?: Array<GetQuotes200ResponseQuotesInner>;
}
/**
 * 
 * @export
 * @interface GetQuotes200ResponseQuotesInner
 */
export interface GetQuotes200ResponseQuotesInner {
    /**
     * Block ID is the unique identifier of the block Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInner
     */
    'block_id': string;
    /**
     * Quote ID is the hash of the quote payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInner
     */
    'quote_id': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInner
     */
    'amount': string;
    /**
     * Order limit price. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInner
     */
    'limit_price': string;
    /**
     * 
     * @type {QuoteStatusResponse}
     * @memberof GetQuotes200ResponseQuotesInner
     */
    'quote_status': QuoteStatusResponse;
    /**
     * True for long order, false for short order. Eg. `true`
     * @type {boolean}
     * @memberof GetQuotes200ResponseQuotesInner
     */
    'is_buy': boolean;
    /**
     * 
     * @type {Array<GetQuotes200ResponseQuotesInnerLegsInner>}
     * @memberof GetQuotes200ResponseQuotesInner
     */
    'legs'?: Array<GetQuotes200ResponseQuotesInnerLegsInner>;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInner
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetQuotes200ResponseQuotesInnerLegsInner
 */
export interface GetQuotes200ResponseQuotesInnerLegsInner {
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'side': SideResponse;
    /**
     * Ratio of the instrument leg in decimals. Eg. `1`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'ratio': string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'price': string;
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'asset': string;
    /**
     * Current index price of the asset. Eg. `12.23`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'index_price': string;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'mark_price': string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'expiry'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'strike'?: string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetQuotes200ResponseQuotesInnerLegsInner
     */
    'iv'?: string;
}
/**
 * 
 * @export
 * @interface GetReferralHistory200Response
 */
export interface GetReferralHistory200Response {
    /**
     * total number of rows in a query Eg. `5`
     * @type {string}
     * @memberof GetReferralHistory200Response
     */
    'count': string;
    /**
     * 
     * @type {Array<GetReferralHistory200ResponseReferralHistoryInner>}
     * @memberof GetReferralHistory200Response
     */
    'referral_history'?: Array<GetReferralHistory200ResponseReferralHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetReferralHistory200ResponseReferralHistoryInner
 */
export interface GetReferralHistory200ResponseReferralHistoryInner {
    /**
     * Referee address of a Referrer Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetReferralHistory200ResponseReferralHistoryInner
     */
    'referee': string;
    /**
     * Username of the referrer Eg. `Officially-Evolved-Terrier`
     * @type {string}
     * @memberof GetReferralHistory200ResponseReferralHistoryInner
     */
    'referrer_username'?: string;
    /**
     * Username of the referee of a referrer Eg. `Officially-Evolved-Terrier`
     * @type {string}
     * @memberof GetReferralHistory200ResponseReferralHistoryInner
     */
    'referee_username': string;
    /**
     * Total traded notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetReferralHistory200ResponseReferralHistoryInner
     */
    'total_volume': string;
    /**
     * 24-hour traded notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetReferralHistory200ResponseReferralHistoryInner
     */
    'daily_volume'?: string;
    /**
     * Profit and loss. Signed float string. Eg. `12.23`
     * @type {string}
     * @memberof GetReferralHistory200ResponseReferralHistoryInner
     */
    'pnl'?: string;
    /**
     * Most active trading pair from the last 30 days Eg. `ETH`
     * @type {string}
     * @memberof GetReferralHistory200ResponseReferralHistoryInner
     */
    'thirty_day_active_pair'?: string;
    /**
     * Volume of the most active trading pair from the last 30 days Eg. `13.53`
     * @type {string}
     * @memberof GetReferralHistory200ResponseReferralHistoryInner
     */
    'thirty_day_active_pair_volume'?: string;
    /**
     * Staking tier of an account based on the amount of AEVO staked Eg. `Bronze`
     * @type {string}
     * @memberof GetReferralHistory200ResponseReferralHistoryInner
     */
    'staking_tier'?: string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetReferralHistory200ResponseReferralHistoryInner
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetReferralRewardsHistory200Response
 */
export interface GetReferralRewardsHistory200Response {
    /**
     * total number of rows in a query Eg. `5`
     * @type {string}
     * @memberof GetReferralRewardsHistory200Response
     */
    'count': string;
    /**
     * 
     * @type {Array<GetReferralRewardsHistory200ResponseReferralRewardsHistoryInner>}
     * @memberof GetReferralRewardsHistory200Response
     */
    'referral_rewards_history'?: Array<GetReferralRewardsHistory200ResponseReferralRewardsHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetReferralRewardsHistory200ResponseReferralRewardsHistoryInner
 */
export interface GetReferralRewardsHistory200ResponseReferralRewardsHistoryInner {
    /**
     * Type of reward an account gets Eg. `referral_bonus`
     * @type {string}
     * @memberof GetReferralRewardsHistory200ResponseReferralRewardsHistoryInner
     */
    'reward_type': string;
    /**
     * Rewards for a referral trade Eg. `12.23`
     * @type {string}
     * @memberof GetReferralRewardsHistory200ResponseReferralRewardsHistoryInner
     */
    'rewards': string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetReferralRewardsHistory200ResponseReferralRewardsHistoryInner
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetReferralStatistics200Response
 */
export interface GetReferralStatistics200Response {
    /**
     * Number of users Referrer has referred Eg. `4`
     * @type {string}
     * @memberof GetReferralStatistics200Response
     */
    'referred': string;
    /**
     * Volume in USDC terms. Eg. `12.23`
     * @type {string}
     * @memberof GetReferralStatistics200Response
     */
    'volume': string;
    /**
     * Total amount of rewards earned by an account for being a referrer or referee Eg. `69.2`
     * @type {string}
     * @memberof GetReferralStatistics200Response
     */
    'total_rewards': string;
    /**
     * Total amount of rewards earned by an account for being a referrer Eg. `69.2`
     * @type {string}
     * @memberof GetReferralStatistics200Response
     */
    'total_referral_bonus': string;
    /**
     * Total amount of rewards earned by an account for being a referee Eg. `69.2`
     * @type {string}
     * @memberof GetReferralStatistics200Response
     */
    'total_referee_discount': string;
    /**
     * Total amount of rewards earned by an account for being a referrer or referee that has not been claimed Eg. `69.2`
     * @type {string}
     * @memberof GetReferralStatistics200Response
     */
    'total_rewards_unclaimed': string;
    /**
     * Total amount of rewards earned by an account for being a referrer that has not been claimed Eg. `69.2`
     * @type {string}
     * @memberof GetReferralStatistics200Response
     */
    'total_referral_bonus_unclaimed': string;
    /**
     * Total amount of rewards earned by an account for being a referee that has not been claimed Eg. `69.2`
     * @type {string}
     * @memberof GetReferralStatistics200Response
     */
    'total_referee_discount_unclaimed': string;
    /**
     * Total amount of trading fees rewards earned by an account Eg. `69.2`
     * @type {string}
     * @memberof GetReferralStatistics200Response
     */
    'total_trading_fees_rewards': string;
    /**
     * Total amount of trading fees rewards volume earned by an account Eg. `69.2`
     * @type {string}
     * @memberof GetReferralStatistics200Response
     */
    'total_trading_fees_rewards_volume': string;
}
/**
 * 
 * @export
 * @interface GetRfqs200Response
 */
export interface GetRfqs200Response {
    /**
     * 
     * @type {Array<GetRfqs200ResponseBlocksInner>}
     * @memberof GetRfqs200Response
     */
    'blocks'?: Array<GetRfqs200ResponseBlocksInner>;
}
/**
 * 
 * @export
 * @interface GetRfqs200ResponseBlocksInner
 */
export interface GetRfqs200ResponseBlocksInner {
    /**
     * Block ID is the unique identifier of the block Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInner
     */
    'block_id': string;
    /**
     * 
     * @type {Array<GetRfqs200ResponseBlocksInnerLegsInner>}
     * @memberof GetRfqs200ResponseBlocksInner
     */
    'legs'?: Array<GetRfqs200ResponseBlocksInnerLegsInner>;
    /**
     * 
     * @type {BlockStatusResponse}
     * @memberof GetRfqs200ResponseBlocksInner
     */
    'block_status': BlockStatusResponse;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInner
     */
    'created_timestamp': string;
    /**
     * Deadline of the RFQ block in UNIX timestamp in nanoseconds Eg. `<nil>`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInner
     */
    'deadline': string;
    /**
     * 
     * @type {GetRfqs200ResponseBlocksInnerOrderbook}
     * @memberof GetRfqs200ResponseBlocksInner
     */
    'orderbook'?: GetRfqs200ResponseBlocksInnerOrderbook;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInner
     */
    'mark_price': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInner
     */
    'amount': string;
    /**
     * Allowed increments in contract amount. Eg. `0.1`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInner
     */
    'amount_precision': string;
    /**
     * Full size only if true. Eg. `true`
     * @type {boolean}
     * @memberof GetRfqs200ResponseBlocksInner
     */
    'full_size': boolean;
    /**
     * True for long order, false for short order. Eg. `true`
     * @type {boolean}
     * @memberof GetRfqs200ResponseBlocksInner
     */
    'is_buy'?: boolean;
    /**
     * 
     * @type {RoleResponse}
     * @memberof GetRfqs200ResponseBlocksInner
     */
    'role'?: RoleResponse;
}
/**
 * 
 * @export
 * @interface GetRfqs200ResponseBlocksInnerLegsInner
 */
export interface GetRfqs200ResponseBlocksInnerLegsInner {
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'side': SideResponse;
    /**
     * Ratio of the instrument leg in decimals. Eg. `1`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'ratio': string;
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'asset': string;
    /**
     * Current index price of the asset. Eg. `12.23`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'index_price': string;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'mark_price': string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'expiry'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'strike'?: string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'iv'?: string;
    /**
     * Allowed increments in price. Eg. `0.05`
     * @type {string}
     * @memberof GetRfqs200ResponseBlocksInnerLegsInner
     */
    'price_precision': string;
}
/**
 * 
 * @export
 * @interface GetRfqs200ResponseBlocksInnerOrderbook
 */
export interface GetRfqs200ResponseBlocksInnerOrderbook {
    /**
     * Array of 2 elements, price in USD and contract amount e.g. [1650, 1].
     * @type {Array<Array<string>>}
     * @memberof GetRfqs200ResponseBlocksInnerOrderbook
     */
    'asks'?: Array<Array<string>>;
    /**
     * Array of 2 elements, price in USD and contract amount e.g. [1650, 1].
     * @type {Array<Array<string>>}
     * @memberof GetRfqs200ResponseBlocksInnerOrderbook
     */
    'bids'?: Array<Array<string>>;
}
/**
 * 
 * @export
 * @interface GetRfqsBlockIdQuotes200Response
 */
export interface GetRfqsBlockIdQuotes200Response {
    /**
     * Block ID is the unique identifier of the block Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetRfqsBlockIdQuotes200Response
     */
    'block_id': string;
    /**
     * 
     * @type {Array<GetRfqsBlockIdQuotes200ResponseAsksInner>}
     * @memberof GetRfqsBlockIdQuotes200Response
     */
    'asks'?: Array<GetRfqsBlockIdQuotes200ResponseAsksInner>;
    /**
     * 
     * @type {Array<GetRfqsBlockIdQuotes200ResponseAsksInner>}
     * @memberof GetRfqsBlockIdQuotes200Response
     */
    'bids'?: Array<GetRfqsBlockIdQuotes200ResponseAsksInner>;
}
/**
 * 
 * @export
 * @interface GetRfqsBlockIdQuotes200ResponseAsksInner
 */
export interface GetRfqsBlockIdQuotes200ResponseAsksInner {
    /**
     * Quote ID is the hash of the quote payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetRfqsBlockIdQuotes200ResponseAsksInner
     */
    'quote_id': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetRfqsBlockIdQuotes200ResponseAsksInner
     */
    'amount': string;
    /**
     * True for long order, false for short order. Eg. `true`
     * @type {boolean}
     * @memberof GetRfqsBlockIdQuotes200ResponseAsksInner
     */
    'is_buy': boolean;
    /**
     * Order limit price. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetRfqsBlockIdQuotes200ResponseAsksInner
     */
    'limit_price': string;
    /**
     * 
     * @type {Array<GetRfqsBlockIdQuotes200ResponseAsksInnerLegsInner>}
     * @memberof GetRfqsBlockIdQuotes200ResponseAsksInner
     */
    'legs'?: Array<GetRfqsBlockIdQuotes200ResponseAsksInnerLegsInner>;
    /**
     * 
     * @type {QuoteStatusResponse}
     * @memberof GetRfqsBlockIdQuotes200ResponseAsksInner
     */
    'quote_status': QuoteStatusResponse;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetRfqsBlockIdQuotes200ResponseAsksInner
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetRfqsBlockIdQuotes200ResponseAsksInnerLegsInner
 */
export interface GetRfqsBlockIdQuotes200ResponseAsksInnerLegsInner {
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetRfqsBlockIdQuotes200ResponseAsksInnerLegsInner
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetRfqsBlockIdQuotes200ResponseAsksInnerLegsInner
     */
    'instrument_name': string;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetRfqsBlockIdQuotes200ResponseAsksInnerLegsInner
     */
    'side': SideResponse;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetRfqsBlockIdQuotes200ResponseAsksInnerLegsInner
     */
    'price': string;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetRfqsBlockIdQuotes200ResponseAsksInnerLegsInner
     */
    'iv'?: string;
}
/**
 * 
 * @export
 * @interface GetSettlementHistory200Response
 */
export interface GetSettlementHistory200Response {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetSettlementHistory200Response
     */
    'asset': string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetSettlementHistory200Response
     */
    'expiry': string;
    /**
     * Settlement price at expiry. Eg. `1734.23`
     * @type {string}
     * @memberof GetSettlementHistory200Response
     */
    'settlement_price': string;
    /**
     * Timestamp at which the settlement price is set Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetSettlementHistory200Response
     */
    'settlement_timestamp': string;
}
/**
 * 
 * @export
 * @interface GetSocketCapacity200Response
 */
export interface GetSocketCapacity200Response {
    /**
     * The socket connector address. Eg. `0x2b42AFFD4b7C14d9B7C2579229495c052672Ccd3`
     * @type {string}
     * @memberof GetSocketCapacity200Response
     */
    'socket_connector': string;
    /**
     * The specified chain ID. Eg. `10`
     * @type {string}
     * @memberof GetSocketCapacity200Response
     */
    'chain_id': string;
    /**
     * The withdrawal capacity for a destination chain. Eg. `1000000`
     * @type {string}
     * @memberof GetSocketCapacity200Response
     */
    'capacity': string;
}
/**
 * 
 * @export
 * @interface GetSocketFees200Response
 */
export interface GetSocketFees200Response {
    /**
     * The socket gas fees. Eg. `194670186373086`
     * @type {string}
     * @memberof GetSocketFees200Response
     */
    'socket_fees': string;
}
/**
 * 
 * @export
 * @interface GetStatistics200Response
 */
export interface GetStatistics200Response {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'asset'?: string;
    /**
     * 
     * @type {GetStatistics200ResponseOpenInterest}
     * @memberof GetStatistics200Response
     */
    'open_interest'?: GetStatistics200ResponseOpenInterest;
    /**
     * 24-hour traded notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'daily_volume': string;
    /**
     * 24-hour buy notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'daily_buy_volume': string;
    /**
     * 24-hour sell notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'daily_sell_volume': string;
    /**
     * 24-hour traded premium volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'daily_volume_premium'?: string;
    /**
     * Total traded notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'total_volume'?: string;
    /**
     * Total traded premium volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'total_volume_premium'?: string;
    /**
     * 24-hour traded volume in contract terms. Eg. `1234.5`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'daily_volume_contracts'?: string;
    /**
     * Current index price of the asset. Eg. `12.23`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'index_price'?: string;
    /**
     * 24-hour change in index price of the underlying asset. Eg. `12.52`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'index_daily_change'?: string;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'mark_price'?: string;
    /**
     * Mark price of the instrument from 24-hour ago. Eg. `12.52`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'mark_price_24h_ago'?: string;
    /**
     * 24-hour change in mark price of the instrument. Eg. `12.52`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'mark_daily_change'?: string;
    /**
     * 24-hour average of the funding rate of the instrument. Eg. `12.52`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'funding_daily_avg'?: string;
    /**
     * Put call ratio. Eg. `0.23`
     * @type {string}
     * @memberof GetStatistics200Response
     */
    'put_call_ratio'?: string;
}
/**
 * 
 * @export
 * @interface GetStatistics200ResponseOpenInterest
 */
export interface GetStatistics200ResponseOpenInterest {
    /**
     * Call options open interest in number of contracts. Eg. `1234.56`
     * @type {string}
     * @memberof GetStatistics200ResponseOpenInterest
     */
    'calls'?: string;
    /**
     * Put options open interest in number of contracts. Eg. `1234.56`
     * @type {string}
     * @memberof GetStatistics200ResponseOpenInterest
     */
    'puts'?: string;
    /**
     * Total open interest in number of contracts. Eg. `1234.56`
     * @type {string}
     * @memberof GetStatistics200ResponseOpenInterest
     */
    'total': string;
}
/**
 * 
 * @export
 * @interface GetStatus200Response
 */
export interface GetStatus200Response {
    /**
     * 
     * @type {ExchangeStatusResponse}
     * @memberof GetStatus200Response
     */
    'status': ExchangeStatusResponse;
}
/**
 * 
 * @export
 * @interface GetStrategies200Response
 */
export interface GetStrategies200Response {
    /**
     * 
     * @type {Array<GetStrategies200ResponseStrategiesInner>}
     * @memberof GetStrategies200Response
     */
    'strategies'?: Array<GetStrategies200ResponseStrategiesInner>;
}
/**
 * 
 * @export
 * @interface GetStrategies200ResponseStrategiesInner
 */
export interface GetStrategies200ResponseStrategiesInner {
    /**
     * Address of strategy Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetStrategies200ResponseStrategiesInner
     */
    'strategy_address': string;
    /**
     * Name of strategy Eg. `Covered Calls`
     * @type {string}
     * @memberof GetStrategies200ResponseStrategiesInner
     */
    'strategy_name': string;
    /**
     * 
     * @type {CollateralAssetResponse}
     * @memberof GetStrategies200ResponseStrategiesInner
     */
    'collateral_asset': CollateralAssetResponse;
    /**
     * AUM of a strategy Eg. `12`
     * @type {string}
     * @memberof GetStrategies200ResponseStrategiesInner
     */
    'aum': string;
    /**
     * Past month returns for a strategy Eg. `12.23`
     * @type {string}
     * @memberof GetStrategies200ResponseStrategiesInner
     */
    'past_month_return': string;
    /**
     * Annualized management fee of a yield vault or strategy. Charged regardless of performance. Eg. `0.2`
     * @type {string}
     * @memberof GetStrategies200ResponseStrategiesInner
     */
    'management_fees': string;
    /**
     * Annualized performance fee of a yield vault or strategy. Charged only on profits. Eg. `0.2`
     * @type {string}
     * @memberof GetStrategies200ResponseStrategiesInner
     */
    'performance_fees': string;
    /**
     * Maximum drawdown of a yield vault or strategy YTD Eg. `0.2`
     * @type {string}
     * @memberof GetStrategies200ResponseStrategiesInner
     */
    'max_drawdown': string;
    /**
     * Capacity of a strategy Eg. `12`
     * @type {string}
     * @memberof GetStrategies200ResponseStrategiesInner
     */
    'cap': string;
    /**
     * Minimum deposit into a strategy in the strategy collateral currency Eg. `12.23`
     * @type {string}
     * @memberof GetStrategies200ResponseStrategiesInner
     */
    'minimum_deposit': string;
}
/**
 * 
 * @export
 * @interface GetStrategiesAccount200Response
 */
export interface GetStrategiesAccount200Response {
    /**
     * 
     * @type {Array<GetStrategiesAccount200ResponseStrategyPositionsInner>}
     * @memberof GetStrategiesAccount200Response
     */
    'strategy_positions'?: Array<GetStrategiesAccount200ResponseStrategyPositionsInner>;
    /**
     * 
     * @type {Array<GetStrategiesAccount200ResponseStrategyRewardsInner>}
     * @memberof GetStrategiesAccount200Response
     */
    'strategy_rewards'?: Array<GetStrategiesAccount200ResponseStrategyRewardsInner>;
}
/**
 * 
 * @export
 * @interface GetStrategiesAccount200ResponseStrategyPositionsInner
 */
export interface GetStrategiesAccount200ResponseStrategyPositionsInner {
    /**
     * Address of strategy Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetStrategiesAccount200ResponseStrategyPositionsInner
     */
    'strategy_address': string;
    /**
     * Name of strategy Eg. `Covered Calls`
     * @type {string}
     * @memberof GetStrategiesAccount200ResponseStrategyPositionsInner
     */
    'strategy_name': string;
    /**
     * 
     * @type {CollateralAssetResponse}
     * @memberof GetStrategiesAccount200ResponseStrategyPositionsInner
     */
    'collateral_asset': CollateralAssetResponse;
    /**
     * Pending deposits for a yield vault or strategy Eg. `12`
     * @type {string}
     * @memberof GetStrategiesAccount200ResponseStrategyPositionsInner
     */
    'pending_deposits': string;
    /**
     * Pending withdrawals for a yield vault or strategy Eg. `12`
     * @type {string}
     * @memberof GetStrategiesAccount200ResponseStrategyPositionsInner
     */
    'pending_withdrawals': string;
    /**
     * Amount in shares for a strategy Eg. `12.23`
     * @type {string}
     * @memberof GetStrategiesAccount200ResponseStrategyPositionsInner
     */
    'shares': string;
    /**
     * Price per share of a yield vault or strategy Eg. `1.04`
     * @type {string}
     * @memberof GetStrategiesAccount200ResponseStrategyPositionsInner
     */
    'pps': string;
    /**
     * ROI Eg. `12.23`
     * @type {string}
     * @memberof GetStrategiesAccount200ResponseStrategyPositionsInner
     */
    'roi': string;
}
/**
 * 
 * @export
 * @interface GetStrategiesAccount200ResponseStrategyRewardsInner
 */
export interface GetStrategiesAccount200ResponseStrategyRewardsInner {
    /**
     * Address of strategy Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetStrategiesAccount200ResponseStrategyRewardsInner
     */
    'strategy_address': string;
    /**
     * 
     * @type {Array<GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInner>}
     * @memberof GetStrategiesAccount200ResponseStrategyRewardsInner
     */
    'epoch_rewards'?: Array<GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInner>;
}
/**
 * 
 * @export
 * @interface GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInner
 */
export interface GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInner {
    /**
     * Epoch Eg. `1`
     * @type {string}
     * @memberof GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInner
     */
    'epoch': string;
    /**
     * 
     * @type {GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInnerEpochReward}
     * @memberof GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInner
     */
    'epoch_reward'?: GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInnerEpochReward;
}
/**
 * 
 * @export
 * @interface GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInnerEpochReward
 */
export interface GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInnerEpochReward {
    /**
     * 
     * @type {Array<GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInnerEpochRewardAssetRewardsInner>}
     * @memberof GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInnerEpochReward
     */
    'asset_rewards'?: Array<GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInnerEpochRewardAssetRewardsInner>;
}
/**
 * 
 * @export
 * @interface GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInnerEpochRewardAssetRewardsInner
 */
export interface GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInnerEpochRewardAssetRewardsInner {
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInnerEpochRewardAssetRewardsInner
     */
    'asset': string;
    /**
     * Amount in unsigned float string Eg. `12.23`
     * @type {string}
     * @memberof GetStrategiesAccount200ResponseStrategyRewardsInnerEpochRewardsInnerEpochRewardAssetRewardsInner
     */
    'amount_float': string;
}
/**
 * 
 * @export
 * @interface GetStrategiesAccountHistory200Response
 */
export interface GetStrategiesAccountHistory200Response {
    /**
     * List of [timestamp, price]. Timestamp is in UNIX nanoseconds.
     * @type {Array<Array<string>>}
     * @memberof GetStrategiesAccountHistory200Response
     */
    'history'?: Array<Array<string>>;
}
/**
 * 
 * @export
 * @interface GetStrategyStrategyAddressBalanceHistory200Response
 */
export interface GetStrategyStrategyAddressBalanceHistory200Response {
    /**
     * List of [timestamp, price]. Timestamp is in UNIX nanoseconds.
     * @type {Array<Array<string>>}
     * @memberof GetStrategyStrategyAddressBalanceHistory200Response
     */
    'history'?: Array<Array<string>>;
}
/**
 * 
 * @export
 * @interface GetStrategyStrategyAddressPnlHistory200Response
 */
export interface GetStrategyStrategyAddressPnlHistory200Response {
    /**
     * List of [timestamp, price]. Timestamp is in UNIX nanoseconds.
     * @type {Array<Array<string>>}
     * @memberof GetStrategyStrategyAddressPnlHistory200Response
     */
    'history'?: Array<Array<string>>;
}
/**
 * 
 * @export
 * @interface GetStrategyStrategyAddressPortfolio200Response
 */
export interface GetStrategyStrategyAddressPortfolio200Response {
    /**
     * Balance. Eg. `12.23`
     * @type {string}
     * @memberof GetStrategyStrategyAddressPortfolio200Response
     */
    'balance': string;
    /**
     * Profit and loss. Signed float string. Eg. `12.23`
     * @type {string}
     * @memberof GetStrategyStrategyAddressPortfolio200Response
     */
    'pnl': string;
    /**
     * Realized profit and loss. Signed float string. Eg. `12.23`
     * @type {string}
     * @memberof GetStrategyStrategyAddressPortfolio200Response
     */
    'realized_pnl': string;
    /**
     * Profit Factor. Eg. `1.4`
     * @type {string}
     * @memberof GetStrategyStrategyAddressPortfolio200Response
     */
    'profit_factor': string;
    /**
     * Win rate. Eg. `12.23`
     * @type {string}
     * @memberof GetStrategyStrategyAddressPortfolio200Response
     */
    'win_rate': string;
    /**
     * Sharpe ratio. Eg. `12.23`
     * @type {string}
     * @memberof GetStrategyStrategyAddressPortfolio200Response
     */
    'sharpe_ratio': string;
    /**
     * 
     * @type {Array<GetPortfolio200ResponseGreeksInner>}
     * @memberof GetStrategyStrategyAddressPortfolio200Response
     */
    'greeks'?: Array<GetPortfolio200ResponseGreeksInner>;
    /**
     * 
     * @type {GetPortfolio200ResponseUserMargin}
     * @memberof GetStrategyStrategyAddressPortfolio200Response
     */
    'user_margin'?: GetPortfolio200ResponseUserMargin;
    /**
     * 
     * @type {Array<GetAccount200ResponseCollateralsInner>}
     * @memberof GetStrategyStrategyAddressPortfolio200Response
     */
    'collaterals'?: Array<GetAccount200ResponseCollateralsInner>;
}
/**
 * 
 * @export
 * @interface GetStrategyStrategyAddressPositions200Response
 */
export interface GetStrategyStrategyAddressPositions200Response {
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetStrategyStrategyAddressPositions200Response
     */
    'account': string;
    /**
     * 
     * @type {Array<GetAccount200ResponsePositionsInner>}
     * @memberof GetStrategyStrategyAddressPositions200Response
     */
    'positions'?: Array<GetAccount200ResponsePositionsInner>;
}
/**
 * 
 * @export
 * @interface GetStrategyStrategyAddressTradeHistory200Response
 */
export interface GetStrategyStrategyAddressTradeHistory200Response {
    /**
     * total number of rows in a query Eg. `5`
     * @type {string}
     * @memberof GetStrategyStrategyAddressTradeHistory200Response
     */
    'count': string;
    /**
     * 
     * @type {Array<GetTradeHistory200ResponseTradeHistoryInner>}
     * @memberof GetStrategyStrategyAddressTradeHistory200Response
     */
    'trade_history'?: Array<GetTradeHistory200ResponseTradeHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetStrategyStrategyAddressTransactionHistory200Response
 */
export interface GetStrategyStrategyAddressTransactionHistory200Response {
    /**
     * total number of rows in a query Eg. `5`
     * @type {string}
     * @memberof GetStrategyStrategyAddressTransactionHistory200Response
     */
    'count': string;
    /**
     * 
     * @type {Array<GetTransactionHistory200ResponseTransactionHistoryInner>}
     * @memberof GetStrategyStrategyAddressTransactionHistory200Response
     */
    'transaction_history'?: Array<GetTransactionHistory200ResponseTransactionHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetTime200Response
 */
export interface GetTime200Response {
    /**
     * name Eg. `5732cc1f14e842f393e8cdecb49f02fa`
     * @type {string}
     * @memberof GetTime200Response
     */
    'name': string;
    /**
     * Timestamp in UNIX in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetTime200Response
     */
    'timestamp': string;
    /**
     * ISO string of the current time Eg. `2023-08-24 07:15:51.448450894 +0000 UTC`
     * @type {string}
     * @memberof GetTime200Response
     */
    'time': string;
    /**
     * Sequence of the current time Eg. `1602711444`
     * @type {string}
     * @memberof GetTime200Response
     */
    'sequence': string;
    /**
     * 1366770 Eg. `2023-08-24 07:15:51.448450894 +0000 UTC`
     * @type {string}
     * @memberof GetTime200Response
     */
    'block': string;
}
/**
 * 
 * @export
 * @interface GetTradeFeesCampaignStats200Response
 */
export interface GetTradeFeesCampaignStats200Response {
    /**
     * 
     * @type {Array<GetTradeFeesCampaignStats200ResponseAccountTradeFeesStatsInner>}
     * @memberof GetTradeFeesCampaignStats200Response
     */
    'account_trade_fees_stats'?: Array<GetTradeFeesCampaignStats200ResponseAccountTradeFeesStatsInner>;
}
/**
 * 
 * @export
 * @interface GetTradeFeesCampaignStats200ResponseAccountTradeFeesStatsInner
 */
export interface GetTradeFeesCampaignStats200ResponseAccountTradeFeesStatsInner {
    /**
     * Start of the week Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetTradeFeesCampaignStats200ResponseAccountTradeFeesStatsInner
     */
    'week_start': string;
    /**
     * End of the week Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetTradeFeesCampaignStats200ResponseAccountTradeFeesStatsInner
     */
    'week_end': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetTradeFeesCampaignStats200ResponseAccountTradeFeesStatsInner
     */
    'account': string;
    /**
     * Total trading fees Eg. `1323.45`
     * @type {string}
     * @memberof GetTradeFeesCampaignStats200ResponseAccountTradeFeesStatsInner
     */
    'total_fees': string;
    /**
     * Total traded notional volume in USD terms. Eg. `1234.56`
     * @type {string}
     * @memberof GetTradeFeesCampaignStats200ResponseAccountTradeFeesStatsInner
     */
    'total_volume': string;
    /**
     * Last claim sequence number Eg. `1323.45`
     * @type {string}
     * @memberof GetTradeFeesCampaignStats200ResponseAccountTradeFeesStatsInner
     */
    'last_claim_seq': string;
    /**
     * Total trade count Eg. `1323.45`
     * @type {string}
     * @memberof GetTradeFeesCampaignStats200ResponseAccountTradeFeesStatsInner
     */
    'trade_count': string;
}
/**
 * 
 * @export
 * @interface GetTradeHistory200Response
 */
export interface GetTradeHistory200Response {
    /**
     * total number of rows in a query Eg. `5`
     * @type {string}
     * @memberof GetTradeHistory200Response
     */
    'count': string;
    /**
     * 
     * @type {Array<GetTradeHistory200ResponseTradeHistoryInner>}
     * @memberof GetTradeHistory200Response
     */
    'trade_history'?: Array<GetTradeHistory200ResponseTradeHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetTradeHistory200ResponseTradeHistoryInner
 */
export interface GetTradeHistory200ResponseTradeHistoryInner {
    /**
     * Unique ID of the trade. Eg. `DwmDn5XnEyiqx5AB5CM4W8bgD137ASX4Lz1XWBYqvpX2`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'trade_id': string;
    /**
     * Order ID is the hash of the order payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'order_id'?: string;
    /**
     * 
     * @type {TradeTypeResponse}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'trade_type': TradeTypeResponse;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'account': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'asset': string;
    /**
     * Spot price. Eg. `1802.30`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'spot_price'?: string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'amount': string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'price'?: string;
    /**
     * Average entry price of the position. Eg. `12.23`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'avg_price'?: string;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'mark_price'?: string;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'side': SideResponse;
    /**
     * Fees paid for the trade. Eg. `12.23`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'fees': string;
    /**
     * 
     * @type {LiquidityResponse}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'liquidity'?: LiquidityResponse;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'iv'?: string;
    /**
     * Funding fee rate in decimals. Only applies to funding trade type. Eg. `0.000065`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'fee_rate'?: string;
    /**
     * Profit and loss. Signed float string. Eg. `12.23`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'pnl'?: string;
    /**
     * Settlement payout. Signed float string. Eg. `12.23`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'payout'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'strike'?: string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'expiry'?: string;
    /**
     * 
     * @type {OrderTypeResponse}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'order_type'?: OrderTypeResponse;
    /**
     * Aggressor Order ID. Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'agg_order_id'?: string;
    /**
     * 
     * @type {TradeStatusResponse}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'trade_status'?: TradeStatusResponse;
    /**
     * Settlement price at expiry. Eg. `1734.23`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'settlement_price'?: string;
    /**
     * Liquidation fee. Eg. `86.23`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'liquidation_fee'?: string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'created_timestamp': string;
    /**
     * Average entry price. Eg. `12.23`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'avg_entry_price'?: string;
    /**
     * True if a closing trade. Eg. `false`
     * @type {boolean}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'is_closing'?: boolean;
    /**
     * Farming boost Eg. `12.23`
     * @type {string}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'farm_boost'?: string;
    /**
     * True if an ADL trade. Eg. `false`
     * @type {boolean}
     * @memberof GetTradeHistory200ResponseTradeHistoryInner
     */
    'is_adl'?: boolean;
}
/**
 * 
 * @export
 * @interface GetTransactionHistory200Response
 */
export interface GetTransactionHistory200Response {
    /**
     * total number of rows in a query Eg. `5`
     * @type {string}
     * @memberof GetTransactionHistory200Response
     */
    'count': string;
    /**
     * 
     * @type {Array<GetTransactionHistory200ResponseTransactionHistoryInner>}
     * @memberof GetTransactionHistory200Response
     */
    'transaction_history'?: Array<GetTransactionHistory200ResponseTransactionHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetTransactionHistory200ResponseTransactionHistoryInner
 */
export interface GetTransactionHistory200ResponseTransactionHistoryInner {
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'account': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'amount': string;
    /**
     * Ethereum address of the collateral asset. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'collateral': string;
    /**
     * Counter party address of a transfer transaction. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'counter_party'?: string;
    /**
     * 
     * @type {GetTransactionHistory200ResponseTransactionHistoryInnerTransferDetails}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'transfer_details'?: GetTransactionHistory200ResponseTransactionHistoryInnerTransferDetails;
    /**
     * Timestamp where transaction is finalized in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'finalized_timestamp': string;
    /**
     * Timestamp where transaction is initiated in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'initiated_timestamp': string;
    /**
     * L1 Transaction hash. Eg. `0x4c55895aa6f2dfc2da8189a71a054348ce63abbc1ae27267977e0d9cc6848e91`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'l1_tx_hash': string;
    /**
     * L2 Transaction hash. Eg. `0x4c55895aa6f2dfc2da8189a71a054348ce63abbc1ae27267977e0d9cc6848e91`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'l2_tx_hash': string;
    /**
     * The specified chain ID. Eg. `10`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'chain_id': string;
    /**
     * 
     * @type {TxStatusResponse}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'tx_status': TxStatusResponse;
    /**
     * 
     * @type {TxTypeResponse}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'tx_type': TxTypeResponse;
    /**
     * Transfer label. Eg. `Rewards`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'label'?: string;
    /**
     * Base asset of a collateral swap. Eg. `ETH`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'swap_asset'?: string;
    /**
     * 
     * @type {SideResponse}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'side'?: SideResponse;
    /**
     * Fees paid for the trade. Eg. `12.23`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'fees'?: string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInner
     */
    'price'?: string;
}
/**
 * 
 * @export
 * @interface GetTransactionHistory200ResponseTransactionHistoryInnerTransferDetails
 */
export interface GetTransactionHistory200ResponseTransactionHistoryInnerTransferDetails {
    /**
     * Reward description Eg. `Taker Rewards`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInnerTransferDetails
     */
    'description': string;
    /**
     * Link to details for the reward Eg. `https://app.aevo.xyz`
     * @type {string}
     * @memberof GetTransactionHistory200ResponseTransactionHistoryInnerTransferDetails
     */
    'link': string;
}
/**
 * 
 * @export
 * @interface GetWeeth200Response
 */
export interface GetWeeth200Response {
    /**
     * Total weETH deposits Eg. `<nil>`
     * @type {string}
     * @memberof GetWeeth200Response
     */
    'total_deposits': string;
}
/**
 * 
 * @export
 * @interface GetWithdrawFees200Response
 */
export interface GetWithdrawFees200Response {
    /**
     * 
     * @type {CollateralAssetResponse}
     * @memberof GetWithdrawFees200Response
     */
    'collateral_asset': CollateralAssetResponse;
    /**
     * The specified chain ID. Eg. `10`
     * @type {string}
     * @memberof GetWithdrawFees200Response
     */
    'chain_id': string;
    /**
     * Fees paid for the trade. Eg. `12.23`
     * @type {string}
     * @memberof GetWithdrawFees200Response
     */
    'fees': string;
}
/**
 * 
 * @export
 * @interface GetYieldVault200Response
 */
export interface GetYieldVault200Response {
    /**
     * AUM of a strategy Eg. `12`
     * @type {string}
     * @memberof GetYieldVault200Response
     */
    'aum': string;
    /**
     * Liquid AUM of a strategy Eg. `12`
     * @type {string}
     * @memberof GetYieldVault200Response
     */
    'aum_liquid': string;
    /**
     * Capacity of a strategy Eg. `12`
     * @type {string}
     * @memberof GetYieldVault200Response
     */
    'cap': string;
    /**
     * Price per share of a yield vault or strategy Eg. `1.04`
     * @type {string}
     * @memberof GetYieldVault200Response
     */
    'pps': string;
    /**
     * Annualized Percentage Return of a yield vault or strategy Eg. `12`
     * @type {string}
     * @memberof GetYieldVault200Response
     */
    'apy': string;
    /**
     * Pending withdrawals for a yield vault or strategy Eg. `12`
     * @type {string}
     * @memberof GetYieldVault200Response
     */
    'pending_withdrawals': string;
    /**
     * Pause status of a yield vault or strategy Eg. `false`
     * @type {boolean}
     * @memberof GetYieldVault200Response
     */
    'is_paused': boolean;
}
/**
 * Type of instrument.
 * @export
 * @enum {string}
 */

export const InstrumentType = {
    Option: 'OPTION',
    Perpetual: 'PERPETUAL',
    Spot: 'SPOT'
} as const;

export type InstrumentType = typeof InstrumentType[keyof typeof InstrumentType];


/**
 * Type of instrument. Eg. `OPTION`
 * @export
 * @enum {string}
 */

export const InstrumentTypeResponse = {
    Option: 'OPTION',
    Perpetual: 'PERPETUAL',
    Spot: 'SPOT'
} as const;

export type InstrumentTypeResponse = typeof InstrumentTypeResponse[keyof typeof InstrumentTypeResponse];


/**
 * Taker or maker order type Eg. `maker`
 * @export
 * @enum {string}
 */

export const LiquidityResponse = {
    Maker: 'maker',
    Taker: 'taker'
} as const;

export type LiquidityResponse = typeof LiquidityResponse[keyof typeof LiquidityResponse];


/**
 * The margin type.
 * @export
 * @enum {string}
 */

export const MarginType = {
    Cross: 'CROSS',
    Isolated: 'ISOLATED'
} as const;

export type MarginType = typeof MarginType[keyof typeof MarginType];


/**
 * The margin type. Eg. `CROSS`
 * @export
 * @enum {string}
 */

export const MarginTypeResponse = {
    Cross: 'CROSS',
    Isolated: 'ISOLATED'
} as const;

export type MarginTypeResponse = typeof MarginTypeResponse[keyof typeof MarginTypeResponse];


/**
 * A non-eth network.
 * @export
 * @enum {string}
 */

export const Network = {
    Sol: 'SOL',
    Sui: 'SUI'
} as const;

export type Network = typeof Network[keyof typeof Network];


/**
 * A non-eth network. Eg. `SUI`
 * @export
 * @enum {string}
 */

export const NetworkResponse = {
    Sol: 'SOL',
    Sui: 'SUI'
} as const;

export type NetworkResponse = typeof NetworkResponse[keyof typeof NetworkResponse];


/**
 * Notification type. Eg. ``
 * @export
 * @enum {string}
 */

export const NotificationTypeResponse = {
    Fill: 'fill',
    LiquidationStarted: 'liquidation_started',
    LiquidationCompleted: 'liquidation_completed',
    DepositFinalized: 'deposit_finalized',
    WithdrawalFinalized: 'withdrawal_finalized',
    MmpUpdated: 'mmp_updated',
    MmpUnfrozen: 'mmp_unfrozen',
    MmpTriggered: 'mmp_triggered',
    SendInitiated: 'send_initiated',
    SendFinalized: 'send_finalized',
    Receive: 'receive',
    Referral: 'referral',
    Referee: 'referee',
    Settled: 'settled',
    EmailVerification: 'email_verification',
    FarmBoostApplied: 'farm_boost_applied'
} as const;

export type NotificationTypeResponse = typeof NotificationTypeResponse[keyof typeof NotificationTypeResponse];


/**
 * Type of option contract.
 * @export
 * @enum {string}
 */

export const OptionType = {
    Put: 'put',
    Call: 'call'
} as const;

export type OptionType = typeof OptionType[keyof typeof OptionType];


/**
 * Type of option contract. Eg. `call`
 * @export
 * @enum {string}
 */

export const OptionTypeResponse = {
    Put: 'put',
    Call: 'call'
} as const;

export type OptionTypeResponse = typeof OptionTypeResponse[keyof typeof OptionTypeResponse];


/**
 * Order status. Eg. `filled`
 * @export
 * @enum {string}
 */

export const OrderStatusResponse = {
    Filled: 'filled',
    Partial: 'partial',
    Opened: 'opened',
    Cancelled: 'cancelled',
    Expired: 'expired',
    Rejected: 'rejected',
    StopOrder: 'stop_order'
} as const;

export type OrderStatusResponse = typeof OrderStatusResponse[keyof typeof OrderStatusResponse];


/**
 * Order type. Eg. `limit`
 * @export
 * @enum {string}
 */

export const OrderTypeResponse = {
    Limit: 'limit',
    Market: 'market'
} as const;

export type OrderTypeResponse = typeof OrderTypeResponse[keyof typeof OrderTypeResponse];


/**
 * 
 * @export
 * @interface PostAccountCancelOnDisconnect200Response
 */
export interface PostAccountCancelOnDisconnect200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostAccountCancelOnDisconnect200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostAccountCancelOnDisconnectPayload
 */
export interface PostAccountCancelOnDisconnectPayload {
    /**
     * Enabled if true.
     * @type {boolean}
     * @memberof PostAccountCancelOnDisconnectPayload
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface PostAccountEmailAddress200Response
 */
export interface PostAccountEmailAddress200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostAccountEmailAddress200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostAccountEmailAddressPayload
 */
export interface PostAccountEmailAddressPayload {
    /**
     * Email address of an account.
     * @type {string}
     * @memberof PostAccountEmailAddressPayload
     */
    'email_address': string;
}
/**
 * 
 * @export
 * @interface PostAccountEmailPreference200Response
 */
export interface PostAccountEmailPreference200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostAccountEmailPreference200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostAccountEmailPreferencePayload
 */
export interface PostAccountEmailPreferencePayload {
    /**
     * Email type in an email preferences objject.
     * @type {string}
     * @memberof PostAccountEmailPreferencePayload
     */
    'email_type': string;
    /**
     * Enabled if true.
     * @type {boolean}
     * @memberof PostAccountEmailPreferencePayload
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface PostAccountEmailVerified200Response
 */
export interface PostAccountEmailVerified200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostAccountEmailVerified200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostAccountEmailVerifiedPayload
 */
export interface PostAccountEmailVerifiedPayload {
    /**
     * Account\'s Ethereum address.
     * @type {string}
     * @memberof PostAccountEmailVerifiedPayload
     */
    'account': string;
    /**
     * Authorization Token for email verification
     * @type {string}
     * @memberof PostAccountEmailVerifiedPayload
     */
    'email_auth_token': string;
}
/**
 * 
 * @export
 * @interface PostAccountLeverage200Response
 */
export interface PostAccountLeverage200Response {
    /**
     * 
     * @type {PostAccountMarginType200ResponseSuccess}
     * @memberof PostAccountLeverage200Response
     */
    'success'?: PostAccountMarginType200ResponseSuccess;
}
/**
 * 
 * @export
 * @interface PostAccountLeveragePayload
 */
export interface PostAccountLeveragePayload {
    /**
     * Instrument ID number.
     * @type {number}
     * @memberof PostAccountLeveragePayload
     */
    'instrument': number;
    /**
     * Leverage multiplier for an instrument.
     * @type {number}
     * @memberof PostAccountLeveragePayload
     */
    'leverage': number;
}
/**
 * 
 * @export
 * @interface PostAccountMarginType200Response
 */
export interface PostAccountMarginType200Response {
    /**
     * 
     * @type {PostAccountMarginType200ResponseSuccess}
     * @memberof PostAccountMarginType200Response
     */
    'success'?: PostAccountMarginType200ResponseSuccess;
}
/**
 * 
 * @export
 * @interface PostAccountMarginType200ResponseSuccess
 */
export interface PostAccountMarginType200ResponseSuccess {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostAccountMarginType200ResponseSuccess
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostAccountMarginTypePayload
 */
export interface PostAccountMarginTypePayload {
    /**
     * Instrument ID number.
     * @type {number}
     * @memberof PostAccountMarginTypePayload
     */
    'instrument': number;
    /**
     * 
     * @type {MarginType}
     * @memberof PostAccountMarginTypePayload
     */
    'margin_type': MarginType;
}
/**
 * 
 * @export
 * @interface PostAccountNetworkAddress200Response
 */
export interface PostAccountNetworkAddress200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostAccountNetworkAddress200Response
     */
    'success': boolean;
    /**
     * Account\'s non-eth network address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof PostAccountNetworkAddress200Response
     */
    'network_address': string;
}
/**
 * 
 * @export
 * @interface PostAccountNetworkAddressPayload
 */
export interface PostAccountNetworkAddressPayload {
    /**
     * 
     * @type {Network}
     * @memberof PostAccountNetworkAddressPayload
     */
    'network': Network;
    /**
     * Account\'s non-eth network address.
     * @type {string}
     * @memberof PostAccountNetworkAddressPayload
     */
    'network_address': string;
}
/**
 * 
 * @export
 * @interface PostAccountPortfolioMargin200Response
 */
export interface PostAccountPortfolioMargin200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostAccountPortfolioMargin200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostAccountPortfolioMarginPayload
 */
export interface PostAccountPortfolioMarginPayload {
    /**
     * Enabled if true.
     * @type {boolean}
     * @memberof PostAccountPortfolioMarginPayload
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface PostAccountUnsubscribe200Response
 */
export interface PostAccountUnsubscribe200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostAccountUnsubscribe200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostAccountUnsubscribePayload
 */
export interface PostAccountUnsubscribePayload {
    /**
     * Account\'s Ethereum address.
     * @type {string}
     * @memberof PostAccountUnsubscribePayload
     */
    'account': string;
    /**
     * Authorization Token for email verification
     * @type {string}
     * @memberof PostAccountUnsubscribePayload
     */
    'email_auth_token': string;
}
/**
 * 
 * @export
 * @interface PostAccountUpdateMargin200Response
 */
export interface PostAccountUpdateMargin200Response {
    /**
     * 
     * @type {PostAccountUpdateMargin200ResponseSuccess}
     * @memberof PostAccountUpdateMargin200Response
     */
    'success'?: PostAccountUpdateMargin200ResponseSuccess;
    /**
     * 
     * @type {GetAccount200ResponsePositionsInner}
     * @memberof PostAccountUpdateMargin200Response
     */
    'position'?: GetAccount200ResponsePositionsInner;
}
/**
 * 
 * @export
 * @interface PostAccountUpdateMargin200ResponseSuccess
 */
export interface PostAccountUpdateMargin200ResponseSuccess {
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'instrument_id'?: string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'instrument_name'?: string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'instrument_type'?: InstrumentTypeResponse;
    /**
     * 
     * @type {GetAccount200ResponsePositionsInnerOption}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'option'?: GetAccount200ResponsePositionsInnerOption;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'iv'?: string;
    /**
     * Name of underlying asset. Eg. `ETH`
     * @type {string}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'asset'?: string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'amount'?: string;
    /**
     * 
     * @type {SideResponse}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'side'?: SideResponse;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'mark_price'?: string;
    /**
     * Average entry price. Eg. `12.23`
     * @type {string}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'avg_entry_price'?: string;
    /**
     * Unrealized PNL. Eg. `12.23`
     * @type {string}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'unrealized_pnl'?: string;
    /**
     * Maintenance margin. Eg. `12.23`
     * @type {string}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'maintenance_margin'?: string;
    /**
     * 
     * @type {MarginTypeResponse}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'margin_type'?: MarginTypeResponse;
    /**
     * Liquidation price of the order/position. Eg. `1288.23`
     * @type {string}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'liquidation_price'?: string;
    /**
     * The change in isolated margin assigned to a position. In 6 decimals fixed number. Negative allowed. Eg. `10000000`
     * @type {string}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'isolated_margin'?: string;
    /**
     * The leverage of the position, will be shown if the position is isolated. Eg. `3.5`
     * @type {string}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'leverage'?: string;
    /**
     * 
     * @type {AdlRankResponse}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'adl_rank'?: AdlRankResponse;
    /**
     * 
     * @type {GetAccount200ResponsePositionsInnerClosePositionTriggers}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'closePositionTriggers'?: GetAccount200ResponsePositionsInnerClosePositionTriggers;
    /**
     * 
     * @type {GetAccount200ResponsePositionsInnerPartialPositionTriggers}
     * @memberof PostAccountUpdateMargin200ResponseSuccess
     */
    'partialPositionTriggers'?: GetAccount200ResponsePositionsInnerPartialPositionTriggers;
}
/**
 * 
 * @export
 * @interface PostAccountUpdateMarginPayload
 */
export interface PostAccountUpdateMarginPayload {
    /**
     * Instrument ID number.
     * @type {number}
     * @memberof PostAccountUpdateMarginPayload
     */
    'instrument': number;
    /**
     * The change in isolated margin assigned to a position. In 6 decimals fixed number. Negative allowed.
     * @type {string}
     * @memberof PostAccountUpdateMarginPayload
     */
    'isolated_margin': string;
}
/**
 * 
 * @export
 * @interface PostApiKey200Response
 */
export interface PostApiKey200Response {
    /**
     * name Eg. `5732cc1f14e842f393e8cdecb49f02fa`
     * @type {string}
     * @memberof PostApiKey200Response
     */
    'name': string;
    /**
     * Account\'s API Key. Eg. `URPtt6eNCXgL8ERuchphUretdaga2smF`
     * @type {string}
     * @memberof PostApiKey200Response
     */
    'api_key': string;
    /**
     * Client\'s API Secret Eg. `0140af7046a63530fc4bd319823d6eee98086ef0d446584b42f68b640b60c457`
     * @type {string}
     * @memberof PostApiKey200Response
     */
    'api_secret': string;
    /**
     * Whitelisted client\'s IP address for API access. Eg. `[1.1.1.1 2.2.2.2]`
     * @type {Array<string>}
     * @memberof PostApiKey200Response
     */
    'ip_addresses'?: Array<string>;
    /**
     * API can only access read-only endpoints if true. Eg. `true`
     * @type {boolean}
     * @memberof PostApiKey200Response
     */
    'read_only': boolean;
}
/**
 * 
 * @export
 * @interface PostApiKeyPayload
 */
export interface PostApiKeyPayload {
    /**
     * API key name.
     * @type {string}
     * @memberof PostApiKeyPayload
     */
    'name': string;
    /**
     * Whitelisted client\'s IP address for API access.
     * @type {Array<string>}
     * @memberof PostApiKeyPayload
     */
    'ip_addresses'?: Array<string>;
    /**
     * API can only access read-only endpoints if true.
     * @type {boolean}
     * @memberof PostApiKeyPayload
     */
    'read_only'?: boolean;
}
/**
 * 
 * @export
 * @interface PostCampaignSignUp200Response
 */
export interface PostCampaignSignUp200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostCampaignSignUp200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostCampaignSignUpPayload
 */
export interface PostCampaignSignUpPayload {
    /**
     * The name of a campaign
     * @type {string}
     * @memberof PostCampaignSignUpPayload
     */
    'campaign_name': string;
}
/**
 * 
 * @export
 * @interface PostClaimReferralRewards200Response
 */
export interface PostClaimReferralRewards200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostClaimReferralRewards200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostClaimTradeFees200Response
 */
export interface PostClaimTradeFees200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostClaimTradeFees200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostFarmBoost200Response
 */
export interface PostFarmBoost200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostFarmBoost200Response
     */
    'success': boolean;
    /**
     * Farming boost Eg. `12.23`
     * @type {string}
     * @memberof PostFarmBoost200Response
     */
    'farm_boost': string;
}
/**
 * 
 * @export
 * @interface PostMarkAsRead200Response
 */
export interface PostMarkAsRead200Response {
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof PostMarkAsRead200Response
     */
    'account': string;
    /**
     * Notification read flag. Eg. `true`
     * @type {boolean}
     * @memberof PostMarkAsRead200Response
     */
    'is_read': boolean;
    /**
     * 
     * @type {NotificationTypeResponse}
     * @memberof PostMarkAsRead200Response
     */
    'notification_type': NotificationTypeResponse;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostMarkAsRead200Response
     */
    'created_timestamp': string;
    /**
     * 
     * @type {PostMarkAsRead200ResponseMetadata}
     * @memberof PostMarkAsRead200Response
     */
    'metadata'?: PostMarkAsRead200ResponseMetadata;
}
/**
 * 
 * @export
 * @interface PostMarkAsRead200ResponseMetadata
 */
export interface PostMarkAsRead200ResponseMetadata {
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PostMarkAsRead200ResponseMetadata
     */
    'amount'?: string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof PostMarkAsRead200ResponseMetadata
     */
    'price'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof PostMarkAsRead200ResponseMetadata
     */
    'strike'?: string;
    /**
     * 
     * @type {SideResponse}
     * @memberof PostMarkAsRead200ResponseMetadata
     */
    'side'?: SideResponse;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof PostMarkAsRead200ResponseMetadata
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostMarkAsRead200ResponseMetadata
     */
    'expiry'?: string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof PostMarkAsRead200ResponseMetadata
     */
    'account'?: string;
    /**
     * Ethereum address of the collateral asset. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof PostMarkAsRead200ResponseMetadata
     */
    'collateral'?: string;
    /**
     * Transaction hash. Eg. `0x4c55895aa6f2dfc2da8189a71a054348ce63abbc1ae27267977e0d9cc6848e91`
     * @type {string}
     * @memberof PostMarkAsRead200ResponseMetadata
     */
    'tx_hash'?: string;
    /**
     * Ethereum address to send withdrawals to. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof PostMarkAsRead200ResponseMetadata
     */
    'to'?: string;
    /**
     * Balance. Eg. `12.23`
     * @type {string}
     * @memberof PostMarkAsRead200ResponseMetadata
     */
    'balance'?: string;
}
/**
 * 
 * @export
 * @interface PostMmp200Response
 */
export interface PostMmp200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostMmp200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostMmpPayload
 */
export interface PostMmpPayload {
    /**
     * Interval in seconds. A setting for market maker protection (MMP). If set to 0, MMP is disabled.
     * @type {number}
     * @memberof PostMmpPayload
     */
    'interval': number;
    /**
     * Duration in seconds during which the account will be frozen. If set to 0, manual reset is required.
     * @type {number}
     * @memberof PostMmpPayload
     */
    'frozen': number;
    /**
     * Amount limit setting for market maker protection (MMP). In 6 decimals fixed number.
     * @type {string}
     * @memberof PostMmpPayload
     */
    'amount_limit': string;
    /**
     * Delta limit setting for market maker protection (MMP). In unsigned float.
     * @type {number}
     * @memberof PostMmpPayload
     */
    'delta_limit'?: number;
    /**
     * Name of underlying asset.
     * @type {string}
     * @memberof PostMmpPayload
     */
    'asset': string;
}
/**
 * 
 * @export
 * @interface PostOrders200Response
 */
export interface PostOrders200Response {
    /**
     * Order ID is the hash of the order payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'order_id': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'account': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof PostOrders200Response
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {OrderTypeResponse}
     * @memberof PostOrders200Response
     */
    'order_type': OrderTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof PostOrders200Response
     */
    'side': SideResponse;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'amount': string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'price': string;
    /**
     * Average entry price of the position. Eg. `12.23`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'avg_price': string;
    /**
     * Amount filled. Eg. `12.23`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'filled': string;
    /**
     * 
     * @type {OrderStatusResponse}
     * @memberof PostOrders200Response
     */
    'order_status': OrderStatusResponse;
    /**
     * True for post-only maker orders, false for standard orders. Eg. `false`
     * @type {boolean}
     * @memberof PostOrders200Response
     */
    'post_only'?: boolean;
    /**
     * True for reduce-only orders, false for standard orders. Eg. `false`
     * @type {boolean}
     * @memberof PostOrders200Response
     */
    'reduce_only'?: boolean;
    /**
     * Margin required to keep an open order. Eg. `12.23`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'initial_margin'?: string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof PostOrders200Response
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'iv'?: string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'expiry'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'strike'?: string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'created_timestamp'?: string;
    /**
     * Timestamp in UNIX in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'timestamp': string;
    /**
     * 
     * @type {SystemTypeResponse}
     * @memberof PostOrders200Response
     */
    'system_type': SystemTypeResponse;
    /**
     * 
     * @type {TimeInForceResponse}
     * @memberof PostOrders200Response
     */
    'time_in_force'?: TimeInForceResponse;
    /**
     * 
     * @type {StopResponse}
     * @memberof PostOrders200Response
     */
    'stop'?: StopResponse;
    /**
     * The price to trigger the stop order at. `stop` is required when `trigger` is specified. Eg. `1836.74`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'trigger'?: string;
    /**
     * Is order a close position TPSL order. Eg. `true`
     * @type {boolean}
     * @memberof PostOrders200Response
     */
    'close_position'?: boolean;
    /**
     * Is order a partial position TPSL order. Eg. `false`
     * @type {boolean}
     * @memberof PostOrders200Response
     */
    'partial_position'?: boolean;
    /**
     * The change in isolated margin assigned to a position. In 6 decimals fixed number. Negative allowed. Eg. `10000000`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'isolated_margin'?: string;
    /**
     * Order ID of the order which when cancelled, cancels this order as well Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PostOrders200Response
     */
    'parent_order_id'?: string;
    /**
     * 
     * @type {SelfTradePreventionResponse}
     * @memberof PostOrders200Response
     */
    'self_trade_prevention'?: SelfTradePreventionResponse;
}
/**
 * 
 * @export
 * @interface PostOrdersOrderId200Response
 */
export interface PostOrdersOrderId200Response {
    /**
     * Order ID is the hash of the order payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'order_id': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'account': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof PostOrdersOrderId200Response
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {OrderTypeResponse}
     * @memberof PostOrdersOrderId200Response
     */
    'order_type': OrderTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof PostOrdersOrderId200Response
     */
    'side': SideResponse;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'amount': string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'price': string;
    /**
     * Average entry price of the position. Eg. `12.23`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'avg_price': string;
    /**
     * Amount filled. Eg. `12.23`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'filled': string;
    /**
     * 
     * @type {OrderStatusResponse}
     * @memberof PostOrdersOrderId200Response
     */
    'order_status': OrderStatusResponse;
    /**
     * True for post-only maker orders, false for standard orders. Eg. `false`
     * @type {boolean}
     * @memberof PostOrdersOrderId200Response
     */
    'post_only'?: boolean;
    /**
     * True for reduce-only orders, false for standard orders. Eg. `false`
     * @type {boolean}
     * @memberof PostOrdersOrderId200Response
     */
    'reduce_only'?: boolean;
    /**
     * Margin required to keep an open order. Eg. `12.23`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'initial_margin'?: string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof PostOrdersOrderId200Response
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'iv'?: string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'expiry'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'strike'?: string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'created_timestamp'?: string;
    /**
     * Timestamp in UNIX in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'timestamp': string;
    /**
     * 
     * @type {SystemTypeResponse}
     * @memberof PostOrdersOrderId200Response
     */
    'system_type': SystemTypeResponse;
    /**
     * 
     * @type {TimeInForceResponse}
     * @memberof PostOrdersOrderId200Response
     */
    'time_in_force'?: TimeInForceResponse;
    /**
     * 
     * @type {StopResponse}
     * @memberof PostOrdersOrderId200Response
     */
    'stop'?: StopResponse;
    /**
     * The price to trigger the stop order at. `stop` is required when `trigger` is specified. Eg. `1836.74`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'trigger'?: string;
    /**
     * Is order a close position TPSL order. Eg. `true`
     * @type {boolean}
     * @memberof PostOrdersOrderId200Response
     */
    'close_position'?: boolean;
    /**
     * Is order a partial position TPSL order. Eg. `false`
     * @type {boolean}
     * @memberof PostOrdersOrderId200Response
     */
    'partial_position'?: boolean;
    /**
     * The change in isolated margin assigned to a position. In 6 decimals fixed number. Negative allowed. Eg. `10000000`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'isolated_margin'?: string;
    /**
     * Order ID of the order which when cancelled, cancels this order as well Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PostOrdersOrderId200Response
     */
    'parent_order_id'?: string;
    /**
     * 
     * @type {SelfTradePreventionResponse}
     * @memberof PostOrdersOrderId200Response
     */
    'self_trade_prevention'?: SelfTradePreventionResponse;
}
/**
 * 
 * @export
 * @interface PostOrdersOrderIdPayload
 */
export interface PostOrdersOrderIdPayload {
    /**
     * Instrument ID number.
     * @type {number}
     * @memberof PostOrdersOrderIdPayload
     */
    'instrument': number;
    /**
     * Account\'s Ethereum address.
     * @type {string}
     * @memberof PostOrdersOrderIdPayload
     */
    'maker': string;
    /**
     * True for long order, false for short order.
     * @type {boolean}
     * @memberof PostOrdersOrderIdPayload
     */
    'is_buy': boolean;
    /**
     * Number of contracts. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostOrdersOrderIdPayload
     */
    'amount': string;
    /**
     * Order limit price. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostOrdersOrderIdPayload
     */
    'limit_price': string;
    /**
     * A randomly generated number to guarantee transaction uniqueness. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostOrdersOrderIdPayload
     */
    'salt': string;
    /**
     * Hash of order payload signature signed by the account.
     * @type {string}
     * @memberof PostOrdersOrderIdPayload
     */
    'signature': string;
    /**
     * Timestamp used in order signing in UNIX timestamp in seconds.
     * @type {string}
     * @memberof PostOrdersOrderIdPayload
     */
    'timestamp': string;
    /**
     * True for post-only maker orders, false for standard orders.
     * @type {boolean}
     * @memberof PostOrdersOrderIdPayload
     */
    'post_only'?: boolean;
    /**
     * True for reduce-only orders, false for standard orders.
     * @type {boolean}
     * @memberof PostOrdersOrderIdPayload
     */
    'reduce_only'?: boolean;
    /**
     * 
     * @type {TimeInForce}
     * @memberof PostOrdersOrderIdPayload
     */
    'time_in_force'?: TimeInForce;
    /**
     * Flag to include order into MMP.
     * @type {boolean}
     * @memberof PostOrdersOrderIdPayload
     */
    'mmp'?: boolean;
    /**
     * 
     * @type {Stop}
     * @memberof PostOrdersOrderIdPayload
     */
    'stop'?: Stop;
    /**
     * The price to trigger the stop order at. `stop` is required when `trigger` is specified.
     * @type {string}
     * @memberof PostOrdersOrderIdPayload
     */
    'trigger'?: string;
    /**
     * Is order a close position TPSL order.
     * @type {boolean}
     * @memberof PostOrdersOrderIdPayload
     */
    'close_position'?: boolean;
    /**
     * Is order a partial position TPSL order.
     * @type {boolean}
     * @memberof PostOrdersOrderIdPayload
     */
    'partial_position'?: boolean;
    /**
     * Order ID of the order which when cancelled, cancels this order as well
     * @type {string}
     * @memberof PostOrdersOrderIdPayload
     */
    'parent_order_id'?: string;
    /**
     * 
     * @type {SelfTradePrevention}
     * @memberof PostOrdersOrderIdPayload
     */
    'self_trade_prevention'?: SelfTradePrevention;
    /**
     * 
     * @type {SystemType}
     * @memberof PostOrdersOrderIdPayload
     */
    'system_type'?: SystemType;
}
/**
 * 
 * @export
 * @interface PostOrdersPayload
 */
export interface PostOrdersPayload {
    /**
     * Instrument ID number.
     * @type {number}
     * @memberof PostOrdersPayload
     */
    'instrument': number;
    /**
     * Account\'s Ethereum address.
     * @type {string}
     * @memberof PostOrdersPayload
     */
    'maker': string;
    /**
     * True for long order, false for short order.
     * @type {boolean}
     * @memberof PostOrdersPayload
     */
    'is_buy': boolean;
    /**
     * Number of contracts. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostOrdersPayload
     */
    'amount': string;
    /**
     * Order limit price. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostOrdersPayload
     */
    'limit_price': string;
    /**
     * A randomly generated number to guarantee transaction uniqueness. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostOrdersPayload
     */
    'salt': string;
    /**
     * Hash of order payload signature signed by the account.
     * @type {string}
     * @memberof PostOrdersPayload
     */
    'signature': string;
    /**
     * Timestamp used in order signing in UNIX timestamp in seconds.
     * @type {string}
     * @memberof PostOrdersPayload
     */
    'timestamp': string;
    /**
     * True for post-only maker orders, false for standard orders.
     * @type {boolean}
     * @memberof PostOrdersPayload
     */
    'post_only'?: boolean;
    /**
     * True for reduce-only orders, false for standard orders.
     * @type {boolean}
     * @memberof PostOrdersPayload
     */
    'reduce_only'?: boolean;
    /**
     * 
     * @type {TimeInForce}
     * @memberof PostOrdersPayload
     */
    'time_in_force'?: TimeInForce;
    /**
     * Flag to include order into MMP.
     * @type {boolean}
     * @memberof PostOrdersPayload
     */
    'mmp'?: boolean;
    /**
     * 
     * @type {Stop}
     * @memberof PostOrdersPayload
     */
    'stop'?: Stop;
    /**
     * The price to trigger the stop order at. `stop` is required when `trigger` is specified.
     * @type {string}
     * @memberof PostOrdersPayload
     */
    'trigger'?: string;
    /**
     * Is order a close position TPSL order.
     * @type {boolean}
     * @memberof PostOrdersPayload
     */
    'close_position'?: boolean;
    /**
     * Is order a partial position TPSL order.
     * @type {boolean}
     * @memberof PostOrdersPayload
     */
    'partial_position'?: boolean;
    /**
     * Order ID of the order which when cancelled, cancels this order as well
     * @type {string}
     * @memberof PostOrdersPayload
     */
    'parent_order_id'?: string;
    /**
     * 
     * @type {SelfTradePrevention}
     * @memberof PostOrdersPayload
     */
    'self_trade_prevention'?: SelfTradePrevention;
    /**
     * 
     * @type {SystemType}
     * @memberof PostOrdersPayload
     */
    'system_type'?: SystemType;
}
/**
 * 
 * @export
 * @interface PostOtcCreateRequest200Response
 */
export interface PostOtcCreateRequest200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostOtcCreateRequest200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostOtcCreateRequestPayload
 */
export interface PostOtcCreateRequestPayload {
    /**
     * Name of underlying asset.
     * @type {string}
     * @memberof PostOtcCreateRequestPayload
     */
    'asset'?: string;
    /**
     * Option strike price.
     * @type {string}
     * @memberof PostOtcCreateRequestPayload
     */
    'strike'?: string;
    /**
     * Signing key expiry in UNIX timestamp in seconds.
     * @type {string}
     * @memberof PostOtcCreateRequestPayload
     */
    'expiry'?: string;
    /**
     * 
     * @type {OptionType}
     * @memberof PostOtcCreateRequestPayload
     */
    'option_type'?: OptionType;
    /**
     * Number of contracts. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostOtcCreateRequestPayload
     */
    'amount': string;
    /**
     * Indicative price of the otc request
     * @type {string}
     * @memberof PostOtcCreateRequestPayload
     */
    'indicative_price': string;
    /**
     * Otc id of position to unwind.
     * @type {number}
     * @memberof PostOtcCreateRequestPayload
     */
    'unwind_id'?: number;
}
/**
 * 
 * @export
 * @interface PostOtcUnwind200Response
 */
export interface PostOtcUnwind200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostOtcUnwind200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostOtcUnwindPayload
 */
export interface PostOtcUnwindPayload {
    /**
     * Unique ID of the otc request
     * @type {number}
     * @memberof PostOtcUnwindPayload
     */
    'otc_id': number;
}
/**
 * 
 * @export
 * @interface PostQuotes200Response
 */
export interface PostQuotes200Response {
    /**
     * Block ID is the unique identifier of the block Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PostQuotes200Response
     */
    'block_id': string;
    /**
     * Quote ID is the hash of the quote payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PostQuotes200Response
     */
    'quote_id': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PostQuotes200Response
     */
    'amount': string;
    /**
     * Margin required to keep an open order. Eg. `12.23`
     * @type {string}
     * @memberof PostQuotes200Response
     */
    'initial_margin': string;
    /**
     * Amount filled. Eg. `12.23`
     * @type {string}
     * @memberof PostQuotes200Response
     */
    'filled': string;
    /**
     * Order limit price. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PostQuotes200Response
     */
    'limit_price': string;
    /**
     * 
     * @type {QuoteStatusResponse}
     * @memberof PostQuotes200Response
     */
    'quote_status': QuoteStatusResponse;
    /**
     * 
     * @type {Array<GetQuotes200ResponseQuotesInnerLegsInner>}
     * @memberof PostQuotes200Response
     */
    'legs'?: Array<GetQuotes200ResponseQuotesInnerLegsInner>;
    /**
     * Average entry price of the position. Eg. `12.23`
     * @type {string}
     * @memberof PostQuotes200Response
     */
    'avg_price'?: string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostQuotes200Response
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface PostQuotesPayload
 */
export interface PostQuotesPayload {
    /**
     * Block ID is the unique identifier of the block
     * @type {string}
     * @memberof PostQuotesPayload
     */
    'block_id': string;
    /**
     * Account\'s Ethereum address.
     * @type {string}
     * @memberof PostQuotesPayload
     */
    'account': string;
    /**
     * Number of contracts. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostQuotesPayload
     */
    'amount': string;
    /**
     * True for long order, false for short order.
     * @type {boolean}
     * @memberof PostQuotesPayload
     */
    'is_buy': boolean;
    /**
     * A randomly generated number to guarantee transaction uniqueness. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostQuotesPayload
     */
    'salt': string;
    /**
     * Timestamp used in order signing in UNIX timestamp in seconds.
     * @type {string}
     * @memberof PostQuotesPayload
     */
    'timestamp': string;
    /**
     * Hash of order payload signature signed by the account.
     * @type {string}
     * @memberof PostQuotesPayload
     */
    'signature': string;
    /**
     * 
     * @type {Array<PostQuotesPayloadLegsInner>}
     * @memberof PostQuotesPayload
     */
    'legs'?: Array<PostQuotesPayloadLegsInner>;
    /**
     * Order limit price. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostQuotesPayload
     */
    'limit_price'?: string;
    /**
     * 
     * @type {SystemType}
     * @memberof PostQuotesPayload
     */
    'system_type'?: SystemType;
}
/**
 * 
 * @export
 * @interface PostQuotesPayloadLegsInner
 */
export interface PostQuotesPayloadLegsInner {
    /**
     * Instrument ID number.
     * @type {number}
     * @memberof PostQuotesPayloadLegsInner
     */
    'instrument': number;
    /**
     * Order limit price. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostQuotesPayloadLegsInner
     */
    'price': string;
}
/**
 * 
 * @export
 * @interface PostQuotesPreview200Response
 */
export interface PostQuotesPreview200Response {
    /**
     * Block ID is the unique identifier of the block Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PostQuotesPreview200Response
     */
    'block_id': string;
    /**
     * Quote ID is the hash of the quote payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PostQuotesPreview200Response
     */
    'quote_id': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PostQuotesPreview200Response
     */
    'amount': string;
    /**
     * Margin required to keep an open order. Eg. `12.23`
     * @type {string}
     * @memberof PostQuotesPreview200Response
     */
    'initial_margin': string;
    /**
     * Amount filled. Eg. `12.23`
     * @type {string}
     * @memberof PostQuotesPreview200Response
     */
    'filled': string;
    /**
     * Order limit price. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PostQuotesPreview200Response
     */
    'limit_price': string;
    /**
     * 
     * @type {QuoteStatusResponse}
     * @memberof PostQuotesPreview200Response
     */
    'quote_status': QuoteStatusResponse;
    /**
     * 
     * @type {Array<GetQuotes200ResponseQuotesInnerLegsInner>}
     * @memberof PostQuotesPreview200Response
     */
    'legs'?: Array<GetQuotes200ResponseQuotesInnerLegsInner>;
    /**
     * Average entry price of the position. Eg. `12.23`
     * @type {string}
     * @memberof PostQuotesPreview200Response
     */
    'avg_price'?: string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostQuotesPreview200Response
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface PostQuotesPreviewPayload
 */
export interface PostQuotesPreviewPayload {
    /**
     * Block ID is the unique identifier of the block
     * @type {string}
     * @memberof PostQuotesPreviewPayload
     */
    'block_id': string;
    /**
     * Account\'s Ethereum address.
     * @type {string}
     * @memberof PostQuotesPreviewPayload
     */
    'account': string;
    /**
     * Number of contracts. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostQuotesPreviewPayload
     */
    'amount': string;
    /**
     * True for long order, false for short order.
     * @type {boolean}
     * @memberof PostQuotesPreviewPayload
     */
    'is_buy': boolean;
    /**
     * A randomly generated number to guarantee transaction uniqueness. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostQuotesPreviewPayload
     */
    'salt': string;
    /**
     * Timestamp used in order signing in UNIX timestamp in seconds.
     * @type {string}
     * @memberof PostQuotesPreviewPayload
     */
    'timestamp': string;
    /**
     * Hash of order payload signature signed by the account.
     * @type {string}
     * @memberof PostQuotesPreviewPayload
     */
    'signature': string;
    /**
     * 
     * @type {Array<PostQuotesPayloadLegsInner>}
     * @memberof PostQuotesPreviewPayload
     */
    'legs'?: Array<PostQuotesPayloadLegsInner>;
    /**
     * Order limit price. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostQuotesPreviewPayload
     */
    'limit_price'?: string;
    /**
     * 
     * @type {SystemType}
     * @memberof PostQuotesPreviewPayload
     */
    'system_type'?: SystemType;
}
/**
 * 
 * @export
 * @interface PostRegister200Response
 */
export interface PostRegister200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostRegister200Response
     */
    'success': boolean;
    /**
     * 
     * @type {Array<PostRegister200ResponseSigningKeysInner>}
     * @memberof PostRegister200Response
     */
    'signing_keys'?: Array<PostRegister200ResponseSigningKeysInner>;
    /**
     * Account\'s API Key. Eg. `URPtt6eNCXgL8ERuchphUretdaga2smF`
     * @type {string}
     * @memberof PostRegister200Response
     */
    'api_key': string;
    /**
     * Client\'s API Secret Eg. `0140af7046a63530fc4bd319823d6eee98086ef0d446584b42f68b640b60c457`
     * @type {string}
     * @memberof PostRegister200Response
     */
    'api_secret': string;
    /**
     * API can only access read-only endpoints if true. Eg. `true`
     * @type {boolean}
     * @memberof PostRegister200Response
     */
    'read_only': boolean;
}
/**
 * 
 * @export
 * @interface PostRegister200ResponseSigningKeysInner
 */
export interface PostRegister200ResponseSigningKeysInner {
    /**
     * Ethereum address of the signing key. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof PostRegister200ResponseSigningKeysInner
     */
    'signing_key': string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostRegister200ResponseSigningKeysInner
     */
    'expiry': string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostRegister200ResponseSigningKeysInner
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface PostRegisterPayload
 */
export interface PostRegisterPayload {
    /**
     * Account\'s Ethereum address.
     * @type {string}
     * @memberof PostRegisterPayload
     */
    'account': string;
    /**
     * Ethereum address of the signing key.
     * @type {string}
     * @memberof PostRegisterPayload
     */
    'signing_key': string;
    /**
     * Signing key expiry in UNIX timestamp in seconds.
     * @type {string}
     * @memberof PostRegisterPayload
     */
    'expiry': string;
    /**
     * Hash of EIP-712 signature signed by the account.
     * @type {string}
     * @memberof PostRegisterPayload
     */
    'account_signature': string;
    /**
     * Hash of EIP-712 signature signed by the signing key.
     * @type {string}
     * @memberof PostRegisterPayload
     */
    'signing_key_signature': string;
    /**
     * Referral Code (username of referrer) of the new account registration
     * @type {string}
     * @memberof PostRegisterPayload
     */
    'referral_code'?: string;
    /**
     * If registering without creating an api key
     * @type {boolean}
     * @memberof PostRegisterPayload
     */
    'no_api_key'?: boolean;
}
/**
 * 
 * @export
 * @interface PostResetMmp200Response
 */
export interface PostResetMmp200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostResetMmp200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostResetMmpPayload
 */
export interface PostResetMmpPayload {
    /**
     * Name of underlying asset.
     * @type {string}
     * @memberof PostResetMmpPayload
     */
    'asset': string;
}
/**
 * 
 * @export
 * @interface PostRfqs200Response
 */
export interface PostRfqs200Response {
    /**
     * 
     * @type {Array<PostRfqs200ResponseBlocksInner>}
     * @memberof PostRfqs200Response
     */
    'blocks'?: Array<PostRfqs200ResponseBlocksInner>;
}
/**
 * 
 * @export
 * @interface PostRfqs200ResponseBlocksInner
 */
export interface PostRfqs200ResponseBlocksInner {
    /**
     * Block ID is the unique identifier of the block Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PostRfqs200ResponseBlocksInner
     */
    'block_id': string;
    /**
     * 
     * @type {Array<GetRfqs200ResponseBlocksInnerLegsInner>}
     * @memberof PostRfqs200ResponseBlocksInner
     */
    'legs'?: Array<GetRfqs200ResponseBlocksInnerLegsInner>;
    /**
     * 
     * @type {BlockStatusResponse}
     * @memberof PostRfqs200ResponseBlocksInner
     */
    'block_status': BlockStatusResponse;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostRfqs200ResponseBlocksInner
     */
    'created_timestamp': string;
    /**
     * Deadline of the RFQ block in UNIX timestamp in nanoseconds Eg. `<nil>`
     * @type {string}
     * @memberof PostRfqs200ResponseBlocksInner
     */
    'deadline': string;
    /**
     * 
     * @type {PostRfqs200ResponseBlocksInnerOrderbook}
     * @memberof PostRfqs200ResponseBlocksInner
     */
    'orderbook'?: PostRfqs200ResponseBlocksInnerOrderbook;
    /**
     * Mark price of the instrument. Eg. `12.23`
     * @type {string}
     * @memberof PostRfqs200ResponseBlocksInner
     */
    'mark_price': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PostRfqs200ResponseBlocksInner
     */
    'amount': string;
    /**
     * Allowed increments in contract amount. Eg. `0.1`
     * @type {string}
     * @memberof PostRfqs200ResponseBlocksInner
     */
    'amount_precision': string;
    /**
     * Full size only if true. Eg. `true`
     * @type {boolean}
     * @memberof PostRfqs200ResponseBlocksInner
     */
    'full_size': boolean;
    /**
     * True for long order, false for short order. Eg. `true`
     * @type {boolean}
     * @memberof PostRfqs200ResponseBlocksInner
     */
    'is_buy': boolean;
    /**
     * 
     * @type {RoleResponse}
     * @memberof PostRfqs200ResponseBlocksInner
     */
    'role'?: RoleResponse;
}
/**
 * 
 * @export
 * @interface PostRfqs200ResponseBlocksInnerOrderbook
 */
export interface PostRfqs200ResponseBlocksInnerOrderbook {
    /**
     * Array of 3 elements, price in USD, contract amount, and IV respectively.
     * @type {Array<Array<string>>}
     * @memberof PostRfqs200ResponseBlocksInnerOrderbook
     */
    'bids'?: Array<Array<string>>;
    /**
     * Array of 3 elements, price in USD, contract amount, and IV respectively.
     * @type {Array<Array<string>>}
     * @memberof PostRfqs200ResponseBlocksInnerOrderbook
     */
    'asks'?: Array<Array<string>>;
}
/**
 * 
 * @export
 * @interface PostRfqsPayload
 */
export interface PostRfqsPayload {
    /**
     * 
     * @type {Array<PostRfqsPayloadLegsInner>}
     * @memberof PostRfqsPayload
     */
    'legs'?: Array<PostRfqsPayloadLegsInner>;
    /**
     * Full size only if true.
     * @type {boolean}
     * @memberof PostRfqsPayload
     */
    'full_size'?: boolean;
    /**
     * True for long order, false for short order.
     * @type {boolean}
     * @memberof PostRfqsPayload
     */
    'is_buy'?: boolean;
    /**
     * Number of contracts. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostRfqsPayload
     */
    'amount'?: string;
    /**
     * Duration of the RFQ block in seconds
     * @type {number}
     * @memberof PostRfqsPayload
     */
    'duration'?: number;
    /**
     * List of counterparties allowed to quote for the RFQ block
     * @type {Array<string>}
     * @memberof PostRfqsPayload
     */
    'counterparties'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PostRfqsPayloadLegsInner
 */
export interface PostRfqsPayloadLegsInner {
    /**
     * Instrument ID number.
     * @type {number}
     * @memberof PostRfqsPayloadLegsInner
     */
    'instrument': number;
    /**
     * True for long order, false for short order.
     * @type {boolean}
     * @memberof PostRfqsPayloadLegsInner
     */
    'is_buy': boolean;
    /**
     * Ratio of the instrument leg in decimals.
     * @type {number}
     * @memberof PostRfqsPayloadLegsInner
     */
    'ratio': number;
}
/**
 * 
 * @export
 * @interface PostStrategyStrategyAddressInitiateWithdraw200Response
 */
export interface PostStrategyStrategyAddressInitiateWithdraw200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostStrategyStrategyAddressInitiateWithdraw200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostStrategyStrategyAddressInitiateWithdrawPayload
 */
export interface PostStrategyStrategyAddressInitiateWithdrawPayload {
    /**
     * 
     * @type {CollateralAsset}
     * @memberof PostStrategyStrategyAddressInitiateWithdrawPayload
     */
    'collateral_asset': CollateralAsset;
    /**
     * Amount in unsigned float string
     * @type {string}
     * @memberof PostStrategyStrategyAddressInitiateWithdrawPayload
     */
    'amount_float': string;
}
/**
 * 
 * @export
 * @interface PostSwap200Response
 */
export interface PostSwap200Response {
    /**
     * Order ID is the hash of the order payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'order_id': string;
    /**
     * Account\'s Ethereum address. Eg. `0xE9b3a48d15BE316A8e34FAd53fFDFDddf0C3D24b`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'account': string;
    /**
     * Instrument ID number. Eg. `12`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'instrument_id': string;
    /**
     * Instrument name. Eg. `ETH-30JUN23-1600-C`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'instrument_name': string;
    /**
     * 
     * @type {InstrumentTypeResponse}
     * @memberof PostSwap200Response
     */
    'instrument_type': InstrumentTypeResponse;
    /**
     * 
     * @type {OrderTypeResponse}
     * @memberof PostSwap200Response
     */
    'order_type': OrderTypeResponse;
    /**
     * 
     * @type {SideResponse}
     * @memberof PostSwap200Response
     */
    'side': SideResponse;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'amount': string;
    /**
     * Limit price for the order. Eg. `12.34`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'price': string;
    /**
     * Average entry price of the position. Eg. `12.23`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'avg_price': string;
    /**
     * Amount filled. Eg. `12.23`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'filled': string;
    /**
     * 
     * @type {OrderStatusResponse}
     * @memberof PostSwap200Response
     */
    'order_status': OrderStatusResponse;
    /**
     * True for post-only maker orders, false for standard orders. Eg. `false`
     * @type {boolean}
     * @memberof PostSwap200Response
     */
    'post_only'?: boolean;
    /**
     * True for reduce-only orders, false for standard orders. Eg. `false`
     * @type {boolean}
     * @memberof PostSwap200Response
     */
    'reduce_only'?: boolean;
    /**
     * Margin required to keep an open order. Eg. `12.23`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'initial_margin'?: string;
    /**
     * 
     * @type {OptionTypeResponse}
     * @memberof PostSwap200Response
     */
    'option_type'?: OptionTypeResponse;
    /**
     * Option\'s implied volatility. Eg. `0.23`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'iv'?: string;
    /**
     * Option expiry in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'expiry'?: string;
    /**
     * Option strike price. Eg. `2500`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'strike'?: string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'created_timestamp'?: string;
    /**
     * Timestamp in UNIX in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'timestamp': string;
    /**
     * 
     * @type {SystemTypeResponse}
     * @memberof PostSwap200Response
     */
    'system_type': SystemTypeResponse;
    /**
     * 
     * @type {TimeInForceResponse}
     * @memberof PostSwap200Response
     */
    'time_in_force'?: TimeInForceResponse;
    /**
     * 
     * @type {StopResponse}
     * @memberof PostSwap200Response
     */
    'stop'?: StopResponse;
    /**
     * The price to trigger the stop order at. `stop` is required when `trigger` is specified. Eg. `1836.74`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'trigger'?: string;
    /**
     * Is order a close position TPSL order. Eg. `true`
     * @type {boolean}
     * @memberof PostSwap200Response
     */
    'close_position'?: boolean;
    /**
     * Is order a partial position TPSL order. Eg. `false`
     * @type {boolean}
     * @memberof PostSwap200Response
     */
    'partial_position'?: boolean;
    /**
     * The change in isolated margin assigned to a position. In 6 decimals fixed number. Negative allowed. Eg. `10000000`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'isolated_margin'?: string;
    /**
     * Order ID of the order which when cancelled, cancels this order as well Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PostSwap200Response
     */
    'parent_order_id'?: string;
    /**
     * 
     * @type {SelfTradePreventionResponse}
     * @memberof PostSwap200Response
     */
    'self_trade_prevention'?: SelfTradePreventionResponse;
}
/**
 * 
 * @export
 * @interface PostSwapPayload
 */
export interface PostSwapPayload {
    /**
     * 
     * @type {CollateralAsset}
     * @memberof PostSwapPayload
     */
    'collateral_asset': CollateralAsset;
    /**
     * True for long order, false for short order.
     * @type {boolean}
     * @memberof PostSwapPayload
     */
    'is_buy': boolean;
    /**
     * The collateral amount. In 6 decimals fixed number for USDT, 18 decimals for WETH, and 8 decimals for WBTC.
     * @type {string}
     * @memberof PostSwapPayload
     */
    'base_amount'?: string;
    /**
     * Amount of USDC. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostSwapPayload
     */
    'quote_amount'?: string;
}
/**
 * 
 * @export
 * @interface PostSwapPreview200Response
 */
export interface PostSwapPreview200Response {
    /**
     * Amount of USDC. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PostSwapPreview200Response
     */
    'quote_amount': string;
    /**
     * Fees paid for the trade. Eg. `12.23`
     * @type {string}
     * @memberof PostSwapPreview200Response
     */
    'fees': string;
    /**
     * Funding fee rate in decimals. Only applies to funding trade type. Eg. `0.000065`
     * @type {string}
     * @memberof PostSwapPreview200Response
     */
    'fee_rate': string;
    /**
     * The collateral balance. Eg. `12.23`
     * @type {string}
     * @memberof PostSwapPreview200Response
     */
    'base_balance': string;
    /**
     * The USDC balance. Eg. `12.23`
     * @type {string}
     * @memberof PostSwapPreview200Response
     */
    'quote_balance': string;
    /**
     * The collateral swap capacity balance. Eg. `12.23`
     * @type {string}
     * @memberof PostSwapPreview200Response
     */
    'base_capacity': string;
    /**
     * The USDC swap capacity balance. Eg. `12.23`
     * @type {string}
     * @memberof PostSwapPreview200Response
     */
    'quote_capacity': string;
    /**
     * The base amount Eg. `1`
     * @type {string}
     * @memberof PostSwapPreview200Response
     */
    'amount': string;
    /**
     * The price Eg. `1982`
     * @type {string}
     * @memberof PostSwapPreview200Response
     */
    'price': string;
}
/**
 * 
 * @export
 * @interface PostSwapPreviewPayload
 */
export interface PostSwapPreviewPayload {
    /**
     * 
     * @type {CollateralAsset}
     * @memberof PostSwapPreviewPayload
     */
    'collateral_asset': CollateralAsset;
    /**
     * True for long order, false for short order.
     * @type {boolean}
     * @memberof PostSwapPreviewPayload
     */
    'is_buy'?: boolean;
    /**
     * The collateral amount. In 6 decimals fixed number for USDT, 18 decimals for WETH, and 8 decimals for WBTC.
     * @type {string}
     * @memberof PostSwapPreviewPayload
     */
    'base_amount'?: string;
    /**
     * Amount of USDC. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostSwapPreviewPayload
     */
    'quote_amount'?: string;
}
/**
 * 
 * @export
 * @interface PostTransfer200Response
 */
export interface PostTransfer200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostTransfer200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostTransferPayload
 */
export interface PostTransferPayload {
    /**
     * Account\'s Ethereum address.
     * @type {string}
     * @memberof PostTransferPayload
     */
    'account': string;
    /**
     * Ethereum address of the collateral asset.
     * @type {string}
     * @memberof PostTransferPayload
     */
    'collateral': string;
    /**
     * Ethereum address to send withdrawals to.
     * @type {string}
     * @memberof PostTransferPayload
     */
    'to': string;
    /**
     * Amount in USDC. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostTransferPayload
     */
    'amount': string;
    /**
     * A randomly generated number to guarantee transaction uniqueness. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostTransferPayload
     */
    'salt': string;
    /**
     * Hash of order payload signature signed by the account.
     * @type {string}
     * @memberof PostTransferPayload
     */
    'signature': string;
    /**
     * Transfer label.
     * @type {string}
     * @memberof PostTransferPayload
     */
    'label'?: string;
    /**
     * Transfer reference id.
     * @type {string}
     * @memberof PostTransferPayload
     */
    'referenceId'?: string;
}
/**
 * 
 * @export
 * @interface PostWithdraw200Response
 */
export interface PostWithdraw200Response {
    /**
     * Request successful if true. Eg. `true`
     * @type {boolean}
     * @memberof PostWithdraw200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface PostWithdrawPayload
 */
export interface PostWithdrawPayload {
    /**
     * Account\'s Ethereum address.
     * @type {string}
     * @memberof PostWithdrawPayload
     */
    'account': string;
    /**
     * Ethereum address of the collateral asset.
     * @type {string}
     * @memberof PostWithdrawPayload
     */
    'collateral': string;
    /**
     * Ethereum address to send withdrawals to.
     * @type {string}
     * @memberof PostWithdrawPayload
     */
    'to': string;
    /**
     * Amount in USDC. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostWithdrawPayload
     */
    'amount': string;
    /**
     * A randomly generated number to guarantee transaction uniqueness. In 6 decimals fixed number.
     * @type {string}
     * @memberof PostWithdrawPayload
     */
    'salt': string;
    /**
     * Hash of order payload signature signed by the account.
     * @type {string}
     * @memberof PostWithdrawPayload
     */
    'signature': string;
    /**
     * A recipient account\'s Ethereum address.
     * @type {string}
     * @memberof PostWithdrawPayload
     */
    'recipient'?: string;
    /**
     * The socket gas fees.
     * @type {string}
     * @memberof PostWithdrawPayload
     */
    'socket_fees'?: string;
    /**
     * The socket message gas limit.
     * @type {string}
     * @memberof PostWithdrawPayload
     */
    'socket_msg_gas_limit'?: string;
    /**
     * The socket connector address.
     * @type {string}
     * @memberof PostWithdrawPayload
     */
    'socket_connector'?: string;
}
/**
 * 
 * @export
 * @interface PutQuotesQuoteId200Response
 */
export interface PutQuotesQuoteId200Response {
    /**
     * Block ID is the unique identifier of the block Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PutQuotesQuoteId200Response
     */
    'block_id': string;
    /**
     * Quote ID is the hash of the quote payload Eg. `0x4c43e0ab72a4edb72dfe4b129148899815d816837b9a7e22d964b884834639f8`
     * @type {string}
     * @memberof PutQuotesQuoteId200Response
     */
    'quote_id': string;
    /**
     * Number of contracts. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PutQuotesQuoteId200Response
     */
    'amount': string;
    /**
     * Margin required to keep an open order. Eg. `12.23`
     * @type {string}
     * @memberof PutQuotesQuoteId200Response
     */
    'initial_margin': string;
    /**
     * Amount filled. Eg. `12.23`
     * @type {string}
     * @memberof PutQuotesQuoteId200Response
     */
    'filled': string;
    /**
     * Order limit price. In 6 decimals fixed number. Eg. `1000000`
     * @type {string}
     * @memberof PutQuotesQuoteId200Response
     */
    'limit_price': string;
    /**
     * 
     * @type {QuoteStatusResponse}
     * @memberof PutQuotesQuoteId200Response
     */
    'quote_status': QuoteStatusResponse;
    /**
     * 
     * @type {Array<GetQuotes200ResponseQuotesInnerLegsInner>}
     * @memberof PutQuotesQuoteId200Response
     */
    'legs'?: Array<GetQuotes200ResponseQuotesInnerLegsInner>;
    /**
     * Average entry price of the position. Eg. `12.23`
     * @type {string}
     * @memberof PutQuotesQuoteId200Response
     */
    'avg_price'?: string;
    /**
     * Created timestamp in UNIX timestamp in nanoseconds. Eg. `1680249600000000000`
     * @type {string}
     * @memberof PutQuotesQuoteId200Response
     */
    'created_timestamp': string;
}
/**
 * 
 * @export
 * @interface PutQuotesQuoteIdPayload
 */
export interface PutQuotesQuoteIdPayload {
    /**
     * Block ID is the unique identifier of the block
     * @type {string}
     * @memberof PutQuotesQuoteIdPayload
     */
    'block_id': string;
    /**
     * Account\'s Ethereum address.
     * @type {string}
     * @memberof PutQuotesQuoteIdPayload
     */
    'account': string;
    /**
     * Number of contracts. In 6 decimals fixed number.
     * @type {string}
     * @memberof PutQuotesQuoteIdPayload
     */
    'amount': string;
    /**
     * True for long order, false for short order.
     * @type {boolean}
     * @memberof PutQuotesQuoteIdPayload
     */
    'is_buy': boolean;
    /**
     * A randomly generated number to guarantee transaction uniqueness. In 6 decimals fixed number.
     * @type {string}
     * @memberof PutQuotesQuoteIdPayload
     */
    'salt': string;
    /**
     * Timestamp used in order signing in UNIX timestamp in seconds.
     * @type {string}
     * @memberof PutQuotesQuoteIdPayload
     */
    'timestamp': string;
    /**
     * Hash of order payload signature signed by the account.
     * @type {string}
     * @memberof PutQuotesQuoteIdPayload
     */
    'signature': string;
    /**
     * 
     * @type {Array<PostQuotesPayloadLegsInner>}
     * @memberof PutQuotesQuoteIdPayload
     */
    'legs'?: Array<PostQuotesPayloadLegsInner>;
    /**
     * Order limit price. In 6 decimals fixed number.
     * @type {string}
     * @memberof PutQuotesQuoteIdPayload
     */
    'limit_price'?: string;
    /**
     * 
     * @type {SystemType}
     * @memberof PutQuotesQuoteIdPayload
     */
    'system_type'?: SystemType;
}
/**
 * Quote status. Eg. `filled`
 * @export
 * @enum {string}
 */

export const QuoteStatusResponse = {
    Filled: 'filled',
    Partial: 'partial',
    Opened: 'opened',
    Cancelled: 'cancelled',
    Rejected: 'rejected'
} as const;

export type QuoteStatusResponse = typeof QuoteStatusResponse[keyof typeof QuoteStatusResponse];


/**
 * Role of the account Eg. `maker`
 * @export
 * @enum {string}
 */

export const RoleResponse = {
    Taker: 'taker',
    Maker: 'maker'
} as const;

export type RoleResponse = typeof RoleResponse[keyof typeof RoleResponse];


/**
 * Can be set to EXPIRE_NONE, EXPIRE_MAKER OR EXPIRE_TAKER (EXPIRE_NONE is set by default)
 * @export
 * @enum {string}
 */

export const SelfTradePrevention = {
    None: 'EXPIRE_NONE',
    Taker: 'EXPIRE_TAKER',
    Maker: 'EXPIRE_MAKER'
} as const;

export type SelfTradePrevention = typeof SelfTradePrevention[keyof typeof SelfTradePrevention];


/**
 * Can be set to EXPIRE_NONE, EXPIRE_MAKER OR EXPIRE_TAKER (EXPIRE_NONE is set by default) Eg. `EXPIRE_NONE`
 * @export
 * @enum {string}
 */

export const SelfTradePreventionResponse = {
    None: 'EXPIRE_NONE',
    Taker: 'EXPIRE_TAKER',
    Maker: 'EXPIRE_MAKER'
} as const;

export type SelfTradePreventionResponse = typeof SelfTradePreventionResponse[keyof typeof SelfTradePreventionResponse];


/**
 * Trade side. Eg. `buy`
 * @export
 * @enum {string}
 */

export const SideResponse = {
    Buy: 'buy',
    Sell: 'sell'
} as const;

export type SideResponse = typeof SideResponse[keyof typeof SideResponse];


/**
 * Type of stop order.
 * @export
 * @enum {string}
 */

export const Stop = {
    StopLoss: 'STOP_LOSS',
    TakeProfit: 'TAKE_PROFIT'
} as const;

export type Stop = typeof Stop[keyof typeof Stop];


/**
 * Type of stop order. Eg. `STOP_LOSS`
 * @export
 * @enum {string}
 */

export const StopResponse = {
    StopLoss: 'STOP_LOSS',
    TakeProfit: 'TAKE_PROFIT'
} as const;

export type StopResponse = typeof StopResponse[keyof typeof StopResponse];


/**
 * Type of stop order. Eg. `STOP_LOSS`
 * @export
 * @enum {string}
 */

export const StopTypeResponse = {
    StopLoss: 'STOP_LOSS',
    TakeProfit: 'TAKE_PROFIT'
} as const;

export type StopTypeResponse = typeof StopTypeResponse[keyof typeof StopTypeResponse];


/**
 * Can be set to API or WEB (API is set by default)
 * @export
 * @enum {string}
 */

export const SystemType = {
    Api: 'API',
    Web: 'WEB'
} as const;

export type SystemType = typeof SystemType[keyof typeof SystemType];


/**
 * Can be set to API or WEB (API is set by default) Eg. `API`
 * @export
 * @enum {string}
 */

export const SystemTypeResponse = {
    Api: 'API',
    Web: 'WEB'
} as const;

export type SystemTypeResponse = typeof SystemTypeResponse[keyof typeof SystemTypeResponse];


/**
 * Can be set to GTC or IOC (GTC is set by default)
 * @export
 * @enum {string}
 */

export const TimeInForce = {
    Gtc: 'GTC',
    Ioc: 'IOC'
} as const;

export type TimeInForce = typeof TimeInForce[keyof typeof TimeInForce];


/**
 * Can be set to GTC or IOC (GTC is set by default) Eg. `GTC`
 * @export
 * @enum {string}
 */

export const TimeInForceResponse = {
    Gtc: 'GTC',
    Ioc: 'IOC'
} as const;

export type TimeInForceResponse = typeof TimeInForceResponse[keyof typeof TimeInForceResponse];


/**
 * Trade status. Eg. `filled`
 * @export
 * @enum {string}
 */

export const TradeStatusResponse = {
    Filled: 'filled',
    Partial: 'partial'
} as const;

export type TradeStatusResponse = typeof TradeStatusResponse[keyof typeof TradeStatusResponse];


/**
 * Type of user trade. Eg. `trade`
 * @export
 * @enum {string}
 */

export const TradeTypeResponse = {
    Trade: 'trade',
    Liquidation: 'liquidation',
    Settlement: 'settlement',
    Funding: 'funding'
} as const;

export type TradeTypeResponse = typeof TradeTypeResponse[keyof typeof TradeTypeResponse];


/**
 * Transaction status. Eg. `initiated`
 * @export
 * @enum {string}
 */

export const TxStatusResponse = {
    Initiated: 'initiated',
    Finalized: 'finalized'
} as const;

export type TxStatusResponse = typeof TxStatusResponse[keyof typeof TxStatusResponse];


/**
 * Type of user transaction. Eg. `deposit`
 * @export
 * @enum {string}
 */

export const TxTypeResponse = {
    Deposit: 'deposit',
    Withdraw: 'withdraw',
    Send: 'send',
    Receive: 'receive',
    Swap: 'swap',
    YvDeposit: 'yv_deposit',
    YvWithdraw: 'yv_withdraw'
} as const;

export type TxTypeResponse = typeof TxTypeResponse[keyof typeof TxTypeResponse];



/**
 * PrivateAPIApi - axios parameter creator
 * @export
 */
export const PrivateAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the account\'s API key. This logs out the account.
         * @summary DELETE /api-key
         * @param {DeleteApiKeyPayload} [deleteApiKeyPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey: async (deleteApiKeyPayload?: DeleteApiKeyPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteApiKeyPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel all orders. Optionally, you can specify an asset and instrument type to cancel only orders for that asset/instrument type.
         * @summary DELETE /orders-all
         * @param {DeleteOrdersAllPayload} [deleteOrdersAllPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrdersAll: async (deleteOrdersAllPayload?: DeleteOrdersAllPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteOrdersAllPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancels an order.
         * @summary DELETE /orders/{order_id}
         * @param {string} orderId Order ID is the hash of the order payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrdersOrderId: async (orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('deleteOrdersOrderId', 'orderId', orderId)
            const localVarPath = `/orders/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel multiple quotes.
         * @summary DELETE /quotes
         * @param {Array<string>} [quoteIds] List of quote IDs.
         * @param {string} [blockId] Block ID is the unique identifier of the block
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuotes: async (quoteIds?: Array<string>, blockId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (quoteIds) {
                localVarQueryParameter['quote_ids'] = quoteIds;
            }

            if (blockId !== undefined) {
                localVarQueryParameter['block_id'] = blockId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancels an quote.
         * @summary DELETE /quotes/{quote_id}
         * @param {string} quoteId Quote ID is the hash of the quote payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuotesQuoteId: async (quoteId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('deleteQuotesQuoteId', 'quoteId', quoteId)
            const localVarPath = `/quotes/{quote_id}`
                .replace(`{${"quote_id"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel all blocks.
         * @summary DELETE /rfqs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRfqs: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rfqs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Close an RFQ block
         * @summary DELETE /rfqs/{block_id}
         * @param {string} blockId Block ID is the unique identifier of the block
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRfqsBlockId: async (blockId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blockId' is not null or undefined
            assertParamExists('deleteRfqsBlockId', 'blockId', blockId)
            const localVarPath = `/rfqs/{block_id}`
                .replace(`{${"block_id"}}`, encodeURIComponent(String(blockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the account\'s signing key. This logs out the account.
         * @summary DELETE /signing-key
         * @param {DeleteSigningKeyPayload} [deleteSigningKeyPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSigningKey: async (deleteSigningKeyPayload?: DeleteSigningKeyPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/signing-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSigningKeyPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the account\'s information including API keys, signing keys and positions.
         * @summary GET /account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the accumulated funding for your account\'s positions.
         * @summary GET /account/accumulated-fundings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccumulatedFundings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/accumulated-fundings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check the Cancel on Disconnect (CoD) setting for your account.
         * @summary GET /account/cancel-on-disconnect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCancelOnDisconnect: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/cancel-on-disconnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check the Email Address for your account.
         * @summary GET /account/email-address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountEmailAddress: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/email-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check the email preferences for your account.
         * @summary GET /account/email-preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountEmailPreferences: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/email-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if an account\'s email is verified.
         * @summary GET /account/email-verified
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountEmailVerified: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/email-verified`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the account\'s statistics of volume and pnl
         * @summary GET /account/stats
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {string} [asset] Name of underlying asset.
         * @param {string} [campaignName] The name of a campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountStats: async (startTime?: number, endTime?: number, asset?: string, campaignName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }

            if (campaignName !== undefined) {
                localVarQueryParameter['campaign_name'] = campaignName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns account\'s trade history in CSV format
         * @summary GET /account/trades/csv
         * @param {Array<'trade' | 'liquidation' | 'settlement' | 'funding'>} tradeTypes Type of user trade.
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountTradesCsv: async (tradeTypes: Array<'trade' | 'liquidation' | 'settlement' | 'funding'>, startTime: number, endTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tradeTypes' is not null or undefined
            assertParamExists('getAccountTradesCsv', 'tradeTypes', tradeTypes)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getAccountTradesCsv', 'startTime', startTime)
            const localVarPath = `/account/trades/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (tradeTypes) {
                localVarQueryParameter['trade_types'] = tradeTypes;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns account\'s transactions history in CSV format
         * @summary GET /account/transactions/csv
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountTransactionsCsv: async (startTime: number, endTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getAccountTransactionsCsv', 'startTime', startTime)
            const localVarPath = `/account/transactions/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Analytics for authenticated accounts
         * @summary INTERNAL GET /analytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalytics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the API key information.
         * @summary GET /api-key
         * @param {string} apiKey Account\&#39;s API Key.
         * @param {string} timestamp Timestamp in UNIX in nanoseconds.
         * @param {string} signature Hash of order payload signature signed by the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKey: async (apiKey: string, timestamp: string, signature: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKey' is not null or undefined
            assertParamExists('getApiKey', 'apiKey', apiKey)
            // verify required parameter 'timestamp' is not null or undefined
            assertParamExists('getApiKey', 'timestamp', timestamp)
            // verify required parameter 'signature' is not null or undefined
            assertParamExists('getApiKey', 'signature', signature)
            const localVarPath = `/api-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiKey !== undefined) {
                localVarQueryParameter['api_key'] = apiKey;
            }

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns true if the given headers has valid authentication
         * @summary GET /auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuth: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the account\'s balance history.
         * @summary INTERNAL GET /balance-history
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceHistory: async (startTime: number, endTime?: number, resolution?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getBalanceHistory', 'startTime', startTime)
            const localVarPath = `/balance-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (resolution !== undefined) {
                localVarQueryParameter['resolution'] = resolution;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the account\'s block history.
         * @summary INTERNAL GET /block-history
         * @param {string} [blockId] Block ID is the unique identifier of the block
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockHistory: async (blockId?: string, startTime?: number, endTime?: number, sortOrder?: 'ASC' | 'DESC', limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/block-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (blockId !== undefined) {
                localVarQueryParameter['block_id'] = blockId;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the account\'s block trade history.
         * @summary INTERNAL GET /block-trade-history
         * @param {string} [blockId] Block ID is the unique identifier of the block
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockTradeHistory: async (blockId?: string, startTime?: number, endTime?: number, sortOrder?: 'ASC' | 'DESC', limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/block-trade-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (blockId !== undefined) {
                localVarQueryParameter['block_id'] = blockId;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns current farm boost, avg farm boost, and boosted volume
         * @summary GET /farm-boost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmBoost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/farm-boost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns L1 withdrawal capacity for each collateral.
         * @summary INTERNAL GET /l1/capacity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getL1Capacity: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/l1/capacity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the leaderboard for a campaign by pnl in descending order
         * @summary GET /leaderboard/campaign
         * @param {string} username Account\&#39;s auto-generated username based on their Ethereum address.
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} endTime Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderboardCampaign: async (username: string, startTime: number, endTime: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getLeaderboardCampaign', 'username', username)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getLeaderboardCampaign', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getLeaderboardCampaign', 'endTime', endTime)
            const localVarPath = `/leaderboard/campaign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the margin requirement.
         * @summary INTERNAL GET /margin
         * @param {number} instrumentId Instrument ID number.
         * @param {boolean} isBuy True for long order, false for short order.
         * @param {string} limitPrice Order limit price. In 6 decimals fixed number.
         * @param {string} amount Number of contracts. In 6 decimals fixed number.
         * @param {string} [orderId] Order ID is the hash of the order payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMargin: async (instrumentId: number, isBuy: boolean, limitPrice: string, amount: string, orderId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instrumentId' is not null or undefined
            assertParamExists('getMargin', 'instrumentId', instrumentId)
            // verify required parameter 'isBuy' is not null or undefined
            assertParamExists('getMargin', 'isBuy', isBuy)
            // verify required parameter 'limitPrice' is not null or undefined
            assertParamExists('getMargin', 'limitPrice', limitPrice)
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('getMargin', 'amount', amount)
            const localVarPath = `/margin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (instrumentId !== undefined) {
                localVarQueryParameter['instrument_id'] = instrumentId;
            }

            if (isBuy !== undefined) {
                localVarQueryParameter['is_buy'] = isBuy;
            }

            if (limitPrice !== undefined) {
                localVarQueryParameter['limit_price'] = limitPrice;
            }

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['order_id'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get market maker protection (MMP) setting.
         * @summary GET /mmp
         * @param {string} asset Name of underlying asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMmp: async (asset: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asset' is not null or undefined
            assertParamExists('getMmp', 'asset', asset)
            const localVarPath = `/mmp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the account\'s notification history.
         * @summary INTERNAL GET /notifications
         * @param {boolean} [unread] Filter by unread only
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (unread?: boolean, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (unread !== undefined) {
                localVarQueryParameter['unread'] = unread;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns order history for the account.
         * @summary GET /order-history
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderHistory: async (startTime: number, endTime?: number, limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getOrderHistory', 'startTime', startTime)
            const localVarPath = `/order-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns stop order history for the account.
         * @summary GET /order-history/stops
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderHistoryStops: async (startTime: number, endTime?: number, limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getOrderHistoryStops', 'startTime', startTime)
            const localVarPath = `/order-history/stops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all account\'s orders.
         * @summary GET /orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the order details.
         * @summary GET /orders/{order_id}
         * @param {string} orderId Order ID is the hash of the order payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersOrderId: async (orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrdersOrderId', 'orderId', orderId)
            const localVarPath = `/orders/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the account\'s otc details
         * @summary GET /otc/account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtcAccount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/otc/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the overall portfolio details of the account.
         * @summary GET /portfolio
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolio: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the account\'s positions
         * @summary GET /positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns account\'s proof data
         * @summary GET /proof-data
         * @param {'airdrop' | 'rewards' | 'zero'} jsonName Json name of proof account wants to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProofData: async (jsonName: 'airdrop' | 'rewards' | 'zero', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jsonName' is not null or undefined
            assertParamExists('getProofData', 'jsonName', jsonName)
            const localVarPath = `/proof-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (jsonName !== undefined) {
                localVarQueryParameter['json_name'] = jsonName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns account\'s proof data
         * @summary GET /proofs-data
         * @param {Array<string>} assets Array of assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProofsData: async (assets: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assets' is not null or undefined
            assertParamExists('getProofsData', 'assets', assets)
            const localVarPath = `/proofs-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (assets) {
                localVarQueryParameter['assets'] = assets;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the account\'s quote history.
         * @summary INTERNAL GET /quote-history
         * @param {string} [quoteId] Quote ID is the hash of the quote payload
         * @param {string} [blockId] Block ID is the unique identifier of the block
         * @param {'taker' | 'maker'} [role] Role of the account
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuoteHistory: async (quoteId?: string, blockId?: string, role?: 'taker' | 'maker', startTime?: number, endTime?: number, sortOrder?: 'ASC' | 'DESC', limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quote-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (quoteId !== undefined) {
                localVarQueryParameter['quote_id'] = quoteId;
            }

            if (blockId !== undefined) {
                localVarQueryParameter['block_id'] = blockId;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all account\'s quotes.
         * @summary GET /quotes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuotes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the account\'s referral history.
         * @summary GET /referral-history
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralHistory: async (limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/referral-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the account\'s referral rewards history.
         * @summary GET /referral-rewards-history
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralRewardsHistory: async (limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/referral-rewards-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the account\'s referral statistics.
         * @summary GET /referral-statistics
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralStatistics: async (startTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/referral-statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get RFQ blocks open for trading.
         * @summary GET /rfqs
         * @param {'taker' | 'maker'} [role] Role of the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRfqs: async (role?: 'taker' | 'maker', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rfqs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the quotes for a given RFQ block.
         * @summary GET /rfqs/{block_id}/quotes
         * @param {string} blockId Block ID is the unique identifier of the block
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRfqsBlockIdQuotes: async (blockId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blockId' is not null or undefined
            assertParamExists('getRfqsBlockIdQuotes', 'blockId', blockId)
            const localVarPath = `/rfqs/{block_id}/quotes`
                .replace(`{${"block_id"}}`, encodeURIComponent(String(blockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns socket withdrawal capacity for each destination chain.
         * @summary INTERNAL GET /socket/capacity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocketCapacity: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/socket/capacity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns socket fee for the deposit or withdrawal.
         * @summary INTERNAL GET /socket/fees
         * @param {number} chainId The specified chain ID.
         * @param {string} socketConnector The socket connector address.
         * @param {string} socketAddress The socket address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocketFees: async (chainId: number, socketConnector: string, socketAddress: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chainId' is not null or undefined
            assertParamExists('getSocketFees', 'chainId', chainId)
            // verify required parameter 'socketConnector' is not null or undefined
            assertParamExists('getSocketFees', 'socketConnector', socketConnector)
            // verify required parameter 'socketAddress' is not null or undefined
            assertParamExists('getSocketFees', 'socketAddress', socketAddress)
            const localVarPath = `/socket/fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (chainId !== undefined) {
                localVarQueryParameter['chain_id'] = chainId;
            }

            if (socketConnector !== undefined) {
                localVarQueryParameter['socket_connector'] = socketConnector;
            }

            if (socketAddress !== undefined) {
                localVarQueryParameter['socket_address'] = socketAddress;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the account\'s strategy positions
         * @summary GET /strategies/account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategiesAccount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/strategies/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the account\'s strategy equity history
         * @summary GET /strategies/account-history
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategiesAccountHistory: async (startTime: number, endTime?: number, resolution?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getStrategiesAccountHistory', 'startTime', startTime)
            const localVarPath = `/strategies/account-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (resolution !== undefined) {
                localVarQueryParameter['resolution'] = resolution;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the account\'s trading fee statistics.
         * @summary GET /trade-fees-campaign-stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeFeesCampaignStats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trade-fees-campaign-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the account\'s trade history.
         * @summary GET /trade-history
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {string} [asset] Name of underlying asset.
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {Array<'trade' | 'liquidation' | 'settlement' | 'funding'>} [tradeTypes] Type of user trade.
         * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
         * @param {'put' | 'call'} [optionType] Type of option contract.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {boolean} [agg] Aggregates trades if set to true.
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeHistory: async (startTime: number, asset?: string, endTime?: number, tradeTypes?: Array<'trade' | 'liquidation' | 'settlement' | 'funding'>, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', optionType?: 'put' | 'call', limit?: number, agg?: boolean, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getTradeHistory', 'startTime', startTime)
            const localVarPath = `/trade-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (tradeTypes) {
                localVarQueryParameter['trade_types'] = tradeTypes;
            }

            if (instrumentType !== undefined) {
                localVarQueryParameter['instrument_type'] = instrumentType;
            }

            if (optionType !== undefined) {
                localVarQueryParameter['option_type'] = optionType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (agg !== undefined) {
                localVarQueryParameter['agg'] = agg;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the account\'s deposit and withdraw history.
         * @summary GET /transaction-history
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw'} [txType] Type of user transaction.
         * @param {'initiated' | 'finalized'} [txStatus] Transaction status.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistory: async (startTime?: number, endTime?: number, txType?: 'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw', txStatus?: 'initiated' | 'finalized', limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transaction-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (txType !== undefined) {
                localVarQueryParameter['tx_type'] = txType;
            }

            if (txStatus !== undefined) {
                localVarQueryParameter['tx_status'] = txStatus;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the withdrawal fees for each chain and asset.
         * @summary INTERNAL GET /withdraw/fees
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawFees: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/withdraw/fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enables or disables the Cancel on Disconnect (CoD) setting for your account. When CoD is enabled, when a websocket connection is closed, all orders placed via that connection will be cancelled.
         * @summary POST /account/cancel-on-disconnect
         * @param {PostAccountCancelOnDisconnectPayload} [postAccountCancelOnDisconnectPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountCancelOnDisconnect: async (postAccountCancelOnDisconnectPayload?: PostAccountCancelOnDisconnectPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/cancel-on-disconnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAccountCancelOnDisconnectPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets up an email address for a user.
         * @summary POST /account/email-address
         * @param {PostAccountEmailAddressPayload} [postAccountEmailAddressPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountEmailAddress: async (postAccountEmailAddressPayload?: PostAccountEmailAddressPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/email-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAccountEmailAddressPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets up email preference for a user.
         * @summary POST /account/email-preference
         * @param {PostAccountEmailPreferencePayload} [postAccountEmailPreferencePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountEmailPreference: async (postAccountEmailPreferencePayload?: PostAccountEmailPreferencePayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/email-preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAccountEmailPreferencePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set the leverage of an instrument for your account.
         * @summary POST /account/leverage
         * @param {PostAccountLeveragePayload} [postAccountLeveragePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountLeverage: async (postAccountLeveragePayload?: PostAccountLeveragePayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/leverage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAccountLeveragePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update margin for your account\'s positions.
         * @summary POST /account/margin-type
         * @param {PostAccountMarginTypePayload} [postAccountMarginTypePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountMarginType: async (postAccountMarginTypePayload?: PostAccountMarginTypePayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/margin-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAccountMarginTypePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a non-eth network\'s address to the account
         * @summary POST /account/network-address
         * @param {PostAccountNetworkAddressPayload} [postAccountNetworkAddressPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountNetworkAddress: async (postAccountNetworkAddressPayload?: PostAccountNetworkAddressPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/network-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAccountNetworkAddressPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enables or disables the portfolio margin on your acccount.
         * @summary POST /account/portfolio-margin
         * @param {PostAccountPortfolioMarginPayload} [postAccountPortfolioMarginPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountPortfolioMargin: async (postAccountPortfolioMarginPayload?: PostAccountPortfolioMarginPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/portfolio-margin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAccountPortfolioMarginPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update margin for your account\'s positions.
         * @summary POST /account/update-margin
         * @param {PostAccountUpdateMarginPayload} [postAccountUpdateMarginPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountUpdateMargin: async (postAccountUpdateMarginPayload?: PostAccountUpdateMarginPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/update-margin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAccountUpdateMarginPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new API key.
         * @summary POST /api-key
         * @param {PostApiKeyPayload} [postApiKeyPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiKey: async (postApiKeyPayload?: PostApiKeyPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postApiKeyPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign up for a campaign
         * @summary POST /campaign-sign-up
         * @param {PostCampaignSignUpPayload} [postCampaignSignUpPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignSignUp: async (postCampaignSignUpPayload?: PostCampaignSignUpPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campaign-sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postCampaignSignUpPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User claims referral rewards
         * @summary POST /claim-referral-rewards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClaimReferralRewards: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/claim-referral-rewards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User claims trade fees rewards
         * @summary POST /claim-trade-fees
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClaimTradeFees: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/claim-trade-fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets random farm boost
         * @summary POST /farm-boost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFarmBoost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/farm-boost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark the notifications for the account as read.
         * @summary INTERNAL POST /mark-as-read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMarkAsRead: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mark-as-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets market maker protection (MMP) settings.
         * @summary POST /mmp
         * @param {PostMmpPayload} [postMmpPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMmp: async (postMmpPayload?: PostMmpPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mmp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postMmpPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new order.
         * @summary POST /orders
         * @param {PostOrdersPayload} [postOrdersPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrders: async (postOrdersPayload?: PostOrdersPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postOrdersPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edits an existing order.
         * @summary POST /orders/{order_id}
         * @param {string} orderId Order ID is the hash of the order payload
         * @param {PostOrdersOrderIdPayload} [postOrdersOrderIdPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrdersOrderId: async (orderId: string, postOrdersOrderIdPayload?: PostOrdersOrderIdPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('postOrdersOrderId', 'orderId', orderId)
            const localVarPath = `/orders/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postOrdersOrderIdPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new otc request
         * @summary POST /otc/create-request
         * @param {PostOtcCreateRequestPayload} [postOtcCreateRequestPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOtcCreateRequest: async (postOtcCreateRequestPayload?: PostOtcCreateRequestPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/otc/create-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postOtcCreateRequestPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unwind an otc position
         * @summary POST /otc/unwind
         * @param {PostOtcUnwindPayload} [postOtcUnwindPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOtcUnwind: async (postOtcUnwindPayload?: PostOtcUnwindPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/otc/unwind`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postOtcUnwindPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new quote.
         * @summary POST /quotes
         * @param {PostQuotesPayload} [postQuotesPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postQuotes: async (postQuotesPayload?: PostQuotesPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postQuotesPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Simulate a new quote.
         * @summary POST /quotes/preview
         * @param {PostQuotesPreviewPayload} [postQuotesPreviewPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postQuotesPreview: async (postQuotesPreviewPayload?: PostQuotesPreviewPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quotes/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postQuotesPreviewPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Registers a new account.
         * @summary POST /register
         * @param {PostRegisterPayload} [postRegisterPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRegister: async (postRegisterPayload?: PostRegisterPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRegisterPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset market maker protection (MMP).
         * @summary POST /reset-mmp
         * @param {PostResetMmpPayload} [postResetMmpPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResetMmp: async (postResetMmpPayload?: PostResetMmpPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reset-mmp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postResetMmpPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new RFQ block.
         * @summary POST /rfqs
         * @param {PostRfqsPayload} [postRfqsPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRfqs: async (postRfqsPayload?: PostRfqsPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rfqs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRfqsPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate a USDC withdraw from strategy.
         * @summary POST /strategy/{strategy_address}/initiate-withdraw
         * @param {string} strategyAddress Address of strategy
         * @param {PostStrategyStrategyAddressInitiateWithdrawPayload} [postStrategyStrategyAddressInitiateWithdrawPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStrategyStrategyAddressInitiateWithdraw: async (strategyAddress: string, postStrategyStrategyAddressInitiateWithdrawPayload?: PostStrategyStrategyAddressInitiateWithdrawPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'strategyAddress' is not null or undefined
            assertParamExists('postStrategyStrategyAddressInitiateWithdraw', 'strategyAddress', strategyAddress)
            const localVarPath = `/strategy/{strategy_address}/initiate-withdraw`
                .replace(`{${"strategy_address"}}`, encodeURIComponent(String(strategyAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postStrategyStrategyAddressInitiateWithdrawPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swaps collateral.
         * @summary POST /swap
         * @param {PostSwapPayload} [postSwapPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSwap: async (postSwapPayload?: PostSwapPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/swap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSwapPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transfer USDC between accounts.
         * @summary POST /transfer
         * @param {PostTransferPayload} [postTransferPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransfer: async (postTransferPayload?: PostTransferPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTransferPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Withdraws USDC from the exchange to L1 Ethereum.
         * @summary POST /withdraw
         * @param {PostWithdrawPayload} [postWithdrawPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWithdraw: async (postWithdrawPayload?: PostWithdrawPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/withdraw`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postWithdrawPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edits an existing quote.
         * @summary PUT /quotes/{quote_id}
         * @param {string} quoteId Quote ID is the hash of the quote payload
         * @param {PutQuotesQuoteIdPayload} [putQuotesQuoteIdPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putQuotesQuoteId: async (quoteId: string, putQuotesQuoteIdPayload?: PutQuotesQuoteIdPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('putQuotesQuoteId', 'quoteId', quoteId)
            const localVarPath = `/quotes/{quote_id}`
                .replace(`{${"quote_id"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putQuotesQuoteIdPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrivateAPIApi - functional programming interface
 * @export
 */
export const PrivateAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrivateAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the account\'s API key. This logs out the account.
         * @summary DELETE /api-key
         * @param {DeleteApiKeyPayload} [deleteApiKeyPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApiKey(deleteApiKeyPayload?: DeleteApiKeyPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteApiKey200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiKey(deleteApiKeyPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cancel all orders. Optionally, you can specify an asset and instrument type to cancel only orders for that asset/instrument type.
         * @summary DELETE /orders-all
         * @param {DeleteOrdersAllPayload} [deleteOrdersAllPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrdersAll(deleteOrdersAllPayload?: DeleteOrdersAllPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteOrdersAll200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrdersAll(deleteOrdersAllPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cancels an order.
         * @summary DELETE /orders/{order_id}
         * @param {string} orderId Order ID is the hash of the order payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrdersOrderId(orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteOrdersOrderId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrdersOrderId(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cancel multiple quotes.
         * @summary DELETE /quotes
         * @param {Array<string>} [quoteIds] List of quote IDs.
         * @param {string} [blockId] Block ID is the unique identifier of the block
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQuotes(quoteIds?: Array<string>, blockId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteQuotes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQuotes(quoteIds, blockId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cancels an quote.
         * @summary DELETE /quotes/{quote_id}
         * @param {string} quoteId Quote ID is the hash of the quote payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQuotesQuoteId(quoteId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteQuotesQuoteId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQuotesQuoteId(quoteId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cancel all blocks.
         * @summary DELETE /rfqs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRfqs(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteRfqs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRfqs(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Close an RFQ block
         * @summary DELETE /rfqs/{block_id}
         * @param {string} blockId Block ID is the unique identifier of the block
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRfqsBlockId(blockId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteRfqsBlockId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRfqsBlockId(blockId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Removes the account\'s signing key. This logs out the account.
         * @summary DELETE /signing-key
         * @param {DeleteSigningKeyPayload} [deleteSigningKeyPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSigningKey(deleteSigningKeyPayload?: DeleteSigningKeyPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteSigningKey200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSigningKey(deleteSigningKeyPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the account\'s information including API keys, signing keys and positions.
         * @summary GET /account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the accumulated funding for your account\'s positions.
         * @summary GET /account/accumulated-fundings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountAccumulatedFundings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountAccumulatedFundings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountAccumulatedFundings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check the Cancel on Disconnect (CoD) setting for your account.
         * @summary GET /account/cancel-on-disconnect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountCancelOnDisconnect(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountCancelOnDisconnect200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountCancelOnDisconnect(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check the Email Address for your account.
         * @summary GET /account/email-address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountEmailAddress(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountEmailAddress200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountEmailAddress(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check the email preferences for your account.
         * @summary GET /account/email-preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountEmailPreferences(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountEmailPreferences200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountEmailPreferences(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check if an account\'s email is verified.
         * @summary GET /account/email-verified
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountEmailVerified(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountEmailVerified200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountEmailVerified(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the account\'s statistics of volume and pnl
         * @summary GET /account/stats
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {string} [asset] Name of underlying asset.
         * @param {string} [campaignName] The name of a campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountStats(startTime?: number, endTime?: number, asset?: string, campaignName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountStats200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountStats(startTime, endTime, asset, campaignName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns account\'s trade history in CSV format
         * @summary GET /account/trades/csv
         * @param {Array<'trade' | 'liquidation' | 'settlement' | 'funding'>} tradeTypes Type of user trade.
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountTradesCsv(tradeTypes: Array<'trade' | 'liquidation' | 'settlement' | 'funding'>, startTime: number, endTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountTradesCsv(tradeTypes, startTime, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns account\'s transactions history in CSV format
         * @summary GET /account/transactions/csv
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountTransactionsCsv(startTime: number, endTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountTransactionsCsv(startTime, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Analytics for authenticated accounts
         * @summary INTERNAL GET /analytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalytics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalytics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the API key information.
         * @summary GET /api-key
         * @param {string} apiKey Account\&#39;s API Key.
         * @param {string} timestamp Timestamp in UNIX in nanoseconds.
         * @param {string} signature Hash of order payload signature signed by the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiKey(apiKey: string, timestamp: string, signature: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApiKey200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiKey(apiKey, timestamp, signature, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns true if the given headers has valid authentication
         * @summary GET /auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuth(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAuth200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuth(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the account\'s balance history.
         * @summary INTERNAL GET /balance-history
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalanceHistory(startTime: number, endTime?: number, resolution?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBalanceHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalanceHistory(startTime, endTime, resolution, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the account\'s block history.
         * @summary INTERNAL GET /block-history
         * @param {string} [blockId] Block ID is the unique identifier of the block
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlockHistory(blockId?: string, startTime?: number, endTime?: number, sortOrder?: 'ASC' | 'DESC', limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBlockHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlockHistory(blockId, startTime, endTime, sortOrder, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the account\'s block trade history.
         * @summary INTERNAL GET /block-trade-history
         * @param {string} [blockId] Block ID is the unique identifier of the block
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlockTradeHistory(blockId?: string, startTime?: number, endTime?: number, sortOrder?: 'ASC' | 'DESC', limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBlockTradeHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlockTradeHistory(blockId, startTime, endTime, sortOrder, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns current farm boost, avg farm boost, and boosted volume
         * @summary GET /farm-boost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFarmBoost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFarmBoost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFarmBoost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns L1 withdrawal capacity for each collateral.
         * @summary INTERNAL GET /l1/capacity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getL1Capacity(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetL1Capacity200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getL1Capacity(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the leaderboard for a campaign by pnl in descending order
         * @summary GET /leaderboard/campaign
         * @param {string} username Account\&#39;s auto-generated username based on their Ethereum address.
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} endTime Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeaderboardCampaign(username: string, startTime: number, endTime: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLeaderboardCampaign200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeaderboardCampaign(username, startTime, endTime, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the margin requirement.
         * @summary INTERNAL GET /margin
         * @param {number} instrumentId Instrument ID number.
         * @param {boolean} isBuy True for long order, false for short order.
         * @param {string} limitPrice Order limit price. In 6 decimals fixed number.
         * @param {string} amount Number of contracts. In 6 decimals fixed number.
         * @param {string} [orderId] Order ID is the hash of the order payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMargin(instrumentId: number, isBuy: boolean, limitPrice: string, amount: string, orderId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMargin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMargin(instrumentId, isBuy, limitPrice, amount, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get market maker protection (MMP) setting.
         * @summary GET /mmp
         * @param {string} asset Name of underlying asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMmp(asset: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMmp200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMmp(asset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the account\'s notification history.
         * @summary INTERNAL GET /notifications
         * @param {boolean} [unread] Filter by unread only
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(unread?: boolean, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetNotifications200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(unread, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns order history for the account.
         * @summary GET /order-history
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderHistory(startTime: number, endTime?: number, limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderHistory(startTime, endTime, limit, offset, sort, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns stop order history for the account.
         * @summary GET /order-history/stops
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderHistoryStops(startTime: number, endTime?: number, limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderHistoryStops200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderHistoryStops(startTime, endTime, limit, offset, sort, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all account\'s orders.
         * @summary GET /orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrders200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the order details.
         * @summary GET /orders/{order_id}
         * @param {string} orderId Order ID is the hash of the order payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrdersOrderId(orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrdersOrderId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrdersOrderId(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the account\'s otc details
         * @summary GET /otc/account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOtcAccount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOtcAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOtcAccount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the overall portfolio details of the account.
         * @summary GET /portfolio
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolio(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPortfolio200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolio(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the account\'s positions
         * @summary GET /positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPositions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns account\'s proof data
         * @summary GET /proof-data
         * @param {'airdrop' | 'rewards' | 'zero'} jsonName Json name of proof account wants to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProofData(jsonName: 'airdrop' | 'rewards' | 'zero', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProofData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProofData(jsonName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns account\'s proof data
         * @summary GET /proofs-data
         * @param {Array<string>} assets Array of assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProofsData(assets: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProofsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProofsData(assets, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the account\'s quote history.
         * @summary INTERNAL GET /quote-history
         * @param {string} [quoteId] Quote ID is the hash of the quote payload
         * @param {string} [blockId] Block ID is the unique identifier of the block
         * @param {'taker' | 'maker'} [role] Role of the account
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuoteHistory(quoteId?: string, blockId?: string, role?: 'taker' | 'maker', startTime?: number, endTime?: number, sortOrder?: 'ASC' | 'DESC', limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuoteHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuoteHistory(quoteId, blockId, role, startTime, endTime, sortOrder, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all account\'s quotes.
         * @summary GET /quotes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuotes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuotes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuotes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the account\'s referral history.
         * @summary GET /referral-history
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralHistory(limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReferralHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralHistory(limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the account\'s referral rewards history.
         * @summary GET /referral-rewards-history
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralRewardsHistory(limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReferralRewardsHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralRewardsHistory(limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the account\'s referral statistics.
         * @summary GET /referral-statistics
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralStatistics(startTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReferralStatistics200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralStatistics(startTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get RFQ blocks open for trading.
         * @summary GET /rfqs
         * @param {'taker' | 'maker'} [role] Role of the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRfqs(role?: 'taker' | 'maker', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRfqs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRfqs(role, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the quotes for a given RFQ block.
         * @summary GET /rfqs/{block_id}/quotes
         * @param {string} blockId Block ID is the unique identifier of the block
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRfqsBlockIdQuotes(blockId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRfqsBlockIdQuotes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRfqsBlockIdQuotes(blockId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns socket withdrawal capacity for each destination chain.
         * @summary INTERNAL GET /socket/capacity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocketCapacity(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSocketCapacity200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocketCapacity(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns socket fee for the deposit or withdrawal.
         * @summary INTERNAL GET /socket/fees
         * @param {number} chainId The specified chain ID.
         * @param {string} socketConnector The socket connector address.
         * @param {string} socketAddress The socket address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocketFees(chainId: number, socketConnector: string, socketAddress: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSocketFees200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocketFees(chainId, socketConnector, socketAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the account\'s strategy positions
         * @summary GET /strategies/account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStrategiesAccount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStrategiesAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrategiesAccount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the account\'s strategy equity history
         * @summary GET /strategies/account-history
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStrategiesAccountHistory(startTime: number, endTime?: number, resolution?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStrategiesAccountHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrategiesAccountHistory(startTime, endTime, resolution, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the account\'s trading fee statistics.
         * @summary GET /trade-fees-campaign-stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTradeFeesCampaignStats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTradeFeesCampaignStats200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradeFeesCampaignStats(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the account\'s trade history.
         * @summary GET /trade-history
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {string} [asset] Name of underlying asset.
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {Array<'trade' | 'liquidation' | 'settlement' | 'funding'>} [tradeTypes] Type of user trade.
         * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
         * @param {'put' | 'call'} [optionType] Type of option contract.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {boolean} [agg] Aggregates trades if set to true.
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTradeHistory(startTime: number, asset?: string, endTime?: number, tradeTypes?: Array<'trade' | 'liquidation' | 'settlement' | 'funding'>, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', optionType?: 'put' | 'call', limit?: number, agg?: boolean, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTradeHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradeHistory(startTime, asset, endTime, tradeTypes, instrumentType, optionType, limit, agg, offset, sort, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the account\'s deposit and withdraw history.
         * @summary GET /transaction-history
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw'} [txType] Type of user transaction.
         * @param {'initiated' | 'finalized'} [txStatus] Transaction status.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionHistory(startTime?: number, endTime?: number, txType?: 'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw', txStatus?: 'initiated' | 'finalized', limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransactionHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionHistory(startTime, endTime, txType, txStatus, limit, offset, sort, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the withdrawal fees for each chain and asset.
         * @summary INTERNAL GET /withdraw/fees
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWithdrawFees(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetWithdrawFees200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWithdrawFees(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Enables or disables the Cancel on Disconnect (CoD) setting for your account. When CoD is enabled, when a websocket connection is closed, all orders placed via that connection will be cancelled.
         * @summary POST /account/cancel-on-disconnect
         * @param {PostAccountCancelOnDisconnectPayload} [postAccountCancelOnDisconnectPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAccountCancelOnDisconnect(postAccountCancelOnDisconnectPayload?: PostAccountCancelOnDisconnectPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAccountCancelOnDisconnect200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAccountCancelOnDisconnect(postAccountCancelOnDisconnectPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets up an email address for a user.
         * @summary POST /account/email-address
         * @param {PostAccountEmailAddressPayload} [postAccountEmailAddressPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAccountEmailAddress(postAccountEmailAddressPayload?: PostAccountEmailAddressPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAccountEmailAddress200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAccountEmailAddress(postAccountEmailAddressPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets up email preference for a user.
         * @summary POST /account/email-preference
         * @param {PostAccountEmailPreferencePayload} [postAccountEmailPreferencePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAccountEmailPreference(postAccountEmailPreferencePayload?: PostAccountEmailPreferencePayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAccountEmailPreference200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAccountEmailPreference(postAccountEmailPreferencePayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set the leverage of an instrument for your account.
         * @summary POST /account/leverage
         * @param {PostAccountLeveragePayload} [postAccountLeveragePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAccountLeverage(postAccountLeveragePayload?: PostAccountLeveragePayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAccountLeverage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAccountLeverage(postAccountLeveragePayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update margin for your account\'s positions.
         * @summary POST /account/margin-type
         * @param {PostAccountMarginTypePayload} [postAccountMarginTypePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAccountMarginType(postAccountMarginTypePayload?: PostAccountMarginTypePayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAccountMarginType200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAccountMarginType(postAccountMarginTypePayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set a non-eth network\'s address to the account
         * @summary POST /account/network-address
         * @param {PostAccountNetworkAddressPayload} [postAccountNetworkAddressPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAccountNetworkAddress(postAccountNetworkAddressPayload?: PostAccountNetworkAddressPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAccountNetworkAddress200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAccountNetworkAddress(postAccountNetworkAddressPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Enables or disables the portfolio margin on your acccount.
         * @summary POST /account/portfolio-margin
         * @param {PostAccountPortfolioMarginPayload} [postAccountPortfolioMarginPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAccountPortfolioMargin(postAccountPortfolioMarginPayload?: PostAccountPortfolioMarginPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAccountPortfolioMargin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAccountPortfolioMargin(postAccountPortfolioMarginPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update margin for your account\'s positions.
         * @summary POST /account/update-margin
         * @param {PostAccountUpdateMarginPayload} [postAccountUpdateMarginPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAccountUpdateMargin(postAccountUpdateMarginPayload?: PostAccountUpdateMarginPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAccountUpdateMargin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAccountUpdateMargin(postAccountUpdateMarginPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new API key.
         * @summary POST /api-key
         * @param {PostApiKeyPayload} [postApiKeyPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiKey(postApiKeyPayload?: PostApiKeyPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostApiKey200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiKey(postApiKeyPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sign up for a campaign
         * @summary POST /campaign-sign-up
         * @param {PostCampaignSignUpPayload} [postCampaignSignUpPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCampaignSignUp(postCampaignSignUpPayload?: PostCampaignSignUpPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCampaignSignUp200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCampaignSignUp(postCampaignSignUpPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User claims referral rewards
         * @summary POST /claim-referral-rewards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postClaimReferralRewards(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostClaimReferralRewards200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postClaimReferralRewards(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User claims trade fees rewards
         * @summary POST /claim-trade-fees
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postClaimTradeFees(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostClaimTradeFees200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postClaimTradeFees(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets random farm boost
         * @summary POST /farm-boost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFarmBoost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostFarmBoost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFarmBoost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Mark the notifications for the account as read.
         * @summary INTERNAL POST /mark-as-read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMarkAsRead(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostMarkAsRead200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMarkAsRead(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets market maker protection (MMP) settings.
         * @summary POST /mmp
         * @param {PostMmpPayload} [postMmpPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMmp(postMmpPayload?: PostMmpPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostMmp200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMmp(postMmpPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new order.
         * @summary POST /orders
         * @param {PostOrdersPayload} [postOrdersPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOrders(postOrdersPayload?: PostOrdersPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostOrders200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOrders(postOrdersPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Edits an existing order.
         * @summary POST /orders/{order_id}
         * @param {string} orderId Order ID is the hash of the order payload
         * @param {PostOrdersOrderIdPayload} [postOrdersOrderIdPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOrdersOrderId(orderId: string, postOrdersOrderIdPayload?: PostOrdersOrderIdPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostOrdersOrderId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOrdersOrderId(orderId, postOrdersOrderIdPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new otc request
         * @summary POST /otc/create-request
         * @param {PostOtcCreateRequestPayload} [postOtcCreateRequestPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOtcCreateRequest(postOtcCreateRequestPayload?: PostOtcCreateRequestPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostOtcCreateRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOtcCreateRequest(postOtcCreateRequestPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unwind an otc position
         * @summary POST /otc/unwind
         * @param {PostOtcUnwindPayload} [postOtcUnwindPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOtcUnwind(postOtcUnwindPayload?: PostOtcUnwindPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostOtcUnwind200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOtcUnwind(postOtcUnwindPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new quote.
         * @summary POST /quotes
         * @param {PostQuotesPayload} [postQuotesPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postQuotes(postQuotesPayload?: PostQuotesPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostQuotes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postQuotes(postQuotesPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Simulate a new quote.
         * @summary POST /quotes/preview
         * @param {PostQuotesPreviewPayload} [postQuotesPreviewPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postQuotesPreview(postQuotesPreviewPayload?: PostQuotesPreviewPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostQuotesPreview200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postQuotesPreview(postQuotesPreviewPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Registers a new account.
         * @summary POST /register
         * @param {PostRegisterPayload} [postRegisterPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRegister(postRegisterPayload?: PostRegisterPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostRegister200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRegister(postRegisterPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reset market maker protection (MMP).
         * @summary POST /reset-mmp
         * @param {PostResetMmpPayload} [postResetMmpPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResetMmp(postResetMmpPayload?: PostResetMmpPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostResetMmp200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResetMmp(postResetMmpPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new RFQ block.
         * @summary POST /rfqs
         * @param {PostRfqsPayload} [postRfqsPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRfqs(postRfqsPayload?: PostRfqsPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostRfqs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRfqs(postRfqsPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Initiate a USDC withdraw from strategy.
         * @summary POST /strategy/{strategy_address}/initiate-withdraw
         * @param {string} strategyAddress Address of strategy
         * @param {PostStrategyStrategyAddressInitiateWithdrawPayload} [postStrategyStrategyAddressInitiateWithdrawPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postStrategyStrategyAddressInitiateWithdraw(strategyAddress: string, postStrategyStrategyAddressInitiateWithdrawPayload?: PostStrategyStrategyAddressInitiateWithdrawPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostStrategyStrategyAddressInitiateWithdraw200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postStrategyStrategyAddressInitiateWithdraw(strategyAddress, postStrategyStrategyAddressInitiateWithdrawPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Swaps collateral.
         * @summary POST /swap
         * @param {PostSwapPayload} [postSwapPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSwap(postSwapPayload?: PostSwapPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostSwap200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSwap(postSwapPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Transfer USDC between accounts.
         * @summary POST /transfer
         * @param {PostTransferPayload} [postTransferPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTransfer(postTransferPayload?: PostTransferPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostTransfer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTransfer(postTransferPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Withdraws USDC from the exchange to L1 Ethereum.
         * @summary POST /withdraw
         * @param {PostWithdrawPayload} [postWithdrawPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postWithdraw(postWithdrawPayload?: PostWithdrawPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostWithdraw200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postWithdraw(postWithdrawPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Edits an existing quote.
         * @summary PUT /quotes/{quote_id}
         * @param {string} quoteId Quote ID is the hash of the quote payload
         * @param {PutQuotesQuoteIdPayload} [putQuotesQuoteIdPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putQuotesQuoteId(quoteId: string, putQuotesQuoteIdPayload?: PutQuotesQuoteIdPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutQuotesQuoteId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putQuotesQuoteId(quoteId, putQuotesQuoteIdPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PrivateAPIApi - factory interface
 * @export
 */
export const PrivateAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrivateAPIApiFp(configuration)
    return {
        /**
         * Removes the account\'s API key. This logs out the account.
         * @summary DELETE /api-key
         * @param {DeleteApiKeyPayload} [deleteApiKeyPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey(deleteApiKeyPayload?: DeleteApiKeyPayload, options?: any): AxiosPromise<DeleteApiKey200Response> {
            return localVarFp.deleteApiKey(deleteApiKeyPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel all orders. Optionally, you can specify an asset and instrument type to cancel only orders for that asset/instrument type.
         * @summary DELETE /orders-all
         * @param {DeleteOrdersAllPayload} [deleteOrdersAllPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrdersAll(deleteOrdersAllPayload?: DeleteOrdersAllPayload, options?: any): AxiosPromise<DeleteOrdersAll200Response> {
            return localVarFp.deleteOrdersAll(deleteOrdersAllPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancels an order.
         * @summary DELETE /orders/{order_id}
         * @param {string} orderId Order ID is the hash of the order payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrdersOrderId(orderId: string, options?: any): AxiosPromise<DeleteOrdersOrderId200Response> {
            return localVarFp.deleteOrdersOrderId(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel multiple quotes.
         * @summary DELETE /quotes
         * @param {Array<string>} [quoteIds] List of quote IDs.
         * @param {string} [blockId] Block ID is the unique identifier of the block
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuotes(quoteIds?: Array<string>, blockId?: string, options?: any): AxiosPromise<DeleteQuotes200Response> {
            return localVarFp.deleteQuotes(quoteIds, blockId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancels an quote.
         * @summary DELETE /quotes/{quote_id}
         * @param {string} quoteId Quote ID is the hash of the quote payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuotesQuoteId(quoteId: string, options?: any): AxiosPromise<DeleteQuotesQuoteId200Response> {
            return localVarFp.deleteQuotesQuoteId(quoteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel all blocks.
         * @summary DELETE /rfqs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRfqs(options?: any): AxiosPromise<DeleteRfqs200Response> {
            return localVarFp.deleteRfqs(options).then((request) => request(axios, basePath));
        },
        /**
         * Close an RFQ block
         * @summary DELETE /rfqs/{block_id}
         * @param {string} blockId Block ID is the unique identifier of the block
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRfqsBlockId(blockId: string, options?: any): AxiosPromise<DeleteRfqsBlockId200Response> {
            return localVarFp.deleteRfqsBlockId(blockId, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the account\'s signing key. This logs out the account.
         * @summary DELETE /signing-key
         * @param {DeleteSigningKeyPayload} [deleteSigningKeyPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSigningKey(deleteSigningKeyPayload?: DeleteSigningKeyPayload, options?: any): AxiosPromise<DeleteSigningKey200Response> {
            return localVarFp.deleteSigningKey(deleteSigningKeyPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the account\'s information including API keys, signing keys and positions.
         * @summary GET /account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(options?: any): AxiosPromise<GetAccount200Response> {
            return localVarFp.getAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the accumulated funding for your account\'s positions.
         * @summary GET /account/accumulated-fundings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccumulatedFundings(options?: any): AxiosPromise<GetAccountAccumulatedFundings200Response> {
            return localVarFp.getAccountAccumulatedFundings(options).then((request) => request(axios, basePath));
        },
        /**
         * Check the Cancel on Disconnect (CoD) setting for your account.
         * @summary GET /account/cancel-on-disconnect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCancelOnDisconnect(options?: any): AxiosPromise<GetAccountCancelOnDisconnect200Response> {
            return localVarFp.getAccountCancelOnDisconnect(options).then((request) => request(axios, basePath));
        },
        /**
         * Check the Email Address for your account.
         * @summary GET /account/email-address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountEmailAddress(options?: any): AxiosPromise<GetAccountEmailAddress200Response> {
            return localVarFp.getAccountEmailAddress(options).then((request) => request(axios, basePath));
        },
        /**
         * Check the email preferences for your account.
         * @summary GET /account/email-preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountEmailPreferences(options?: any): AxiosPromise<GetAccountEmailPreferences200Response> {
            return localVarFp.getAccountEmailPreferences(options).then((request) => request(axios, basePath));
        },
        /**
         * Check if an account\'s email is verified.
         * @summary GET /account/email-verified
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountEmailVerified(options?: any): AxiosPromise<GetAccountEmailVerified200Response> {
            return localVarFp.getAccountEmailVerified(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the account\'s statistics of volume and pnl
         * @summary GET /account/stats
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {string} [asset] Name of underlying asset.
         * @param {string} [campaignName] The name of a campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountStats(startTime?: number, endTime?: number, asset?: string, campaignName?: string, options?: any): AxiosPromise<GetAccountStats200Response> {
            return localVarFp.getAccountStats(startTime, endTime, asset, campaignName, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns account\'s trade history in CSV format
         * @summary GET /account/trades/csv
         * @param {Array<'trade' | 'liquidation' | 'settlement' | 'funding'>} tradeTypes Type of user trade.
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountTradesCsv(tradeTypes: Array<'trade' | 'liquidation' | 'settlement' | 'funding'>, startTime: number, endTime?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getAccountTradesCsv(tradeTypes, startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns account\'s transactions history in CSV format
         * @summary GET /account/transactions/csv
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountTransactionsCsv(startTime: number, endTime?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getAccountTransactionsCsv(startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Analytics for authenticated accounts
         * @summary INTERNAL GET /analytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalytics(options?: any): AxiosPromise<object> {
            return localVarFp.getAnalytics(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the API key information.
         * @summary GET /api-key
         * @param {string} apiKey Account\&#39;s API Key.
         * @param {string} timestamp Timestamp in UNIX in nanoseconds.
         * @param {string} signature Hash of order payload signature signed by the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKey(apiKey: string, timestamp: string, signature: string, options?: any): AxiosPromise<GetApiKey200Response> {
            return localVarFp.getApiKey(apiKey, timestamp, signature, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns true if the given headers has valid authentication
         * @summary GET /auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuth(options?: any): AxiosPromise<GetAuth200Response> {
            return localVarFp.getAuth(options).then((request) => request(axios, basePath));
        },
        /**
         * Return the account\'s balance history.
         * @summary INTERNAL GET /balance-history
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceHistory(startTime: number, endTime?: number, resolution?: number, options?: any): AxiosPromise<GetBalanceHistory200Response> {
            return localVarFp.getBalanceHistory(startTime, endTime, resolution, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the account\'s block history.
         * @summary INTERNAL GET /block-history
         * @param {string} [blockId] Block ID is the unique identifier of the block
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockHistory(blockId?: string, startTime?: number, endTime?: number, sortOrder?: 'ASC' | 'DESC', limit?: number, offset?: number, options?: any): AxiosPromise<GetBlockHistory200Response> {
            return localVarFp.getBlockHistory(blockId, startTime, endTime, sortOrder, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the account\'s block trade history.
         * @summary INTERNAL GET /block-trade-history
         * @param {string} [blockId] Block ID is the unique identifier of the block
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockTradeHistory(blockId?: string, startTime?: number, endTime?: number, sortOrder?: 'ASC' | 'DESC', limit?: number, offset?: number, options?: any): AxiosPromise<GetBlockTradeHistory200Response> {
            return localVarFp.getBlockTradeHistory(blockId, startTime, endTime, sortOrder, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns current farm boost, avg farm boost, and boosted volume
         * @summary GET /farm-boost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmBoost(options?: any): AxiosPromise<GetFarmBoost200Response> {
            return localVarFp.getFarmBoost(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns L1 withdrawal capacity for each collateral.
         * @summary INTERNAL GET /l1/capacity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getL1Capacity(options?: any): AxiosPromise<Array<GetL1Capacity200Response>> {
            return localVarFp.getL1Capacity(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the leaderboard for a campaign by pnl in descending order
         * @summary GET /leaderboard/campaign
         * @param {string} username Account\&#39;s auto-generated username based on their Ethereum address.
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} endTime Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderboardCampaign(username: string, startTime: number, endTime: number, limit?: number, options?: any): AxiosPromise<GetLeaderboardCampaign200Response> {
            return localVarFp.getLeaderboardCampaign(username, startTime, endTime, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the margin requirement.
         * @summary INTERNAL GET /margin
         * @param {number} instrumentId Instrument ID number.
         * @param {boolean} isBuy True for long order, false for short order.
         * @param {string} limitPrice Order limit price. In 6 decimals fixed number.
         * @param {string} amount Number of contracts. In 6 decimals fixed number.
         * @param {string} [orderId] Order ID is the hash of the order payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMargin(instrumentId: number, isBuy: boolean, limitPrice: string, amount: string, orderId?: string, options?: any): AxiosPromise<GetMargin200Response> {
            return localVarFp.getMargin(instrumentId, isBuy, limitPrice, amount, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get market maker protection (MMP) setting.
         * @summary GET /mmp
         * @param {string} asset Name of underlying asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMmp(asset: string, options?: any): AxiosPromise<GetMmp200Response> {
            return localVarFp.getMmp(asset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the account\'s notification history.
         * @summary INTERNAL GET /notifications
         * @param {boolean} [unread] Filter by unread only
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(unread?: boolean, limit?: number, options?: any): AxiosPromise<Array<GetNotifications200Response>> {
            return localVarFp.getNotifications(unread, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns order history for the account.
         * @summary GET /order-history
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderHistory(startTime: number, endTime?: number, limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: any): AxiosPromise<GetOrderHistory200Response> {
            return localVarFp.getOrderHistory(startTime, endTime, limit, offset, sort, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns stop order history for the account.
         * @summary GET /order-history/stops
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderHistoryStops(startTime: number, endTime?: number, limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: any): AxiosPromise<GetOrderHistoryStops200Response> {
            return localVarFp.getOrderHistoryStops(startTime, endTime, limit, offset, sort, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all account\'s orders.
         * @summary GET /orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders(options?: any): AxiosPromise<Array<GetOrders200Response>> {
            return localVarFp.getOrders(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the order details.
         * @summary GET /orders/{order_id}
         * @param {string} orderId Order ID is the hash of the order payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersOrderId(orderId: string, options?: any): AxiosPromise<GetOrdersOrderId200Response> {
            return localVarFp.getOrdersOrderId(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the account\'s otc details
         * @summary GET /otc/account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtcAccount(options?: any): AxiosPromise<GetOtcAccount200Response> {
            return localVarFp.getOtcAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the overall portfolio details of the account.
         * @summary GET /portfolio
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolio(options?: any): AxiosPromise<GetPortfolio200Response> {
            return localVarFp.getPortfolio(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the account\'s positions
         * @summary GET /positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions(options?: any): AxiosPromise<GetPositions200Response> {
            return localVarFp.getPositions(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns account\'s proof data
         * @summary GET /proof-data
         * @param {'airdrop' | 'rewards' | 'zero'} jsonName Json name of proof account wants to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProofData(jsonName: 'airdrop' | 'rewards' | 'zero', options?: any): AxiosPromise<GetProofData200Response> {
            return localVarFp.getProofData(jsonName, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns account\'s proof data
         * @summary GET /proofs-data
         * @param {Array<string>} assets Array of assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProofsData(assets: Array<string>, options?: any): AxiosPromise<GetProofsData200Response> {
            return localVarFp.getProofsData(assets, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the account\'s quote history.
         * @summary INTERNAL GET /quote-history
         * @param {string} [quoteId] Quote ID is the hash of the quote payload
         * @param {string} [blockId] Block ID is the unique identifier of the block
         * @param {'taker' | 'maker'} [role] Role of the account
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuoteHistory(quoteId?: string, blockId?: string, role?: 'taker' | 'maker', startTime?: number, endTime?: number, sortOrder?: 'ASC' | 'DESC', limit?: number, offset?: number, options?: any): AxiosPromise<GetQuoteHistory200Response> {
            return localVarFp.getQuoteHistory(quoteId, blockId, role, startTime, endTime, sortOrder, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all account\'s quotes.
         * @summary GET /quotes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuotes(options?: any): AxiosPromise<GetQuotes200Response> {
            return localVarFp.getQuotes(options).then((request) => request(axios, basePath));
        },
        /**
         * Return the account\'s referral history.
         * @summary GET /referral-history
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralHistory(limit?: number, offset?: number, options?: any): AxiosPromise<GetReferralHistory200Response> {
            return localVarFp.getReferralHistory(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the account\'s referral rewards history.
         * @summary GET /referral-rewards-history
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralRewardsHistory(limit?: number, offset?: number, options?: any): AxiosPromise<GetReferralRewardsHistory200Response> {
            return localVarFp.getReferralRewardsHistory(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the account\'s referral statistics.
         * @summary GET /referral-statistics
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralStatistics(startTime?: number, options?: any): AxiosPromise<GetReferralStatistics200Response> {
            return localVarFp.getReferralStatistics(startTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Get RFQ blocks open for trading.
         * @summary GET /rfqs
         * @param {'taker' | 'maker'} [role] Role of the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRfqs(role?: 'taker' | 'maker', options?: any): AxiosPromise<GetRfqs200Response> {
            return localVarFp.getRfqs(role, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the quotes for a given RFQ block.
         * @summary GET /rfqs/{block_id}/quotes
         * @param {string} blockId Block ID is the unique identifier of the block
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRfqsBlockIdQuotes(blockId: string, options?: any): AxiosPromise<GetRfqsBlockIdQuotes200Response> {
            return localVarFp.getRfqsBlockIdQuotes(blockId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns socket withdrawal capacity for each destination chain.
         * @summary INTERNAL GET /socket/capacity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocketCapacity(options?: any): AxiosPromise<Array<GetSocketCapacity200Response>> {
            return localVarFp.getSocketCapacity(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns socket fee for the deposit or withdrawal.
         * @summary INTERNAL GET /socket/fees
         * @param {number} chainId The specified chain ID.
         * @param {string} socketConnector The socket connector address.
         * @param {string} socketAddress The socket address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocketFees(chainId: number, socketConnector: string, socketAddress: string, options?: any): AxiosPromise<GetSocketFees200Response> {
            return localVarFp.getSocketFees(chainId, socketConnector, socketAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the account\'s strategy positions
         * @summary GET /strategies/account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategiesAccount(options?: any): AxiosPromise<GetStrategiesAccount200Response> {
            return localVarFp.getStrategiesAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the account\'s strategy equity history
         * @summary GET /strategies/account-history
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategiesAccountHistory(startTime: number, endTime?: number, resolution?: number, options?: any): AxiosPromise<GetStrategiesAccountHistory200Response> {
            return localVarFp.getStrategiesAccountHistory(startTime, endTime, resolution, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the account\'s trading fee statistics.
         * @summary GET /trade-fees-campaign-stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeFeesCampaignStats(options?: any): AxiosPromise<GetTradeFeesCampaignStats200Response> {
            return localVarFp.getTradeFeesCampaignStats(options).then((request) => request(axios, basePath));
        },
        /**
         * Return the account\'s trade history.
         * @summary GET /trade-history
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {string} [asset] Name of underlying asset.
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {Array<'trade' | 'liquidation' | 'settlement' | 'funding'>} [tradeTypes] Type of user trade.
         * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
         * @param {'put' | 'call'} [optionType] Type of option contract.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {boolean} [agg] Aggregates trades if set to true.
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeHistory(startTime: number, asset?: string, endTime?: number, tradeTypes?: Array<'trade' | 'liquidation' | 'settlement' | 'funding'>, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', optionType?: 'put' | 'call', limit?: number, agg?: boolean, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: any): AxiosPromise<GetTradeHistory200Response> {
            return localVarFp.getTradeHistory(startTime, asset, endTime, tradeTypes, instrumentType, optionType, limit, agg, offset, sort, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the account\'s deposit and withdraw history.
         * @summary GET /transaction-history
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw'} [txType] Type of user transaction.
         * @param {'initiated' | 'finalized'} [txStatus] Transaction status.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistory(startTime?: number, endTime?: number, txType?: 'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw', txStatus?: 'initiated' | 'finalized', limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: any): AxiosPromise<GetTransactionHistory200Response> {
            return localVarFp.getTransactionHistory(startTime, endTime, txType, txStatus, limit, offset, sort, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the withdrawal fees for each chain and asset.
         * @summary INTERNAL GET /withdraw/fees
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawFees(options?: any): AxiosPromise<Array<GetWithdrawFees200Response>> {
            return localVarFp.getWithdrawFees(options).then((request) => request(axios, basePath));
        },
        /**
         * Enables or disables the Cancel on Disconnect (CoD) setting for your account. When CoD is enabled, when a websocket connection is closed, all orders placed via that connection will be cancelled.
         * @summary POST /account/cancel-on-disconnect
         * @param {PostAccountCancelOnDisconnectPayload} [postAccountCancelOnDisconnectPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountCancelOnDisconnect(postAccountCancelOnDisconnectPayload?: PostAccountCancelOnDisconnectPayload, options?: any): AxiosPromise<PostAccountCancelOnDisconnect200Response> {
            return localVarFp.postAccountCancelOnDisconnect(postAccountCancelOnDisconnectPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets up an email address for a user.
         * @summary POST /account/email-address
         * @param {PostAccountEmailAddressPayload} [postAccountEmailAddressPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountEmailAddress(postAccountEmailAddressPayload?: PostAccountEmailAddressPayload, options?: any): AxiosPromise<PostAccountEmailAddress200Response> {
            return localVarFp.postAccountEmailAddress(postAccountEmailAddressPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets up email preference for a user.
         * @summary POST /account/email-preference
         * @param {PostAccountEmailPreferencePayload} [postAccountEmailPreferencePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountEmailPreference(postAccountEmailPreferencePayload?: PostAccountEmailPreferencePayload, options?: any): AxiosPromise<PostAccountEmailPreference200Response> {
            return localVarFp.postAccountEmailPreference(postAccountEmailPreferencePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the leverage of an instrument for your account.
         * @summary POST /account/leverage
         * @param {PostAccountLeveragePayload} [postAccountLeveragePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountLeverage(postAccountLeveragePayload?: PostAccountLeveragePayload, options?: any): AxiosPromise<PostAccountLeverage200Response> {
            return localVarFp.postAccountLeverage(postAccountLeveragePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Update margin for your account\'s positions.
         * @summary POST /account/margin-type
         * @param {PostAccountMarginTypePayload} [postAccountMarginTypePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountMarginType(postAccountMarginTypePayload?: PostAccountMarginTypePayload, options?: any): AxiosPromise<PostAccountMarginType200Response> {
            return localVarFp.postAccountMarginType(postAccountMarginTypePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Set a non-eth network\'s address to the account
         * @summary POST /account/network-address
         * @param {PostAccountNetworkAddressPayload} [postAccountNetworkAddressPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountNetworkAddress(postAccountNetworkAddressPayload?: PostAccountNetworkAddressPayload, options?: any): AxiosPromise<PostAccountNetworkAddress200Response> {
            return localVarFp.postAccountNetworkAddress(postAccountNetworkAddressPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Enables or disables the portfolio margin on your acccount.
         * @summary POST /account/portfolio-margin
         * @param {PostAccountPortfolioMarginPayload} [postAccountPortfolioMarginPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountPortfolioMargin(postAccountPortfolioMarginPayload?: PostAccountPortfolioMarginPayload, options?: any): AxiosPromise<PostAccountPortfolioMargin200Response> {
            return localVarFp.postAccountPortfolioMargin(postAccountPortfolioMarginPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Update margin for your account\'s positions.
         * @summary POST /account/update-margin
         * @param {PostAccountUpdateMarginPayload} [postAccountUpdateMarginPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountUpdateMargin(postAccountUpdateMarginPayload?: PostAccountUpdateMarginPayload, options?: any): AxiosPromise<PostAccountUpdateMargin200Response> {
            return localVarFp.postAccountUpdateMargin(postAccountUpdateMarginPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new API key.
         * @summary POST /api-key
         * @param {PostApiKeyPayload} [postApiKeyPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiKey(postApiKeyPayload?: PostApiKeyPayload, options?: any): AxiosPromise<PostApiKey200Response> {
            return localVarFp.postApiKey(postApiKeyPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign up for a campaign
         * @summary POST /campaign-sign-up
         * @param {PostCampaignSignUpPayload} [postCampaignSignUpPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignSignUp(postCampaignSignUpPayload?: PostCampaignSignUpPayload, options?: any): AxiosPromise<PostCampaignSignUp200Response> {
            return localVarFp.postCampaignSignUp(postCampaignSignUpPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * User claims referral rewards
         * @summary POST /claim-referral-rewards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClaimReferralRewards(options?: any): AxiosPromise<PostClaimReferralRewards200Response> {
            return localVarFp.postClaimReferralRewards(options).then((request) => request(axios, basePath));
        },
        /**
         * User claims trade fees rewards
         * @summary POST /claim-trade-fees
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClaimTradeFees(options?: any): AxiosPromise<PostClaimTradeFees200Response> {
            return localVarFp.postClaimTradeFees(options).then((request) => request(axios, basePath));
        },
        /**
         * Sets random farm boost
         * @summary POST /farm-boost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFarmBoost(options?: any): AxiosPromise<PostFarmBoost200Response> {
            return localVarFp.postFarmBoost(options).then((request) => request(axios, basePath));
        },
        /**
         * Mark the notifications for the account as read.
         * @summary INTERNAL POST /mark-as-read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMarkAsRead(options?: any): AxiosPromise<Array<PostMarkAsRead200Response>> {
            return localVarFp.postMarkAsRead(options).then((request) => request(axios, basePath));
        },
        /**
         * Sets market maker protection (MMP) settings.
         * @summary POST /mmp
         * @param {PostMmpPayload} [postMmpPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMmp(postMmpPayload?: PostMmpPayload, options?: any): AxiosPromise<PostMmp200Response> {
            return localVarFp.postMmp(postMmpPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new order.
         * @summary POST /orders
         * @param {PostOrdersPayload} [postOrdersPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrders(postOrdersPayload?: PostOrdersPayload, options?: any): AxiosPromise<PostOrders200Response> {
            return localVarFp.postOrders(postOrdersPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Edits an existing order.
         * @summary POST /orders/{order_id}
         * @param {string} orderId Order ID is the hash of the order payload
         * @param {PostOrdersOrderIdPayload} [postOrdersOrderIdPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrdersOrderId(orderId: string, postOrdersOrderIdPayload?: PostOrdersOrderIdPayload, options?: any): AxiosPromise<PostOrdersOrderId200Response> {
            return localVarFp.postOrdersOrderId(orderId, postOrdersOrderIdPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new otc request
         * @summary POST /otc/create-request
         * @param {PostOtcCreateRequestPayload} [postOtcCreateRequestPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOtcCreateRequest(postOtcCreateRequestPayload?: PostOtcCreateRequestPayload, options?: any): AxiosPromise<PostOtcCreateRequest200Response> {
            return localVarFp.postOtcCreateRequest(postOtcCreateRequestPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Unwind an otc position
         * @summary POST /otc/unwind
         * @param {PostOtcUnwindPayload} [postOtcUnwindPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOtcUnwind(postOtcUnwindPayload?: PostOtcUnwindPayload, options?: any): AxiosPromise<PostOtcUnwind200Response> {
            return localVarFp.postOtcUnwind(postOtcUnwindPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new quote.
         * @summary POST /quotes
         * @param {PostQuotesPayload} [postQuotesPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postQuotes(postQuotesPayload?: PostQuotesPayload, options?: any): AxiosPromise<PostQuotes200Response> {
            return localVarFp.postQuotes(postQuotesPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Simulate a new quote.
         * @summary POST /quotes/preview
         * @param {PostQuotesPreviewPayload} [postQuotesPreviewPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postQuotesPreview(postQuotesPreviewPayload?: PostQuotesPreviewPayload, options?: any): AxiosPromise<PostQuotesPreview200Response> {
            return localVarFp.postQuotesPreview(postQuotesPreviewPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Registers a new account.
         * @summary POST /register
         * @param {PostRegisterPayload} [postRegisterPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRegister(postRegisterPayload?: PostRegisterPayload, options?: any): AxiosPromise<PostRegister200Response> {
            return localVarFp.postRegister(postRegisterPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset market maker protection (MMP).
         * @summary POST /reset-mmp
         * @param {PostResetMmpPayload} [postResetMmpPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResetMmp(postResetMmpPayload?: PostResetMmpPayload, options?: any): AxiosPromise<PostResetMmp200Response> {
            return localVarFp.postResetMmp(postResetMmpPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new RFQ block.
         * @summary POST /rfqs
         * @param {PostRfqsPayload} [postRfqsPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRfqs(postRfqsPayload?: PostRfqsPayload, options?: any): AxiosPromise<PostRfqs200Response> {
            return localVarFp.postRfqs(postRfqsPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate a USDC withdraw from strategy.
         * @summary POST /strategy/{strategy_address}/initiate-withdraw
         * @param {string} strategyAddress Address of strategy
         * @param {PostStrategyStrategyAddressInitiateWithdrawPayload} [postStrategyStrategyAddressInitiateWithdrawPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStrategyStrategyAddressInitiateWithdraw(strategyAddress: string, postStrategyStrategyAddressInitiateWithdrawPayload?: PostStrategyStrategyAddressInitiateWithdrawPayload, options?: any): AxiosPromise<PostStrategyStrategyAddressInitiateWithdraw200Response> {
            return localVarFp.postStrategyStrategyAddressInitiateWithdraw(strategyAddress, postStrategyStrategyAddressInitiateWithdrawPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Swaps collateral.
         * @summary POST /swap
         * @param {PostSwapPayload} [postSwapPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSwap(postSwapPayload?: PostSwapPayload, options?: any): AxiosPromise<PostSwap200Response> {
            return localVarFp.postSwap(postSwapPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Transfer USDC between accounts.
         * @summary POST /transfer
         * @param {PostTransferPayload} [postTransferPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransfer(postTransferPayload?: PostTransferPayload, options?: any): AxiosPromise<PostTransfer200Response> {
            return localVarFp.postTransfer(postTransferPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Withdraws USDC from the exchange to L1 Ethereum.
         * @summary POST /withdraw
         * @param {PostWithdrawPayload} [postWithdrawPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWithdraw(postWithdrawPayload?: PostWithdrawPayload, options?: any): AxiosPromise<PostWithdraw200Response> {
            return localVarFp.postWithdraw(postWithdrawPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Edits an existing quote.
         * @summary PUT /quotes/{quote_id}
         * @param {string} quoteId Quote ID is the hash of the quote payload
         * @param {PutQuotesQuoteIdPayload} [putQuotesQuoteIdPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putQuotesQuoteId(quoteId: string, putQuotesQuoteIdPayload?: PutQuotesQuoteIdPayload, options?: any): AxiosPromise<PutQuotesQuoteId200Response> {
            return localVarFp.putQuotesQuoteId(quoteId, putQuotesQuoteIdPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrivateAPIApi - object-oriented interface
 * @export
 * @class PrivateAPIApi
 * @extends {BaseAPI}
 */
export class PrivateAPIApi extends BaseAPI {
    /**
     * Removes the account\'s API key. This logs out the account.
     * @summary DELETE /api-key
     * @param {DeleteApiKeyPayload} [deleteApiKeyPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public deleteApiKey(deleteApiKeyPayload?: DeleteApiKeyPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).deleteApiKey(deleteApiKeyPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel all orders. Optionally, you can specify an asset and instrument type to cancel only orders for that asset/instrument type.
     * @summary DELETE /orders-all
     * @param {DeleteOrdersAllPayload} [deleteOrdersAllPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public deleteOrdersAll(deleteOrdersAllPayload?: DeleteOrdersAllPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).deleteOrdersAll(deleteOrdersAllPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancels an order.
     * @summary DELETE /orders/{order_id}
     * @param {string} orderId Order ID is the hash of the order payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public deleteOrdersOrderId(orderId: string, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).deleteOrdersOrderId(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel multiple quotes.
     * @summary DELETE /quotes
     * @param {Array<string>} [quoteIds] List of quote IDs.
     * @param {string} [blockId] Block ID is the unique identifier of the block
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public deleteQuotes(quoteIds?: Array<string>, blockId?: string, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).deleteQuotes(quoteIds, blockId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancels an quote.
     * @summary DELETE /quotes/{quote_id}
     * @param {string} quoteId Quote ID is the hash of the quote payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public deleteQuotesQuoteId(quoteId: string, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).deleteQuotesQuoteId(quoteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel all blocks.
     * @summary DELETE /rfqs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public deleteRfqs(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).deleteRfqs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Close an RFQ block
     * @summary DELETE /rfqs/{block_id}
     * @param {string} blockId Block ID is the unique identifier of the block
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public deleteRfqsBlockId(blockId: string, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).deleteRfqsBlockId(blockId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the account\'s signing key. This logs out the account.
     * @summary DELETE /signing-key
     * @param {DeleteSigningKeyPayload} [deleteSigningKeyPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public deleteSigningKey(deleteSigningKeyPayload?: DeleteSigningKeyPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).deleteSigningKey(deleteSigningKeyPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the account\'s information including API keys, signing keys and positions.
     * @summary GET /account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getAccount(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the accumulated funding for your account\'s positions.
     * @summary GET /account/accumulated-fundings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getAccountAccumulatedFundings(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getAccountAccumulatedFundings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check the Cancel on Disconnect (CoD) setting for your account.
     * @summary GET /account/cancel-on-disconnect
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getAccountCancelOnDisconnect(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getAccountCancelOnDisconnect(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check the Email Address for your account.
     * @summary GET /account/email-address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getAccountEmailAddress(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getAccountEmailAddress(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check the email preferences for your account.
     * @summary GET /account/email-preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getAccountEmailPreferences(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getAccountEmailPreferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if an account\'s email is verified.
     * @summary GET /account/email-verified
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getAccountEmailVerified(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getAccountEmailVerified(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the account\'s statistics of volume and pnl
     * @summary GET /account/stats
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {string} [asset] Name of underlying asset.
     * @param {string} [campaignName] The name of a campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getAccountStats(startTime?: number, endTime?: number, asset?: string, campaignName?: string, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getAccountStats(startTime, endTime, asset, campaignName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns account\'s trade history in CSV format
     * @summary GET /account/trades/csv
     * @param {Array<'trade' | 'liquidation' | 'settlement' | 'funding'>} tradeTypes Type of user trade.
     * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getAccountTradesCsv(tradeTypes: Array<'trade' | 'liquidation' | 'settlement' | 'funding'>, startTime: number, endTime?: number, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getAccountTradesCsv(tradeTypes, startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns account\'s transactions history in CSV format
     * @summary GET /account/transactions/csv
     * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getAccountTransactionsCsv(startTime: number, endTime?: number, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getAccountTransactionsCsv(startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Analytics for authenticated accounts
     * @summary INTERNAL GET /analytics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getAnalytics(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getAnalytics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the API key information.
     * @summary GET /api-key
     * @param {string} apiKey Account\&#39;s API Key.
     * @param {string} timestamp Timestamp in UNIX in nanoseconds.
     * @param {string} signature Hash of order payload signature signed by the account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getApiKey(apiKey: string, timestamp: string, signature: string, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getApiKey(apiKey, timestamp, signature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns true if the given headers has valid authentication
     * @summary GET /auth
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getAuth(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getAuth(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the account\'s balance history.
     * @summary INTERNAL GET /balance-history
     * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getBalanceHistory(startTime: number, endTime?: number, resolution?: number, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getBalanceHistory(startTime, endTime, resolution, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the account\'s block history.
     * @summary INTERNAL GET /block-history
     * @param {string} [blockId] Block ID is the unique identifier of the block
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {number} [offset] Offset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getBlockHistory(blockId?: string, startTime?: number, endTime?: number, sortOrder?: 'ASC' | 'DESC', limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getBlockHistory(blockId, startTime, endTime, sortOrder, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the account\'s block trade history.
     * @summary INTERNAL GET /block-trade-history
     * @param {string} [blockId] Block ID is the unique identifier of the block
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {number} [offset] Offset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getBlockTradeHistory(blockId?: string, startTime?: number, endTime?: number, sortOrder?: 'ASC' | 'DESC', limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getBlockTradeHistory(blockId, startTime, endTime, sortOrder, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns current farm boost, avg farm boost, and boosted volume
     * @summary GET /farm-boost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getFarmBoost(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getFarmBoost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns L1 withdrawal capacity for each collateral.
     * @summary INTERNAL GET /l1/capacity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getL1Capacity(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getL1Capacity(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the leaderboard for a campaign by pnl in descending order
     * @summary GET /leaderboard/campaign
     * @param {string} username Account\&#39;s auto-generated username based on their Ethereum address.
     * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} endTime Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getLeaderboardCampaign(username: string, startTime: number, endTime: number, limit?: number, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getLeaderboardCampaign(username, startTime, endTime, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the margin requirement.
     * @summary INTERNAL GET /margin
     * @param {number} instrumentId Instrument ID number.
     * @param {boolean} isBuy True for long order, false for short order.
     * @param {string} limitPrice Order limit price. In 6 decimals fixed number.
     * @param {string} amount Number of contracts. In 6 decimals fixed number.
     * @param {string} [orderId] Order ID is the hash of the order payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getMargin(instrumentId: number, isBuy: boolean, limitPrice: string, amount: string, orderId?: string, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getMargin(instrumentId, isBuy, limitPrice, amount, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get market maker protection (MMP) setting.
     * @summary GET /mmp
     * @param {string} asset Name of underlying asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getMmp(asset: string, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getMmp(asset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the account\'s notification history.
     * @summary INTERNAL GET /notifications
     * @param {boolean} [unread] Filter by unread only
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getNotifications(unread?: boolean, limit?: number, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getNotifications(unread, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns order history for the account.
     * @summary GET /order-history
     * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {number} [offset] Offset.
     * @param {string} [sort] Sort field
     * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getOrderHistory(startTime: number, endTime?: number, limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getOrderHistory(startTime, endTime, limit, offset, sort, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns stop order history for the account.
     * @summary GET /order-history/stops
     * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {number} [offset] Offset.
     * @param {string} [sort] Sort field
     * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getOrderHistoryStops(startTime: number, endTime?: number, limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getOrderHistoryStops(startTime, endTime, limit, offset, sort, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all account\'s orders.
     * @summary GET /orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getOrders(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getOrders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the order details.
     * @summary GET /orders/{order_id}
     * @param {string} orderId Order ID is the hash of the order payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getOrdersOrderId(orderId: string, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getOrdersOrderId(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the account\'s otc details
     * @summary GET /otc/account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getOtcAccount(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getOtcAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the overall portfolio details of the account.
     * @summary GET /portfolio
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getPortfolio(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getPortfolio(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the account\'s positions
     * @summary GET /positions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getPositions(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getPositions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns account\'s proof data
     * @summary GET /proof-data
     * @param {'airdrop' | 'rewards' | 'zero'} jsonName Json name of proof account wants to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getProofData(jsonName: 'airdrop' | 'rewards' | 'zero', options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getProofData(jsonName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns account\'s proof data
     * @summary GET /proofs-data
     * @param {Array<string>} assets Array of assets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getProofsData(assets: Array<string>, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getProofsData(assets, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the account\'s quote history.
     * @summary INTERNAL GET /quote-history
     * @param {string} [quoteId] Quote ID is the hash of the quote payload
     * @param {string} [blockId] Block ID is the unique identifier of the block
     * @param {'taker' | 'maker'} [role] Role of the account
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {number} [offset] Offset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getQuoteHistory(quoteId?: string, blockId?: string, role?: 'taker' | 'maker', startTime?: number, endTime?: number, sortOrder?: 'ASC' | 'DESC', limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getQuoteHistory(quoteId, blockId, role, startTime, endTime, sortOrder, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all account\'s quotes.
     * @summary GET /quotes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getQuotes(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getQuotes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the account\'s referral history.
     * @summary GET /referral-history
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {number} [offset] Offset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getReferralHistory(limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getReferralHistory(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the account\'s referral rewards history.
     * @summary GET /referral-rewards-history
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {number} [offset] Offset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getReferralRewardsHistory(limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getReferralRewardsHistory(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the account\'s referral statistics.
     * @summary GET /referral-statistics
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getReferralStatistics(startTime?: number, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getReferralStatistics(startTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get RFQ blocks open for trading.
     * @summary GET /rfqs
     * @param {'taker' | 'maker'} [role] Role of the account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getRfqs(role?: 'taker' | 'maker', options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getRfqs(role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the quotes for a given RFQ block.
     * @summary GET /rfqs/{block_id}/quotes
     * @param {string} blockId Block ID is the unique identifier of the block
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getRfqsBlockIdQuotes(blockId: string, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getRfqsBlockIdQuotes(blockId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns socket withdrawal capacity for each destination chain.
     * @summary INTERNAL GET /socket/capacity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getSocketCapacity(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getSocketCapacity(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns socket fee for the deposit or withdrawal.
     * @summary INTERNAL GET /socket/fees
     * @param {number} chainId The specified chain ID.
     * @param {string} socketConnector The socket connector address.
     * @param {string} socketAddress The socket address.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getSocketFees(chainId: number, socketConnector: string, socketAddress: string, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getSocketFees(chainId, socketConnector, socketAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the account\'s strategy positions
     * @summary GET /strategies/account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getStrategiesAccount(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getStrategiesAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the account\'s strategy equity history
     * @summary GET /strategies/account-history
     * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getStrategiesAccountHistory(startTime: number, endTime?: number, resolution?: number, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getStrategiesAccountHistory(startTime, endTime, resolution, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the account\'s trading fee statistics.
     * @summary GET /trade-fees-campaign-stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getTradeFeesCampaignStats(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getTradeFeesCampaignStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the account\'s trade history.
     * @summary GET /trade-history
     * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {string} [asset] Name of underlying asset.
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {Array<'trade' | 'liquidation' | 'settlement' | 'funding'>} [tradeTypes] Type of user trade.
     * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
     * @param {'put' | 'call'} [optionType] Type of option contract.
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {boolean} [agg] Aggregates trades if set to true.
     * @param {number} [offset] Offset.
     * @param {string} [sort] Sort field
     * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getTradeHistory(startTime: number, asset?: string, endTime?: number, tradeTypes?: Array<'trade' | 'liquidation' | 'settlement' | 'funding'>, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', optionType?: 'put' | 'call', limit?: number, agg?: boolean, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getTradeHistory(startTime, asset, endTime, tradeTypes, instrumentType, optionType, limit, agg, offset, sort, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the account\'s deposit and withdraw history.
     * @summary GET /transaction-history
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw'} [txType] Type of user transaction.
     * @param {'initiated' | 'finalized'} [txStatus] Transaction status.
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {number} [offset] Offset.
     * @param {string} [sort] Sort field
     * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getTransactionHistory(startTime?: number, endTime?: number, txType?: 'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw', txStatus?: 'initiated' | 'finalized', limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getTransactionHistory(startTime, endTime, txType, txStatus, limit, offset, sort, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the withdrawal fees for each chain and asset.
     * @summary INTERNAL GET /withdraw/fees
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public getWithdrawFees(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).getWithdrawFees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enables or disables the Cancel on Disconnect (CoD) setting for your account. When CoD is enabled, when a websocket connection is closed, all orders placed via that connection will be cancelled.
     * @summary POST /account/cancel-on-disconnect
     * @param {PostAccountCancelOnDisconnectPayload} [postAccountCancelOnDisconnectPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postAccountCancelOnDisconnect(postAccountCancelOnDisconnectPayload?: PostAccountCancelOnDisconnectPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postAccountCancelOnDisconnect(postAccountCancelOnDisconnectPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets up an email address for a user.
     * @summary POST /account/email-address
     * @param {PostAccountEmailAddressPayload} [postAccountEmailAddressPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postAccountEmailAddress(postAccountEmailAddressPayload?: PostAccountEmailAddressPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postAccountEmailAddress(postAccountEmailAddressPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets up email preference for a user.
     * @summary POST /account/email-preference
     * @param {PostAccountEmailPreferencePayload} [postAccountEmailPreferencePayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postAccountEmailPreference(postAccountEmailPreferencePayload?: PostAccountEmailPreferencePayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postAccountEmailPreference(postAccountEmailPreferencePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set the leverage of an instrument for your account.
     * @summary POST /account/leverage
     * @param {PostAccountLeveragePayload} [postAccountLeveragePayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postAccountLeverage(postAccountLeveragePayload?: PostAccountLeveragePayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postAccountLeverage(postAccountLeveragePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update margin for your account\'s positions.
     * @summary POST /account/margin-type
     * @param {PostAccountMarginTypePayload} [postAccountMarginTypePayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postAccountMarginType(postAccountMarginTypePayload?: PostAccountMarginTypePayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postAccountMarginType(postAccountMarginTypePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set a non-eth network\'s address to the account
     * @summary POST /account/network-address
     * @param {PostAccountNetworkAddressPayload} [postAccountNetworkAddressPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postAccountNetworkAddress(postAccountNetworkAddressPayload?: PostAccountNetworkAddressPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postAccountNetworkAddress(postAccountNetworkAddressPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enables or disables the portfolio margin on your acccount.
     * @summary POST /account/portfolio-margin
     * @param {PostAccountPortfolioMarginPayload} [postAccountPortfolioMarginPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postAccountPortfolioMargin(postAccountPortfolioMarginPayload?: PostAccountPortfolioMarginPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postAccountPortfolioMargin(postAccountPortfolioMarginPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update margin for your account\'s positions.
     * @summary POST /account/update-margin
     * @param {PostAccountUpdateMarginPayload} [postAccountUpdateMarginPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postAccountUpdateMargin(postAccountUpdateMarginPayload?: PostAccountUpdateMarginPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postAccountUpdateMargin(postAccountUpdateMarginPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new API key.
     * @summary POST /api-key
     * @param {PostApiKeyPayload} [postApiKeyPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postApiKey(postApiKeyPayload?: PostApiKeyPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postApiKey(postApiKeyPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign up for a campaign
     * @summary POST /campaign-sign-up
     * @param {PostCampaignSignUpPayload} [postCampaignSignUpPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postCampaignSignUp(postCampaignSignUpPayload?: PostCampaignSignUpPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postCampaignSignUp(postCampaignSignUpPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User claims referral rewards
     * @summary POST /claim-referral-rewards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postClaimReferralRewards(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postClaimReferralRewards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User claims trade fees rewards
     * @summary POST /claim-trade-fees
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postClaimTradeFees(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postClaimTradeFees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets random farm boost
     * @summary POST /farm-boost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postFarmBoost(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postFarmBoost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark the notifications for the account as read.
     * @summary INTERNAL POST /mark-as-read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postMarkAsRead(options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postMarkAsRead(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets market maker protection (MMP) settings.
     * @summary POST /mmp
     * @param {PostMmpPayload} [postMmpPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postMmp(postMmpPayload?: PostMmpPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postMmp(postMmpPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new order.
     * @summary POST /orders
     * @param {PostOrdersPayload} [postOrdersPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postOrders(postOrdersPayload?: PostOrdersPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postOrders(postOrdersPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edits an existing order.
     * @summary POST /orders/{order_id}
     * @param {string} orderId Order ID is the hash of the order payload
     * @param {PostOrdersOrderIdPayload} [postOrdersOrderIdPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postOrdersOrderId(orderId: string, postOrdersOrderIdPayload?: PostOrdersOrderIdPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postOrdersOrderId(orderId, postOrdersOrderIdPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new otc request
     * @summary POST /otc/create-request
     * @param {PostOtcCreateRequestPayload} [postOtcCreateRequestPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postOtcCreateRequest(postOtcCreateRequestPayload?: PostOtcCreateRequestPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postOtcCreateRequest(postOtcCreateRequestPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unwind an otc position
     * @summary POST /otc/unwind
     * @param {PostOtcUnwindPayload} [postOtcUnwindPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postOtcUnwind(postOtcUnwindPayload?: PostOtcUnwindPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postOtcUnwind(postOtcUnwindPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new quote.
     * @summary POST /quotes
     * @param {PostQuotesPayload} [postQuotesPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postQuotes(postQuotesPayload?: PostQuotesPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postQuotes(postQuotesPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Simulate a new quote.
     * @summary POST /quotes/preview
     * @param {PostQuotesPreviewPayload} [postQuotesPreviewPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postQuotesPreview(postQuotesPreviewPayload?: PostQuotesPreviewPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postQuotesPreview(postQuotesPreviewPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Registers a new account.
     * @summary POST /register
     * @param {PostRegisterPayload} [postRegisterPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postRegister(postRegisterPayload?: PostRegisterPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postRegister(postRegisterPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset market maker protection (MMP).
     * @summary POST /reset-mmp
     * @param {PostResetMmpPayload} [postResetMmpPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postResetMmp(postResetMmpPayload?: PostResetMmpPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postResetMmp(postResetMmpPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new RFQ block.
     * @summary POST /rfqs
     * @param {PostRfqsPayload} [postRfqsPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postRfqs(postRfqsPayload?: PostRfqsPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postRfqs(postRfqsPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate a USDC withdraw from strategy.
     * @summary POST /strategy/{strategy_address}/initiate-withdraw
     * @param {string} strategyAddress Address of strategy
     * @param {PostStrategyStrategyAddressInitiateWithdrawPayload} [postStrategyStrategyAddressInitiateWithdrawPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postStrategyStrategyAddressInitiateWithdraw(strategyAddress: string, postStrategyStrategyAddressInitiateWithdrawPayload?: PostStrategyStrategyAddressInitiateWithdrawPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postStrategyStrategyAddressInitiateWithdraw(strategyAddress, postStrategyStrategyAddressInitiateWithdrawPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swaps collateral.
     * @summary POST /swap
     * @param {PostSwapPayload} [postSwapPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postSwap(postSwapPayload?: PostSwapPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postSwap(postSwapPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transfer USDC between accounts.
     * @summary POST /transfer
     * @param {PostTransferPayload} [postTransferPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postTransfer(postTransferPayload?: PostTransferPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postTransfer(postTransferPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Withdraws USDC from the exchange to L1 Ethereum.
     * @summary POST /withdraw
     * @param {PostWithdrawPayload} [postWithdrawPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public postWithdraw(postWithdrawPayload?: PostWithdrawPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).postWithdraw(postWithdrawPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edits an existing quote.
     * @summary PUT /quotes/{quote_id}
     * @param {string} quoteId Quote ID is the hash of the quote payload
     * @param {PutQuotesQuoteIdPayload} [putQuotesQuoteIdPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateAPIApi
     */
    public putQuotesQuoteId(quoteId: string, putQuotesQuoteIdPayload?: PutQuotesQuoteIdPayload, options?: AxiosRequestConfig) {
        return PrivateAPIApiFp(this.configuration).putQuotesQuoteId(quoteId, putQuotesQuoteIdPayload, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PublicAPIApi - axios parameter creator
 * @export
 */
export const PublicAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of airdrop incentivized assets
         * @summary GET /airdrop-incentivized-assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAirdropIncentivizedAssets: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/airdrop-incentivized-assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the list of active underlying assets.
         * @summary GET /assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssets: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if user can be referred.
         * @summary GET /check-referral
         * @param {string} account Account\&#39;s Ethereum address.
         * @param {string} referralCode Referral Code (username of referrer) of the new account registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckReferral: async (account: string, referralCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'account' is not null or undefined
            assertParamExists('getCheckReferral', 'account', account)
            // verify required parameter 'referralCode' is not null or undefined
            assertParamExists('getCheckReferral', 'referralCode', referralCode)
            const localVarPath = `/check-referral`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (account !== undefined) {
                localVarQueryParameter['account'] = account;
            }

            if (referralCode !== undefined) {
                localVarQueryParameter['referral_code'] = referralCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the restriction status of the IP address calling the API.
         * @summary INTERNAL GET /check-restricted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckRestricted: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/check-restricted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the perpetual statistics of all assets specifically for https://www.coingecko.com/en/exchanges/aevo
         * @summary GET /coingecko-statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoingeckoStatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/coingecko-statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the farm + staking emissions
         * @summary GET /emissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/emissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the expiry timestamps of derivatives of the given asset.
         * @summary GET /expiries
         * @param {string} asset Name of underlying asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiries: async (asset: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asset' is not null or undefined
            assertParamExists('getExpiries', 'asset', asset)
            const localVarPath = `/expiries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current funding rate for the instrument.
         * @summary GET /funding
         * @param {string} instrumentName Instrument name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFunding: async (instrumentName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instrumentName' is not null or undefined
            assertParamExists('getFunding', 'instrumentName', instrumentName)
            const localVarPath = `/funding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (instrumentName !== undefined) {
                localVarQueryParameter['instrument_name'] = instrumentName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the funding rate history for the instrument.
         * @summary GET /funding-history
         * @param {string} [instrumentName] Instrument name.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFundingHistory: async (instrumentName?: string, startTime?: number, endTime?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/funding-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (instrumentName !== undefined) {
                localVarQueryParameter['instrument_name'] = instrumentName;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current index price of the given asset.
         * @summary GET /index
         * @param {string} asset Name of underlying asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndex: async (asset: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asset' is not null or undefined
            assertParamExists('getIndex', 'asset', asset)
            const localVarPath = `/index`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the historical index price for an array of assets.
         * @summary INTERNAL GET /index-histories
         * @param {Array<string>} assets Array of assets
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndexHistories: async (assets: Array<string>, resolution?: number, startTime?: number, endTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assets' is not null or undefined
            assertParamExists('getIndexHistories', 'assets', assets)
            const localVarPath = `/index-histories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (assets) {
                localVarQueryParameter['assets'] = assets;
            }

            if (resolution !== undefined) {
                localVarQueryParameter['resolution'] = resolution;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the historical index price for a given asset.
         * @summary GET /index-history
         * @param {string} asset Name of underlying asset.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndexHistory: async (asset: string, resolution?: number, startTime?: number, endTime?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asset' is not null or undefined
            assertParamExists('getIndexHistory', 'asset', asset)
            const localVarPath = `/index-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }

            if (resolution !== undefined) {
                localVarQueryParameter['resolution'] = resolution;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the instrument information for the given instrument.
         * @summary GET /instrument/{instrument_name}
         * @param {string} instrumentName Instrument name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstrumentInstrumentName: async (instrumentName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instrumentName' is not null or undefined
            assertParamExists('getInstrumentInstrumentName', 'instrumentName', instrumentName)
            const localVarPath = `/instrument/{instrument_name}`
                .replace(`{${"instrument_name"}}`, encodeURIComponent(String(instrumentName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the trade history for the given instrument.
         * @summary GET /instrument/{instrument_name}/trade-history
         * @param {string} instrumentName Instrument name.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstrumentInstrumentNameTradeHistory: async (instrumentName: string, startTime?: number, endTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instrumentName' is not null or undefined
            assertParamExists('getInstrumentInstrumentNameTradeHistory', 'instrumentName', instrumentName)
            const localVarPath = `/instrument/{instrument_name}/trade-history`
                .replace(`{${"instrument_name"}}`, encodeURIComponent(String(instrumentName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the leaderboard by pnl in descending order
         * @summary INTERNAL GET /leaderboard
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {string} [asset] Name of underlying asset.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {string} [sort] Sort field
         * @param {string} [campaignName] The name of a campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderboard: async (limit?: number, asset?: string, startTime?: number, endTime?: number, sort?: string, campaignName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/leaderboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (campaignName !== undefined) {
                localVarQueryParameter['campaign_name'] = campaignName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the historical mark prices for a given instrument.
         * @summary GET /mark-history
         * @param {string} instrumentName Instrument name.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkHistory: async (instrumentName: string, resolution?: number, limit?: number, startTime?: number, endTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instrumentName' is not null or undefined
            assertParamExists('getMarkHistory', 'instrumentName', instrumentName)
            const localVarPath = `/mark-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (instrumentName !== undefined) {
                localVarQueryParameter['instrument_name'] = instrumentName;
            }

            if (resolution !== undefined) {
                localVarQueryParameter['resolution'] = resolution;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of instruments. If `asset` is not specified, the response will include all listed instruments.
         * @summary GET /markets
         * @param {string} [asset] Name of underlying asset.
         * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkets: async (asset?: string, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/markets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }

            if (instrumentType !== undefined) {
                localVarQueryParameter['instrument_type'] = instrumentType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the market summary for the given asset. Used to populate the markets dropdown in the app
         * @summary INTERNAL GET /markets-summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketsSummary: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/markets-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the options chain for a given asset and expiry.
         * @summary INTERNAL GET /options-chain
         * @param {string} asset Name of underlying asset.
         * @param {string} expiry Option expiry in UNIX timestamp in nanoseconds.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptionsChain: async (asset: string, expiry: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asset' is not null or undefined
            assertParamExists('getOptionsChain', 'asset', asset)
            // verify required parameter 'expiry' is not null or undefined
            assertParamExists('getOptionsChain', 'expiry', expiry)
            const localVarPath = `/options-chain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }

            if (expiry !== undefined) {
                localVarQueryParameter['expiry'] = expiry;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the trade history for group of instrument.
         * @summary GET /options-history
         * @param {string} asset Name of underlying asset.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'put' | 'call'} [optionType] Type of option contract.
         * @param {number} [offset] Offset.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptionsHistory: async (asset: string, startTime?: number, endTime?: number, optionType?: 'put' | 'call', offset?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asset' is not null or undefined
            assertParamExists('getOptionsHistory', 'asset', asset)
            const localVarPath = `/options-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (optionType !== undefined) {
                localVarQueryParameter['option_type'] = optionType;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the orderbook for a given symbol.
         * @summary GET /orderbook
         * @param {string} instrumentName Instrument name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderbook: async (instrumentName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instrumentName' is not null or undefined
            assertParamExists('getOrderbook', 'instrumentName', instrumentName)
            const localVarPath = `/orderbook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (instrumentName !== undefined) {
                localVarQueryParameter['instrument_name'] = instrumentName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the historical settlement prices for a given asset.
         * @summary GET /settlement-history
         * @param {string} [asset] Name of underlying asset.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettlementHistory: async (asset?: string, startTime?: number, endTime?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/settlement-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the market statistics for the given asset.
         * @summary GET /statistics
         * @param {string} [asset] Name of underlying asset.
         * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistics: async (asset?: string, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', endTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }

            if (instrumentType !== undefined) {
                localVarQueryParameter['instrument_type'] = instrumentType;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the exchange status.
         * @summary INTERNAL GET /status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the map of strategies.
         * @summary GET /strategies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategies: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/strategies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the strategy\'s balance history.
         * @summary GET /strategy/{strategy_address}/balance-history
         * @param {string} strategyAddress Address of strategy
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategyStrategyAddressBalanceHistory: async (strategyAddress: string, startTime: number, endTime?: number, resolution?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'strategyAddress' is not null or undefined
            assertParamExists('getStrategyStrategyAddressBalanceHistory', 'strategyAddress', strategyAddress)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getStrategyStrategyAddressBalanceHistory', 'startTime', startTime)
            const localVarPath = `/strategy/{strategy_address}/balance-history`
                .replace(`{${"strategy_address"}}`, encodeURIComponent(String(strategyAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (resolution !== undefined) {
                localVarQueryParameter['resolution'] = resolution;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the strategy\'s pnl history.
         * @summary GET /strategy/{strategy_address}/pnl-history
         * @param {string} strategyAddress Address of strategy
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategyStrategyAddressPnlHistory: async (strategyAddress: string, startTime: number, endTime?: number, resolution?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'strategyAddress' is not null or undefined
            assertParamExists('getStrategyStrategyAddressPnlHistory', 'strategyAddress', strategyAddress)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getStrategyStrategyAddressPnlHistory', 'startTime', startTime)
            const localVarPath = `/strategy/{strategy_address}/pnl-history`
                .replace(`{${"strategy_address"}}`, encodeURIComponent(String(strategyAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (resolution !== undefined) {
                localVarQueryParameter['resolution'] = resolution;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the overall portfolio details of the strategy
         * @summary GET /strategy/{strategy_address}/portfolio
         * @param {string} strategyAddress Address of strategy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategyStrategyAddressPortfolio: async (strategyAddress: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'strategyAddress' is not null or undefined
            assertParamExists('getStrategyStrategyAddressPortfolio', 'strategyAddress', strategyAddress)
            const localVarPath = `/strategy/{strategy_address}/portfolio`
                .replace(`{${"strategy_address"}}`, encodeURIComponent(String(strategyAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the strategy positions
         * @summary GET /strategy/{strategy_address}/positions
         * @param {string} strategyAddress Address of strategy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategyStrategyAddressPositions: async (strategyAddress: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'strategyAddress' is not null or undefined
            assertParamExists('getStrategyStrategyAddressPositions', 'strategyAddress', strategyAddress)
            const localVarPath = `/strategy/{strategy_address}/positions`
                .replace(`{${"strategy_address"}}`, encodeURIComponent(String(strategyAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the account\'s trade history.
         * @summary GET /strategy/{strategy_address}/trade-history
         * @param {string} strategyAddress Address of strategy
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {string} [asset] Name of underlying asset.
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {Array<'trade' | 'liquidation' | 'settlement' | 'funding'>} [tradeTypes] Type of user trade.
         * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
         * @param {'put' | 'call'} [optionType] Type of option contract.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {boolean} [agg] Aggregates trades if set to true.
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategyStrategyAddressTradeHistory: async (strategyAddress: string, startTime: number, asset?: string, endTime?: number, tradeTypes?: Array<'trade' | 'liquidation' | 'settlement' | 'funding'>, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', optionType?: 'put' | 'call', limit?: number, agg?: boolean, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'strategyAddress' is not null or undefined
            assertParamExists('getStrategyStrategyAddressTradeHistory', 'strategyAddress', strategyAddress)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getStrategyStrategyAddressTradeHistory', 'startTime', startTime)
            const localVarPath = `/strategy/{strategy_address}/trade-history`
                .replace(`{${"strategy_address"}}`, encodeURIComponent(String(strategyAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (tradeTypes) {
                localVarQueryParameter['trade_types'] = tradeTypes;
            }

            if (instrumentType !== undefined) {
                localVarQueryParameter['instrument_type'] = instrumentType;
            }

            if (optionType !== undefined) {
                localVarQueryParameter['option_type'] = optionType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (agg !== undefined) {
                localVarQueryParameter['agg'] = agg;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the strategy\'s deposit and withdraw history.
         * @summary GET /strategy/{strategy_address}/transaction-history
         * @param {string} strategyAddress Address of strategy
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw'} [txType] Type of user transaction.
         * @param {'initiated' | 'finalized'} [txStatus] Transaction status.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategyStrategyAddressTransactionHistory: async (strategyAddress: string, startTime?: number, endTime?: number, txType?: 'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw', txStatus?: 'initiated' | 'finalized', limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'strategyAddress' is not null or undefined
            assertParamExists('getStrategyStrategyAddressTransactionHistory', 'strategyAddress', strategyAddress)
            const localVarPath = `/strategy/{strategy_address}/transaction-history`
                .replace(`{${"strategy_address"}}`, encodeURIComponent(String(strategyAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }

            if (txType !== undefined) {
                localVarQueryParameter['tx_type'] = txType;
            }

            if (txStatus !== undefined) {
                localVarQueryParameter['tx_status'] = txStatus;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the server time
         * @summary GET /time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTime: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the total weETH deposits.
         * @summary GET /weeth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeth: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/weeth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the yield vault information for the given yield vault.
         * @summary GET /yield-vault
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYieldVault: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/yield-vault`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify an account\'s email.
         * @summary POST /account/email-verified
         * @param {PostAccountEmailVerifiedPayload} [postAccountEmailVerifiedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountEmailVerified: async (postAccountEmailVerifiedPayload?: PostAccountEmailVerifiedPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/email-verified`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAccountEmailVerifiedPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unsubscribe from all email preferences
         * @summary POST /account/unsubscribe
         * @param {PostAccountUnsubscribePayload} [postAccountUnsubscribePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountUnsubscribe: async (postAccountUnsubscribePayload?: PostAccountUnsubscribePayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAccountUnsubscribePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Previews a collateral swap
         * @summary POST /swap/preview
         * @param {PostSwapPreviewPayload} [postSwapPreviewPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSwapPreview: async (postSwapPreviewPayload?: PostSwapPreviewPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/swap/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-KEY", configuration)

            // authentication api_secret required
            await setApiKeyToObject(localVarHeaderParameter, "AEVO-SECRET", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSwapPreviewPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicAPIApi - functional programming interface
 * @export
 */
export const PublicAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of airdrop incentivized assets
         * @summary GET /airdrop-incentivized-assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAirdropIncentivizedAssets(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAirdropIncentivizedAssets200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAirdropIncentivizedAssets(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the list of active underlying assets.
         * @summary GET /assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssets(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssets(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check if user can be referred.
         * @summary GET /check-referral
         * @param {string} account Account\&#39;s Ethereum address.
         * @param {string} referralCode Referral Code (username of referrer) of the new account registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCheckReferral(account: string, referralCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCheckReferral200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckReferral(account, referralCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the restriction status of the IP address calling the API.
         * @summary INTERNAL GET /check-restricted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCheckRestricted(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCheckRestricted200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckRestricted(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the perpetual statistics of all assets specifically for https://www.coingecko.com/en/exchanges/aevo
         * @summary GET /coingecko-statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCoingeckoStatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCoingeckoStatistics200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCoingeckoStatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the farm + staking emissions
         * @summary GET /emissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmissions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEmissions200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmissions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the expiry timestamps of derivatives of the given asset.
         * @summary GET /expiries
         * @param {string} asset Name of underlying asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExpiries(asset: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExpiries(asset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the current funding rate for the instrument.
         * @summary GET /funding
         * @param {string} instrumentName Instrument name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFunding(instrumentName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFunding200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFunding(instrumentName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the funding rate history for the instrument.
         * @summary GET /funding-history
         * @param {string} [instrumentName] Instrument name.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFundingHistory(instrumentName?: string, startTime?: number, endTime?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFundingHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFundingHistory(instrumentName, startTime, endTime, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the current index price of the given asset.
         * @summary GET /index
         * @param {string} asset Name of underlying asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndex(asset: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIndex200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndex(asset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the historical index price for an array of assets.
         * @summary INTERNAL GET /index-histories
         * @param {Array<string>} assets Array of assets
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndexHistories(assets: Array<string>, resolution?: number, startTime?: number, endTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIndexHistories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndexHistories(assets, resolution, startTime, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the historical index price for a given asset.
         * @summary GET /index-history
         * @param {string} asset Name of underlying asset.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndexHistory(asset: string, resolution?: number, startTime?: number, endTime?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIndexHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndexHistory(asset, resolution, startTime, endTime, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the instrument information for the given instrument.
         * @summary GET /instrument/{instrument_name}
         * @param {string} instrumentName Instrument name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstrumentInstrumentName(instrumentName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInstrumentInstrumentName200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstrumentInstrumentName(instrumentName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the trade history for the given instrument.
         * @summary GET /instrument/{instrument_name}/trade-history
         * @param {string} instrumentName Instrument name.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstrumentInstrumentNameTradeHistory(instrumentName: string, startTime?: number, endTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInstrumentInstrumentNameTradeHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstrumentInstrumentNameTradeHistory(instrumentName, startTime, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the leaderboard by pnl in descending order
         * @summary INTERNAL GET /leaderboard
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {string} [asset] Name of underlying asset.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {string} [sort] Sort field
         * @param {string} [campaignName] The name of a campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeaderboard(limit?: number, asset?: string, startTime?: number, endTime?: number, sort?: string, campaignName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLeaderboard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeaderboard(limit, asset, startTime, endTime, sort, campaignName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the historical mark prices for a given instrument.
         * @summary GET /mark-history
         * @param {string} instrumentName Instrument name.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarkHistory(instrumentName: string, resolution?: number, limit?: number, startTime?: number, endTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMarkHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarkHistory(instrumentName, resolution, limit, startTime, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of instruments. If `asset` is not specified, the response will include all listed instruments.
         * @summary GET /markets
         * @param {string} [asset] Name of underlying asset.
         * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarkets(asset?: string, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMarkets200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarkets(asset, instrumentType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the market summary for the given asset. Used to populate the markets dropdown in the app
         * @summary INTERNAL GET /markets-summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketsSummary(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMarketsSummary200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketsSummary(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the options chain for a given asset and expiry.
         * @summary INTERNAL GET /options-chain
         * @param {string} asset Name of underlying asset.
         * @param {string} expiry Option expiry in UNIX timestamp in nanoseconds.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOptionsChain(asset: string, expiry: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOptionsChain200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOptionsChain(asset, expiry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the trade history for group of instrument.
         * @summary GET /options-history
         * @param {string} asset Name of underlying asset.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'put' | 'call'} [optionType] Type of option contract.
         * @param {number} [offset] Offset.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOptionsHistory(asset: string, startTime?: number, endTime?: number, optionType?: 'put' | 'call', offset?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOptionsHistory200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOptionsHistory(asset, startTime, endTime, optionType, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the orderbook for a given symbol.
         * @summary GET /orderbook
         * @param {string} instrumentName Instrument name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderbook(instrumentName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderbook200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderbook(instrumentName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the historical settlement prices for a given asset.
         * @summary GET /settlement-history
         * @param {string} [asset] Name of underlying asset.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettlementHistory(asset?: string, startTime?: number, endTime?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSettlementHistory200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettlementHistory(asset, startTime, endTime, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the market statistics for the given asset.
         * @summary GET /statistics
         * @param {string} [asset] Name of underlying asset.
         * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatistics(asset?: string, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', endTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatistics200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatistics(asset, instrumentType, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the exchange status.
         * @summary INTERNAL GET /status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatus(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the map of strategies.
         * @summary GET /strategies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStrategies(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStrategies200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrategies(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the strategy\'s balance history.
         * @summary GET /strategy/{strategy_address}/balance-history
         * @param {string} strategyAddress Address of strategy
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStrategyStrategyAddressBalanceHistory(strategyAddress: string, startTime: number, endTime?: number, resolution?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStrategyStrategyAddressBalanceHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrategyStrategyAddressBalanceHistory(strategyAddress, startTime, endTime, resolution, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the strategy\'s pnl history.
         * @summary GET /strategy/{strategy_address}/pnl-history
         * @param {string} strategyAddress Address of strategy
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStrategyStrategyAddressPnlHistory(strategyAddress: string, startTime: number, endTime?: number, resolution?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStrategyStrategyAddressPnlHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrategyStrategyAddressPnlHistory(strategyAddress, startTime, endTime, resolution, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the overall portfolio details of the strategy
         * @summary GET /strategy/{strategy_address}/portfolio
         * @param {string} strategyAddress Address of strategy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStrategyStrategyAddressPortfolio(strategyAddress: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStrategyStrategyAddressPortfolio200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrategyStrategyAddressPortfolio(strategyAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the strategy positions
         * @summary GET /strategy/{strategy_address}/positions
         * @param {string} strategyAddress Address of strategy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStrategyStrategyAddressPositions(strategyAddress: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStrategyStrategyAddressPositions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrategyStrategyAddressPositions(strategyAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the account\'s trade history.
         * @summary GET /strategy/{strategy_address}/trade-history
         * @param {string} strategyAddress Address of strategy
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {string} [asset] Name of underlying asset.
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {Array<'trade' | 'liquidation' | 'settlement' | 'funding'>} [tradeTypes] Type of user trade.
         * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
         * @param {'put' | 'call'} [optionType] Type of option contract.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {boolean} [agg] Aggregates trades if set to true.
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStrategyStrategyAddressTradeHistory(strategyAddress: string, startTime: number, asset?: string, endTime?: number, tradeTypes?: Array<'trade' | 'liquidation' | 'settlement' | 'funding'>, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', optionType?: 'put' | 'call', limit?: number, agg?: boolean, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStrategyStrategyAddressTradeHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrategyStrategyAddressTradeHistory(strategyAddress, startTime, asset, endTime, tradeTypes, instrumentType, optionType, limit, agg, offset, sort, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the strategy\'s deposit and withdraw history.
         * @summary GET /strategy/{strategy_address}/transaction-history
         * @param {string} strategyAddress Address of strategy
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw'} [txType] Type of user transaction.
         * @param {'initiated' | 'finalized'} [txStatus] Transaction status.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStrategyStrategyAddressTransactionHistory(strategyAddress: string, startTime?: number, endTime?: number, txType?: 'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw', txStatus?: 'initiated' | 'finalized', limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStrategyStrategyAddressTransactionHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrategyStrategyAddressTransactionHistory(strategyAddress, startTime, endTime, txType, txStatus, limit, offset, sort, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the server time
         * @summary GET /time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTime(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTime200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTime(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the total weETH deposits.
         * @summary GET /weeth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeth(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWeeth200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeth(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the yield vault information for the given yield vault.
         * @summary GET /yield-vault
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getYieldVault(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetYieldVault200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getYieldVault(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verify an account\'s email.
         * @summary POST /account/email-verified
         * @param {PostAccountEmailVerifiedPayload} [postAccountEmailVerifiedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAccountEmailVerified(postAccountEmailVerifiedPayload?: PostAccountEmailVerifiedPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAccountEmailVerified200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAccountEmailVerified(postAccountEmailVerifiedPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unsubscribe from all email preferences
         * @summary POST /account/unsubscribe
         * @param {PostAccountUnsubscribePayload} [postAccountUnsubscribePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAccountUnsubscribe(postAccountUnsubscribePayload?: PostAccountUnsubscribePayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAccountUnsubscribe200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAccountUnsubscribe(postAccountUnsubscribePayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Previews a collateral swap
         * @summary POST /swap/preview
         * @param {PostSwapPreviewPayload} [postSwapPreviewPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSwapPreview(postSwapPreviewPayload?: PostSwapPreviewPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostSwapPreview200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSwapPreview(postSwapPreviewPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicAPIApi - factory interface
 * @export
 */
export const PublicAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicAPIApiFp(configuration)
    return {
        /**
         * Returns a list of airdrop incentivized assets
         * @summary GET /airdrop-incentivized-assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAirdropIncentivizedAssets(options?: any): AxiosPromise<GetAirdropIncentivizedAssets200Response> {
            return localVarFp.getAirdropIncentivizedAssets(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the list of active underlying assets.
         * @summary GET /assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssets(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAssets(options).then((request) => request(axios, basePath));
        },
        /**
         * Check if user can be referred.
         * @summary GET /check-referral
         * @param {string} account Account\&#39;s Ethereum address.
         * @param {string} referralCode Referral Code (username of referrer) of the new account registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckReferral(account: string, referralCode: string, options?: any): AxiosPromise<GetCheckReferral200Response> {
            return localVarFp.getCheckReferral(account, referralCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the restriction status of the IP address calling the API.
         * @summary INTERNAL GET /check-restricted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckRestricted(options?: any): AxiosPromise<GetCheckRestricted200Response> {
            return localVarFp.getCheckRestricted(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the perpetual statistics of all assets specifically for https://www.coingecko.com/en/exchanges/aevo
         * @summary GET /coingecko-statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoingeckoStatistics(options?: any): AxiosPromise<Array<GetCoingeckoStatistics200Response>> {
            return localVarFp.getCoingeckoStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the farm + staking emissions
         * @summary GET /emissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissions(options?: any): AxiosPromise<Array<GetEmissions200Response>> {
            return localVarFp.getEmissions(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the expiry timestamps of derivatives of the given asset.
         * @summary GET /expiries
         * @param {string} asset Name of underlying asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiries(asset: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getExpiries(asset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current funding rate for the instrument.
         * @summary GET /funding
         * @param {string} instrumentName Instrument name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFunding(instrumentName: string, options?: any): AxiosPromise<GetFunding200Response> {
            return localVarFp.getFunding(instrumentName, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the funding rate history for the instrument.
         * @summary GET /funding-history
         * @param {string} [instrumentName] Instrument name.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFundingHistory(instrumentName?: string, startTime?: number, endTime?: number, limit?: number, options?: any): AxiosPromise<GetFundingHistory200Response> {
            return localVarFp.getFundingHistory(instrumentName, startTime, endTime, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current index price of the given asset.
         * @summary GET /index
         * @param {string} asset Name of underlying asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndex(asset: string, options?: any): AxiosPromise<GetIndex200Response> {
            return localVarFp.getIndex(asset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the historical index price for an array of assets.
         * @summary INTERNAL GET /index-histories
         * @param {Array<string>} assets Array of assets
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndexHistories(assets: Array<string>, resolution?: number, startTime?: number, endTime?: number, options?: any): AxiosPromise<GetIndexHistories200Response> {
            return localVarFp.getIndexHistories(assets, resolution, startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the historical index price for a given asset.
         * @summary GET /index-history
         * @param {string} asset Name of underlying asset.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndexHistory(asset: string, resolution?: number, startTime?: number, endTime?: number, limit?: number, options?: any): AxiosPromise<GetIndexHistory200Response> {
            return localVarFp.getIndexHistory(asset, resolution, startTime, endTime, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the instrument information for the given instrument.
         * @summary GET /instrument/{instrument_name}
         * @param {string} instrumentName Instrument name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstrumentInstrumentName(instrumentName: string, options?: any): AxiosPromise<GetInstrumentInstrumentName200Response> {
            return localVarFp.getInstrumentInstrumentName(instrumentName, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the trade history for the given instrument.
         * @summary GET /instrument/{instrument_name}/trade-history
         * @param {string} instrumentName Instrument name.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstrumentInstrumentNameTradeHistory(instrumentName: string, startTime?: number, endTime?: number, options?: any): AxiosPromise<GetInstrumentInstrumentNameTradeHistory200Response> {
            return localVarFp.getInstrumentInstrumentNameTradeHistory(instrumentName, startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the leaderboard by pnl in descending order
         * @summary INTERNAL GET /leaderboard
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {string} [asset] Name of underlying asset.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {string} [sort] Sort field
         * @param {string} [campaignName] The name of a campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderboard(limit?: number, asset?: string, startTime?: number, endTime?: number, sort?: string, campaignName?: string, options?: any): AxiosPromise<GetLeaderboard200Response> {
            return localVarFp.getLeaderboard(limit, asset, startTime, endTime, sort, campaignName, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the historical mark prices for a given instrument.
         * @summary GET /mark-history
         * @param {string} instrumentName Instrument name.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkHistory(instrumentName: string, resolution?: number, limit?: number, startTime?: number, endTime?: number, options?: any): AxiosPromise<GetMarkHistory200Response> {
            return localVarFp.getMarkHistory(instrumentName, resolution, limit, startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of instruments. If `asset` is not specified, the response will include all listed instruments.
         * @summary GET /markets
         * @param {string} [asset] Name of underlying asset.
         * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkets(asset?: string, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', options?: any): AxiosPromise<Array<GetMarkets200Response>> {
            return localVarFp.getMarkets(asset, instrumentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the market summary for the given asset. Used to populate the markets dropdown in the app
         * @summary INTERNAL GET /markets-summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketsSummary(options?: any): AxiosPromise<GetMarketsSummary200Response> {
            return localVarFp.getMarketsSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the options chain for a given asset and expiry.
         * @summary INTERNAL GET /options-chain
         * @param {string} asset Name of underlying asset.
         * @param {string} expiry Option expiry in UNIX timestamp in nanoseconds.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptionsChain(asset: string, expiry: string, options?: any): AxiosPromise<GetOptionsChain200Response> {
            return localVarFp.getOptionsChain(asset, expiry, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the trade history for group of instrument.
         * @summary GET /options-history
         * @param {string} asset Name of underlying asset.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'put' | 'call'} [optionType] Type of option contract.
         * @param {number} [offset] Offset.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptionsHistory(asset: string, startTime?: number, endTime?: number, optionType?: 'put' | 'call', offset?: number, limit?: number, options?: any): AxiosPromise<Array<GetOptionsHistory200Response>> {
            return localVarFp.getOptionsHistory(asset, startTime, endTime, optionType, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the orderbook for a given symbol.
         * @summary GET /orderbook
         * @param {string} instrumentName Instrument name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderbook(instrumentName: string, options?: any): AxiosPromise<GetOrderbook200Response> {
            return localVarFp.getOrderbook(instrumentName, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the historical settlement prices for a given asset.
         * @summary GET /settlement-history
         * @param {string} [asset] Name of underlying asset.
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettlementHistory(asset?: string, startTime?: number, endTime?: number, limit?: number, options?: any): AxiosPromise<Array<GetSettlementHistory200Response>> {
            return localVarFp.getSettlementHistory(asset, startTime, endTime, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the market statistics for the given asset.
         * @summary GET /statistics
         * @param {string} [asset] Name of underlying asset.
         * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistics(asset?: string, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', endTime?: number, options?: any): AxiosPromise<GetStatistics200Response> {
            return localVarFp.getStatistics(asset, instrumentType, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the exchange status.
         * @summary INTERNAL GET /status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus(options?: any): AxiosPromise<GetStatus200Response> {
            return localVarFp.getStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the map of strategies.
         * @summary GET /strategies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategies(options?: any): AxiosPromise<GetStrategies200Response> {
            return localVarFp.getStrategies(options).then((request) => request(axios, basePath));
        },
        /**
         * Return the strategy\'s balance history.
         * @summary GET /strategy/{strategy_address}/balance-history
         * @param {string} strategyAddress Address of strategy
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategyStrategyAddressBalanceHistory(strategyAddress: string, startTime: number, endTime?: number, resolution?: number, options?: any): AxiosPromise<GetStrategyStrategyAddressBalanceHistory200Response> {
            return localVarFp.getStrategyStrategyAddressBalanceHistory(strategyAddress, startTime, endTime, resolution, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the strategy\'s pnl history.
         * @summary GET /strategy/{strategy_address}/pnl-history
         * @param {string} strategyAddress Address of strategy
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategyStrategyAddressPnlHistory(strategyAddress: string, startTime: number, endTime?: number, resolution?: number, options?: any): AxiosPromise<GetStrategyStrategyAddressPnlHistory200Response> {
            return localVarFp.getStrategyStrategyAddressPnlHistory(strategyAddress, startTime, endTime, resolution, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the overall portfolio details of the strategy
         * @summary GET /strategy/{strategy_address}/portfolio
         * @param {string} strategyAddress Address of strategy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategyStrategyAddressPortfolio(strategyAddress: string, options?: any): AxiosPromise<GetStrategyStrategyAddressPortfolio200Response> {
            return localVarFp.getStrategyStrategyAddressPortfolio(strategyAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the strategy positions
         * @summary GET /strategy/{strategy_address}/positions
         * @param {string} strategyAddress Address of strategy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategyStrategyAddressPositions(strategyAddress: string, options?: any): AxiosPromise<GetStrategyStrategyAddressPositions200Response> {
            return localVarFp.getStrategyStrategyAddressPositions(strategyAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the account\'s trade history.
         * @summary GET /strategy/{strategy_address}/trade-history
         * @param {string} strategyAddress Address of strategy
         * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {string} [asset] Name of underlying asset.
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {Array<'trade' | 'liquidation' | 'settlement' | 'funding'>} [tradeTypes] Type of user trade.
         * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
         * @param {'put' | 'call'} [optionType] Type of option contract.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {boolean} [agg] Aggregates trades if set to true.
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategyStrategyAddressTradeHistory(strategyAddress: string, startTime: number, asset?: string, endTime?: number, tradeTypes?: Array<'trade' | 'liquidation' | 'settlement' | 'funding'>, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', optionType?: 'put' | 'call', limit?: number, agg?: boolean, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: any): AxiosPromise<GetStrategyStrategyAddressTradeHistory200Response> {
            return localVarFp.getStrategyStrategyAddressTradeHistory(strategyAddress, startTime, asset, endTime, tradeTypes, instrumentType, optionType, limit, agg, offset, sort, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the strategy\'s deposit and withdraw history.
         * @summary GET /strategy/{strategy_address}/transaction-history
         * @param {string} strategyAddress Address of strategy
         * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
         * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
         * @param {'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw'} [txType] Type of user transaction.
         * @param {'initiated' | 'finalized'} [txStatus] Transaction status.
         * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
         * @param {number} [offset] Offset.
         * @param {string} [sort] Sort field
         * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrategyStrategyAddressTransactionHistory(strategyAddress: string, startTime?: number, endTime?: number, txType?: 'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw', txStatus?: 'initiated' | 'finalized', limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: any): AxiosPromise<GetStrategyStrategyAddressTransactionHistory200Response> {
            return localVarFp.getStrategyStrategyAddressTransactionHistory(strategyAddress, startTime, endTime, txType, txStatus, limit, offset, sort, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the server time
         * @summary GET /time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTime(options?: any): AxiosPromise<GetTime200Response> {
            return localVarFp.getTime(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the total weETH deposits.
         * @summary GET /weeth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeth(options?: any): AxiosPromise<GetWeeth200Response> {
            return localVarFp.getWeeth(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the yield vault information for the given yield vault.
         * @summary GET /yield-vault
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYieldVault(options?: any): AxiosPromise<GetYieldVault200Response> {
            return localVarFp.getYieldVault(options).then((request) => request(axios, basePath));
        },
        /**
         * Verify an account\'s email.
         * @summary POST /account/email-verified
         * @param {PostAccountEmailVerifiedPayload} [postAccountEmailVerifiedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountEmailVerified(postAccountEmailVerifiedPayload?: PostAccountEmailVerifiedPayload, options?: any): AxiosPromise<PostAccountEmailVerified200Response> {
            return localVarFp.postAccountEmailVerified(postAccountEmailVerifiedPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Unsubscribe from all email preferences
         * @summary POST /account/unsubscribe
         * @param {PostAccountUnsubscribePayload} [postAccountUnsubscribePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAccountUnsubscribe(postAccountUnsubscribePayload?: PostAccountUnsubscribePayload, options?: any): AxiosPromise<PostAccountUnsubscribe200Response> {
            return localVarFp.postAccountUnsubscribe(postAccountUnsubscribePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Previews a collateral swap
         * @summary POST /swap/preview
         * @param {PostSwapPreviewPayload} [postSwapPreviewPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSwapPreview(postSwapPreviewPayload?: PostSwapPreviewPayload, options?: any): AxiosPromise<PostSwapPreview200Response> {
            return localVarFp.postSwapPreview(postSwapPreviewPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicAPIApi - object-oriented interface
 * @export
 * @class PublicAPIApi
 * @extends {BaseAPI}
 */
export class PublicAPIApi extends BaseAPI {
    /**
     * Returns a list of airdrop incentivized assets
     * @summary GET /airdrop-incentivized-assets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getAirdropIncentivizedAssets(options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getAirdropIncentivizedAssets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the list of active underlying assets.
     * @summary GET /assets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getAssets(options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getAssets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if user can be referred.
     * @summary GET /check-referral
     * @param {string} account Account\&#39;s Ethereum address.
     * @param {string} referralCode Referral Code (username of referrer) of the new account registration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getCheckReferral(account: string, referralCode: string, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getCheckReferral(account, referralCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the restriction status of the IP address calling the API.
     * @summary INTERNAL GET /check-restricted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getCheckRestricted(options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getCheckRestricted(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the perpetual statistics of all assets specifically for https://www.coingecko.com/en/exchanges/aevo
     * @summary GET /coingecko-statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getCoingeckoStatistics(options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getCoingeckoStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the farm + staking emissions
     * @summary GET /emissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getEmissions(options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getEmissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the expiry timestamps of derivatives of the given asset.
     * @summary GET /expiries
     * @param {string} asset Name of underlying asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getExpiries(asset: string, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getExpiries(asset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current funding rate for the instrument.
     * @summary GET /funding
     * @param {string} instrumentName Instrument name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getFunding(instrumentName: string, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getFunding(instrumentName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the funding rate history for the instrument.
     * @summary GET /funding-history
     * @param {string} [instrumentName] Instrument name.
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getFundingHistory(instrumentName?: string, startTime?: number, endTime?: number, limit?: number, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getFundingHistory(instrumentName, startTime, endTime, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current index price of the given asset.
     * @summary GET /index
     * @param {string} asset Name of underlying asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getIndex(asset: string, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getIndex(asset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the historical index price for an array of assets.
     * @summary INTERNAL GET /index-histories
     * @param {Array<string>} assets Array of assets
     * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getIndexHistories(assets: Array<string>, resolution?: number, startTime?: number, endTime?: number, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getIndexHistories(assets, resolution, startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the historical index price for a given asset.
     * @summary GET /index-history
     * @param {string} asset Name of underlying asset.
     * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getIndexHistory(asset: string, resolution?: number, startTime?: number, endTime?: number, limit?: number, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getIndexHistory(asset, resolution, startTime, endTime, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the instrument information for the given instrument.
     * @summary GET /instrument/{instrument_name}
     * @param {string} instrumentName Instrument name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getInstrumentInstrumentName(instrumentName: string, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getInstrumentInstrumentName(instrumentName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the trade history for the given instrument.
     * @summary GET /instrument/{instrument_name}/trade-history
     * @param {string} instrumentName Instrument name.
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getInstrumentInstrumentNameTradeHistory(instrumentName: string, startTime?: number, endTime?: number, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getInstrumentInstrumentNameTradeHistory(instrumentName, startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the leaderboard by pnl in descending order
     * @summary INTERNAL GET /leaderboard
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {string} [asset] Name of underlying asset.
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {string} [sort] Sort field
     * @param {string} [campaignName] The name of a campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getLeaderboard(limit?: number, asset?: string, startTime?: number, endTime?: number, sort?: string, campaignName?: string, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getLeaderboard(limit, asset, startTime, endTime, sort, campaignName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the historical mark prices for a given instrument.
     * @summary GET /mark-history
     * @param {string} instrumentName Instrument name.
     * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getMarkHistory(instrumentName: string, resolution?: number, limit?: number, startTime?: number, endTime?: number, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getMarkHistory(instrumentName, resolution, limit, startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of instruments. If `asset` is not specified, the response will include all listed instruments.
     * @summary GET /markets
     * @param {string} [asset] Name of underlying asset.
     * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getMarkets(asset?: string, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getMarkets(asset, instrumentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the market summary for the given asset. Used to populate the markets dropdown in the app
     * @summary INTERNAL GET /markets-summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getMarketsSummary(options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getMarketsSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the options chain for a given asset and expiry.
     * @summary INTERNAL GET /options-chain
     * @param {string} asset Name of underlying asset.
     * @param {string} expiry Option expiry in UNIX timestamp in nanoseconds.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getOptionsChain(asset: string, expiry: string, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getOptionsChain(asset, expiry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the trade history for group of instrument.
     * @summary GET /options-history
     * @param {string} asset Name of underlying asset.
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {'put' | 'call'} [optionType] Type of option contract.
     * @param {number} [offset] Offset.
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getOptionsHistory(asset: string, startTime?: number, endTime?: number, optionType?: 'put' | 'call', offset?: number, limit?: number, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getOptionsHistory(asset, startTime, endTime, optionType, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the orderbook for a given symbol.
     * @summary GET /orderbook
     * @param {string} instrumentName Instrument name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getOrderbook(instrumentName: string, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getOrderbook(instrumentName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the historical settlement prices for a given asset.
     * @summary GET /settlement-history
     * @param {string} [asset] Name of underlying asset.
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getSettlementHistory(asset?: string, startTime?: number, endTime?: number, limit?: number, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getSettlementHistory(asset, startTime, endTime, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the market statistics for the given asset.
     * @summary GET /statistics
     * @param {string} [asset] Name of underlying asset.
     * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getStatistics(asset?: string, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', endTime?: number, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getStatistics(asset, instrumentType, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the exchange status.
     * @summary INTERNAL GET /status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getStatus(options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the map of strategies.
     * @summary GET /strategies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getStrategies(options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getStrategies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the strategy\'s balance history.
     * @summary GET /strategy/{strategy_address}/balance-history
     * @param {string} strategyAddress Address of strategy
     * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getStrategyStrategyAddressBalanceHistory(strategyAddress: string, startTime: number, endTime?: number, resolution?: number, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getStrategyStrategyAddressBalanceHistory(strategyAddress, startTime, endTime, resolution, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the strategy\'s pnl history.
     * @summary GET /strategy/{strategy_address}/pnl-history
     * @param {string} strategyAddress Address of strategy
     * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {number} [resolution] Interval between entries in seconds. Must be a multiple of 30. Defaults to &#x60;30&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getStrategyStrategyAddressPnlHistory(strategyAddress: string, startTime: number, endTime?: number, resolution?: number, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getStrategyStrategyAddressPnlHistory(strategyAddress, startTime, endTime, resolution, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the overall portfolio details of the strategy
     * @summary GET /strategy/{strategy_address}/portfolio
     * @param {string} strategyAddress Address of strategy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getStrategyStrategyAddressPortfolio(strategyAddress: string, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getStrategyStrategyAddressPortfolio(strategyAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the strategy positions
     * @summary GET /strategy/{strategy_address}/positions
     * @param {string} strategyAddress Address of strategy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getStrategyStrategyAddressPositions(strategyAddress: string, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getStrategyStrategyAddressPositions(strategyAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the account\'s trade history.
     * @summary GET /strategy/{strategy_address}/trade-history
     * @param {string} strategyAddress Address of strategy
     * @param {number} startTime Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {string} [asset] Name of underlying asset.
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {Array<'trade' | 'liquidation' | 'settlement' | 'funding'>} [tradeTypes] Type of user trade.
     * @param {'OPTION' | 'PERPETUAL' | 'SPOT'} [instrumentType] Type of instrument.
     * @param {'put' | 'call'} [optionType] Type of option contract.
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {boolean} [agg] Aggregates trades if set to true.
     * @param {number} [offset] Offset.
     * @param {string} [sort] Sort field
     * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getStrategyStrategyAddressTradeHistory(strategyAddress: string, startTime: number, asset?: string, endTime?: number, tradeTypes?: Array<'trade' | 'liquidation' | 'settlement' | 'funding'>, instrumentType?: 'OPTION' | 'PERPETUAL' | 'SPOT', optionType?: 'put' | 'call', limit?: number, agg?: boolean, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getStrategyStrategyAddressTradeHistory(strategyAddress, startTime, asset, endTime, tradeTypes, instrumentType, optionType, limit, agg, offset, sort, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the strategy\'s deposit and withdraw history.
     * @summary GET /strategy/{strategy_address}/transaction-history
     * @param {string} strategyAddress Address of strategy
     * @param {number} [startTime] Entries created prior (&lt;) to start time are excluded in UNIX timestamp in nanoseconds. Defaults to &#x60;0&#x60;
     * @param {number} [endTime] Entries created after (&gt;) end time are excluded in UNIX timestamp in nanoseconds. Defaults to current time.
     * @param {'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw'} [txType] Type of user transaction.
     * @param {'initiated' | 'finalized'} [txStatus] Transaction status.
     * @param {number} [limit] Limits the number of relevant entries in the response. Defaults to &#x60;10&#x60;. Maximum value is &#x60;50&#x60;
     * @param {number} [offset] Offset.
     * @param {string} [sort] Sort field
     * @param {'ASC' | 'DESC'} [sortOrder] Either ASC or DESC. Default is DESC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getStrategyStrategyAddressTransactionHistory(strategyAddress: string, startTime?: number, endTime?: number, txType?: 'deposit' | 'withdraw' | 'send' | 'receive' | 'swap' | 'yv_deposit' | 'yv_withdraw', txStatus?: 'initiated' | 'finalized', limit?: number, offset?: number, sort?: string, sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getStrategyStrategyAddressTransactionHistory(strategyAddress, startTime, endTime, txType, txStatus, limit, offset, sort, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the server time
     * @summary GET /time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getTime(options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getTime(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the total weETH deposits.
     * @summary GET /weeth
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getWeeth(options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getWeeth(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the yield vault information for the given yield vault.
     * @summary GET /yield-vault
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public getYieldVault(options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).getYieldVault(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify an account\'s email.
     * @summary POST /account/email-verified
     * @param {PostAccountEmailVerifiedPayload} [postAccountEmailVerifiedPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public postAccountEmailVerified(postAccountEmailVerifiedPayload?: PostAccountEmailVerifiedPayload, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).postAccountEmailVerified(postAccountEmailVerifiedPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unsubscribe from all email preferences
     * @summary POST /account/unsubscribe
     * @param {PostAccountUnsubscribePayload} [postAccountUnsubscribePayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public postAccountUnsubscribe(postAccountUnsubscribePayload?: PostAccountUnsubscribePayload, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).postAccountUnsubscribe(postAccountUnsubscribePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Previews a collateral swap
     * @summary POST /swap/preview
     * @param {PostSwapPreviewPayload} [postSwapPreviewPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicAPIApi
     */
    public postSwapPreview(postSwapPreviewPayload?: PostSwapPreviewPayload, options?: AxiosRequestConfig) {
        return PublicAPIApiFp(this.configuration).postSwapPreview(postSwapPreviewPayload, options).then((request) => request(this.axios, this.basePath));
    }
}


